
let custom_money_format = document.querySelector('.custom_money_format')?.dataset.value;
var Shopify = Shopify || {}; Shopify.money_format = custom_money_format; Shopify.formatMoney = function(cents, format) { if (typeof cents == 'string') { cents = cents.replace('.',''); } var value = ''; var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/; var formatString = (format || this.money_format); function defaultOption(opt, def) { return (typeof opt == 'undefined' ? def : opt); } function formatWithDelimiters(number, precision, thousands, decimal) { precision = defaultOption(precision, 2); thousands = defaultOption(thousands, ','); decimal   = defaultOption(decimal, '.'); if (isNaN(number) || number == null) { return 0; } number = (number/100.0).toFixed(precision); var parts   = number.split('.'), dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands), cents   = parts[1] ? (decimal + parts[1]) : ''; return dollars + cents; } switch(formatString.match(placeholderRegex)[1]) { case 'amount': value = formatWithDelimiters(cents, 2); break; case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break; case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break; case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break; /* 2026-09-26 cartfix (currency): SEK uses amount_with_space_separator and got ' kr' with no number. Delete these four cases and the default to roll back. */ case 'amount_with_space_separator': value = formatWithDelimiters(cents, 2, ' ', ','); break; case 'amount_no_decimals_with_space_separator': value = formatWithDelimiters(cents, 0, ' ', ','); break; case 'amount_with_period_and_space_separator': value = formatWithDelimiters(cents, 2, ' ', '.'); break; case 'amount_with_apostrophe_separator': value = formatWithDelimiters(cents, 2, "'", '.'); break; default: value = formatWithDelimiters(cents, 2); break; } return formatString.replace(placeholderRegex, value); };
function toggleOrderDiscountVisibility() {
  const savingEl = document.querySelector(".block-saving__amount");
  const savingsRow = document.querySelector(".cart-item__savings");

  if (!savingEl || !savingsRow) return;

  // Attribute preference (cus-discount) otherwise text
  let value = savingEl.getAttribute("cus-discount") || savingEl.textContent;

  // Remove currency symbols & spaces → keep only number
  let numericValue = parseFloat(
    value.replace(/[^0-9.-]+/g, "")
  );

  if (!numericValue || numericValue === 0) {
    savingsRow.classList.add("hidden");
  } else {
    savingsRow.classList.remove("hidden");
  }
}

/*
 * 2026-08-16 (Claude) - THE COMPARE-AT SUBTOTAL COULD NEVER BE RIGHT, and this is the reason.
 * updateCompareTotal() below used to read `item.compare_at_price` off /cart.js. THAT FIELD DOES NOT
 * EXIST on a Cart AJAX API line item (checked against Shopify's line-item property list; it is a
 * Liquid `variant` property, not a cart one). It was therefore always undefined, the ternary always
 * took the `item.original_price * quantity` branch, and `.total_com_price` - the slot the theme
 * renders the PRE-DISCOUNT subtotal into - was written with the amount actually being paid. On a cart
 * with a compare-at sale the shopper saw no strike and no saving anywhere in the totals block.
 *
 * DO NOT "FIX" THIS BY FETCHING /variants/{id}.js PER LINE. That is what updateCartPageOrderDiscount
 * does and it costs one request per cart line, which trips Shopify's throttle by itself on a big kit
 * cart (there is already a 429 guard around it for exactly that).
 *
 * The compare total is computed by Liquid, which HAS the variant, and shipped down on every drawer
 * rebuild as `data-compare-total` on .cart__items. This helper reads it, but only when that markup
 * describes the SAME cart state we just fetched - `data-cart-subtotal` is cart.total_price at render
 * time, so a mismatch means the markup is one cart change behind and its compare total would be stale.
 * Returns null when it cannot be trusted, and every caller falls back to its own figure.
 */
function aoamDomCompareTotal(cartTotalPrice) {
  try {
    var el = document.querySelector('.cart__items[data-compare-total]');
    if (!el) return null;
    var cmp = parseInt(el.getAttribute('data-compare-total'), 10);
    var snap = parseInt(el.getAttribute('data-cart-subtotal'), 10);
    if (!isFinite(cmp) || !isFinite(snap)) return null;
    if (typeof cartTotalPrice === 'number' && snap !== cartTotalPrice) return null;
    return cmp;
  } catch (e) { return null; }
}

async function updateCompareTotal() {
  try {
    const response = await fetch("/cart.js");
    const cart = await response.json();
    let cart_count = 0;
    let totalComparePrice = 0;
    cart.items.forEach((item) => {
      if (item.properties && !item.properties['_protection_product']) {
        cart_count+=item.quantity;
        // original_price is the pre-line-discount UNIT price; it is the honest floor when no
        // compare-at is available, and it is what the DOM figure below replaces when it can.
        totalComparePrice += item.original_price * item.quantity;
      }
    });
    const domCompare = aoamDomCompareTotal(cart.total_price);
    // Never show LESS than the paid subtotal: a compare total below it would render a "saving" that
    // is negative. If the markup ever disagrees that way, keep the computed floor.
    if (domCompare !== null && domCompare > totalComparePrice) totalComparePrice = domCompare;
    const formattedTotal = formatMoneyNoTrailing(totalComparePrice);
    document.querySelectorAll(".total_com_price").forEach((el) => {
      el.textContent = formattedTotal;
    });

    /* 2026-08-16 (Claude) - THE WRITE-BACK ONTO [data-compare-total] IS GONE, and it was the worst
       bug in the cart. This used to do an UNSCOPED querySelector("[data-compare-total]") - which finds
       the drawer's own .cart__items - and stamp its locally computed figure onto it, WITHOUT touching
       the data-cart-subtotal fingerprint that tells other code whether that markup is current.
       Since this function's figure is the PAID subtotal (see the note at the top of the file: there is
       no compare_at_price on a /cart.js line item), it overwrote Liquid's pre-discount total with the
       paid one and left the fingerprint saying "still fresh". Step a line 1->2, let the +1000ms pass
       run, step back 2->1: the fingerprint matches again, aoamCompareSubtotal trusts the poisoned
       qty-2 number, and a one-item $99.95 cart renders a $199.90 subtotal and a $99.95 SAVING beside a
       correct $99.95 TOTAL. Full-price items poison identically - cart.ajax.liquid falls back to
       original_price x quantity - so this was never limited to sale items.
       Nothing reads that attribute except aoam-cart-fix's aoamCompareSubtotal and this file, and both
       want the LIQUID value this line destroyed. The cart-count write below is unrelated and stays. */
    let countEls = document.querySelectorAll(".cart-linkbubble-count");
    countEls.forEach((countEl)=>{
      countEl.innerText = cart_count;
    })
  } catch (error) {
    console.error("Error updating compare total:", error);
  }
}

// 2026-08-14 (Claude) - lowest real flat-rate tier per delivery-profile zone (28770009140),
// used by updateFreeShippingUI below. CA/GB = Canada & United Kingdom zone ($22.95 low tier),
// the Europe list = Europe zone ($29.95 low tier); every other country falls through to the
// $79.95 low tier shared by "No USPS Countries (HIGH RISK)" and "Rest of world".
// 2026-09-25 (Claude, international cart check): re-synced to delivery profile 28770009140 as it
// stands today. The 2026-09-15 carve-outs never reached this table: AU/NZ got their own $29.95 zone
// but still read "From $79.95 USD" here, and CH/DK/FI/NO/SE moved to the $34.95 "Switzerland &
// Nordics" zone but still read $29.95. Everyone else (Rest of world + No USPS) is CARRIER-quoted:
// draftOrderCalculate gave JP $27.99, IS $25.81, MX $36.96, SG $41.73, PH $45.48 for a small cart,
// so "From $79.95" was never a floor there. Those countries now read "Calculated at next step",
// the wording the US path and the Kit Builder already use. Update ALL THREE copies together
// (this file, templates/page.kit-builder.liquid, assets/theme.js INTL_LOW_RATE).
const INTL_LOW_RATE = { // every band +$5 handling 2026-10-09 (Joel's popup)
  CA: 27.95, GB: 27.95,
  AU: 34.95, NZ: 34.95, JP: 34.95,
  BE: 39.95, FR: 39.95, DE: 39.95, IE: 39.95, IT: 39.95, LU: 39.95, NL: 39.95, PT: 39.95, ES: 39.95,
  VA: 39.95, MC: 39.95, SM: 39.95, // W.Europe 44.95 -> 39.95 2026-10-22 (Joel: our own DHL account)
  CH: 44.95, DK: 44.95, FI: 44.95, NO: 44.95, SE: 44.95, CY: 44.95, MT: 44.95, AT: 44.95, GR: 44.95, AD: 44.95, // CH/Nordics zone; AT GR AD joined 2026-10-22
  BG: 44.95, HR: 44.95, CZ: 44.95, EE: 44.95, HU: 44.95, LV: 44.95, LT: 44.95, PL: 44.95, RO: 44.95, SK: 44.95, SI: 44.95, // Eastern Europe zone 2026-10-22
  PH: 39.95, TW: 39.95, SG: 39.95, KR: 39.95, HK: 39.95, MO: 39.95, IN: 39.95, TH: 39.95, ID: 39.95, VN: 39.95, CN: 39.95, // Asia zone 2026-10-05
  MX: 29.95, AE: 39.95, BR: 44.95, ZA: 59.95, // own DHL zones 2026-10-06 (out of HIGH RISK)
};

function updateFreeShippingUI(cartTotalCents, cart) {
  const shippingBlock = document.querySelector('.cart-shipping__details');
  const shippingLink = shippingBlock?.querySelector('.shipping_link');
  if (!shippingBlock || !shippingLink) return;

  const freeLimit = Number(shippingBlock.dataset.freeLimit);
  const isFreeShipping = cartTotalCents >= freeLimit;
  const country = window.Shopify?.country || 'US';

  /* =========================
     NON-US (always flat rate)
  ========================== */
  if (country !== 'US') {
    // 2026-08-14 (Claude) - was hardcoded '$19.95 USD Flat-Rate Shipping', which under-quoted
    // every real intl zone rate. drawer-cart.liquid now prints the ONE real answer into
    // data-intl-ship-label (see the Liquid comment there); read it here rather than carrying a
    // second copy. INTL_LOW_RATE below is only a fallback for markup that never got that
    // attribute (e.g. a page render outside the drawer).
    const label = shippingBlock.dataset.intlShipLabel
      || (INTL_LOW_RATE[country] ? `From $${INTL_LOW_RATE[country].toFixed(2)} USD` : 'Calculated at next step');
    shippingBlock.dataset.freeShipping = 'false';
    shippingLink.innerHTML = label;
    shippingLink.classList.remove('free-shipping-active');
    return;
  }

  /* =========================
     US logic
  ========================== */
  // 2026-08-14 (Claude) - Joel: "how can we copy amazon here and show the us customer how much
  // approximately they will save on shipping on the cart drawer?". usShipLabel is the "$6.95"
  // Domestic Standard rate, printed once by snippets/drawer-cart.liquid onto this row and empty
  // whenever the strike-through is not allowed. Naming it below the $99 threshold is what makes the
  // struck price above the threshold read as a real saving. Delete the two references to roll back.
  // 2026-09-25 (Claude): a cart with nothing to ship (gift cards are weightless, requires_shipping
  // false) pays no shipping at checkout, so it gets neither "$6.95" nor a "FREE" row with the struck
  // $11.25 saving beside it. `cart` is the second argument every live caller now passes; a caller
  // that omits it keeps the old behaviour. An empty cart is also requires_shipping=false and lands
  // on exactly what it got before. Delete this block and the ", cart" arguments to roll back.
  if (cart && cart.requires_shipping === false) {
    shippingBlock.dataset.freeShipping = 'false';
    shippingLink.textContent = 'Calculated at next step';
    shippingLink.classList.remove('free-shipping-active');
    return;
  }
  let usShipLabel = shippingBlock.dataset.usShipLabel || '';
  // 2026-09-24 (Claude): name the rate ONLY when the TOTAL is charging it, so the Shipping row and
  // the TOTAL can never disagree again. window.aoamShipCents (snippets/aoam-cart-fix.liquid) is the
  // function every TOTAL writer adds; it returns 0 for an empty cart, which is the case this guard is
  // for now that drawer-cart.liquid publishes data-us-ship-label for every US visitor. Before that it
  // was gated on the PAGE-LOAD cart's weight, so the first add on an empty-cart page read "Calculated
  // at next step" above a TOTAL that already included $6.95. Delete these two lines to roll back.
  const aoamShipNow = (typeof window.aoamShipCents === 'function') ? window.aoamShipCents(cart || { total_price: cartTotalCents }) : (cartTotalCents > 0 ? 1 : 0);
  if (!(aoamShipNow > 0)) usShipLabel = '';
  if (isFreeShipping) {
    shippingBlock.dataset.freeShipping = 'true';
    shippingLink.textContent = 'Free';
    shippingLink.classList.add('free-shipping-active');
  } else {
    shippingBlock.dataset.freeShipping = 'false';
    shippingLink.textContent = usShipLabel || 'Calculated at next step';
    shippingLink.classList.remove('free-shipping-active');
  }
}


function updateCartPageOrderDiscount(cart) {
  const wrap = document.querySelector('[data-cart-page-discount]');
  if (!wrap || !cart || !Array.isArray(cart.items)) return;

  let saving = 0;
  const requests = [];

  cart.items.forEach(item => {
    requests.push(
      // 2026-08-06 - Clarity/GA4 error-click sweep. A throttled /variants/<id>.js returns an
      // HTML 429 page, so res.json() threw "Unexpected token '<'" as an uncaught rejection
      // (one fetch per cart line, so a big kit cart trips the throttle by itself). Skip the
      // line's saving instead; the subtotal it feeds is cosmetic. Restore the bare
      // res.json() chain to roll back.
      fetch(`/variants/${item.id}.js`)
        .then(res => (res.ok ? res.json() : null))
        .then(variant => {
          if (
            variant &&
            variant.compare_at_price &&
            variant.compare_at_price > item.original_price
          ) {
            saving +=
              (variant.compare_at_price - item.original_price) *
              item.quantity;
          }
        })
        .catch(function () {})
    );
  });

  Promise.all(requests).then(() => {
    saving += cart.total_discount || 0;

    const amountEl = wrap.querySelector('.block-saving__amount');
    if (!amountEl) return;

    if (saving > 0) {
      const formatted = formatMoneyNoTrailing(saving);
      amountEl.textContent = formatted;
      amountEl.setAttribute('cus-discount', formatted);
      wrap.classList.remove('hidden');
    } else {
      wrap.classList.add('hidden');
      amountEl.textContent = '';
      amountEl.removeAttribute('cus-discount');
    }
  });
}


// Restrict specific product from Non Us customer
  function closeRestrictedPopup() {
    const restrictedPopup = document.querySelector(".custom-non-us-restricted");
    if (restrictedPopup) {
      restrictedPopup.classList.remove("active");
    }
  }
  document.addEventListener("click", function(e) {
    if (e.target.classList.contains("custom-non-us-restricted-popup-full-width-overlay")) {
      closeRestrictedPopup();
    }
  });

  document.addEventListener("click", function(e) {
    if (e.target.closest(".btn-copy-battery")) {
      const specsList = document.querySelectorAll(".battery-specs li");

      let specsText = [];
      specsList.forEach(li => {
        specsText.push(li.textContent.trim());
      });

      const finalText = specsText.join("\n");

      navigator.clipboard.writeText(finalText).then(() => {
        console.log("Battery specs copied");
      });
      closeRestrictedPopup();
    }
  });

  function customNonUsRestricted(){
    const restrictedPopup = document.querySelector(".custom-non-us-restricted");
    if(restrictedPopup){
      restrictedPopup.classList.add("active");
      const okayBtn = restrictedPopup.querySelector(".btn-ok");
      if(okayBtn){
        okayBtn.addEventListener('click',function(){
          closeRestrictedPopup();
        })
      }
    }
  }
  document.addEventListener("click", function(e) {
    if (e.target.closest(".close-btn-wrapper")) {
      closeRestrictedPopup();
    }
  });
// Restrict specific product from Non Us customer

document.addEventListener('DOMContentLoaded', function () {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      updateCartPageOrderDiscount(cart);
      updateCompareTotal();
    })
    .catch(function () {}); // 2026-09-15: /cart.js can return non-JSON (rate limit), was an unhandled rejection in GA4 js_error
});

function updateExtendedWarranty() {
  // Fetch cart data
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      let updates = {};
      let relatedProductMap = {};
      let saving = 0;

      // STEP 1: Build a map of main products with _related_product and quantity
      cart.items.forEach(item => {
        if (!item.properties?.['Extended Warranty'] && item.properties?.['_related_product']) {
          relatedProductMap[item.properties['_related_product']] = item.quantity;
        }
      });

      // STEP 2: Check warranties (remove if missing, sync quantity if mismatch)
      cart.items.forEach(item => {
        if (item.properties?.['Extended Warranty'] && item.properties['_related_product']) {
          let relatedKey = item.properties['_related_product'];
          let mainQty = relatedProductMap[relatedKey];

          if (!mainQty) {
            // Remove warranty if main product not found
            updates[item.key] = 0;
          } else if (item.quantity !== mainQty) {
            // Sync warranty quantity with main product
            updates[item.key] = mainQty;
          }
        }

        // STEP 3: Calculate savings
        let variantId = item.id;
        fetch(`/variants/${variantId}.js`)
          .then(res => res.json())
          .then(variant => {
            if (variant.compare_at_price > item.original_price) {
              let line_saving = (variant.compare_at_price - item.original_price) * item.quantity;
              saving += line_saving;
            }

            let formattedSaving = formatMoneyNoTrailing(saving);
            let savingEl = document.querySelector(".cart__footer .block-saving__amount");
            if (savingEl) {
              savingEl.textContent = formattedSaving;         
              savingEl.setAttribute("cus-discount", formattedSaving); 
            }

            toggleOrderDiscountVisibility();


          })
          .catch(err => console.error("Variant fetch error:", err));
      });

      // STEP 4: Apply updates if needed
      if (Object.keys(updates).length > 0) {
        fetch('/cart/update.js', {
          method: "POST",
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        })
          .then(res => res.json())
          .then(response => {
            document.dispatchEvent(
              new CustomEvent("ajaxProduct:added", {
                detail: { product: response }
              })
            );
            updateCompareTotal();
          })
          .catch(console.error);
      }else{
        document.dispatchEvent(new CustomEvent("ajaxProduct:added", {detail: {}}));
      }

      // STEP 5: Helper for formatting money
      function formatMoneyNoTrailing(amount) {
        let formatted = theme.Currency.formatMoney(amount, theme.settings.moneyFormat);
        return formatted.replace(/(\.00|,00)$/, '');
      }
    })
    .catch(err => console.error("Cart fetch error:", err));
}

function formatMoney(cents, format) {
  if (typeof cents === "string") cents = cents.replace(".", "");
  let value = "";
  let placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

  function defaultOption(opt, def) {
    return typeof opt === "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");
    if (isNaN(number) || number == null) return 0;

    number = (number / 100.0).toFixed(precision);

    const parts = number.split(".");
    const dollars = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      "$1" + thousands
    );
    const centsPart = parts[1] ? decimal + parts[1] : "";
    return dollars + centsPart;
  }

  format = format || window.Shopify.money_format;

  switch (format.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    // 2026-09-26 cartfix (currency): placeholders local-currency markets use (SEK = amount_with_space_separator).
    // Delete these four cases and the default to roll back.
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ", ",");
      break;
    case "amount_with_period_and_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    default:
      value = formatWithDelimiters(cents, 2);
      break;
  }

  return format.replace(placeholderRegex, value);
}

function formatMoneyWithSuperscript(cents) { let formattedPrice = formatMoney(cents, window.Shopify.money_format); const match = formattedPrice.match(/^(.*?)([.,])(\d{2})$/); if (!match) { return formattedPrice; } return ` <span class="first-price">${match[1]}</span><span class="price-dots">${match[2]}</span> <sup>${match[3]}</sup> `; }
// 2026-10-05 cart audit S11 + S02 + S06 (Claude). The add-to-cart popup is hidden for good (aoam-cart-fix.liquid) and its .active
// class is only the hook aoam-cart-fix.liquid watches to open the cart drawer. That open used to wait on a /variants/<id>.js read whose
// prices only the hidden popup used (S11). It now waits for what the drawer actually shows: the row rebuild that ajaxProduct:added
// starts (lands in [data-products]) AND the cart read aoam-cart-fix-2.liquid starts for the same add (window.__aoamFastP, S06), capped
// at 1.5s. So the drawer opens with its row, totals and warranty offer already in (C12, S06), and one request per add is gone.
// Returns false when the popup is NOT hidden, and the callers then keep their old path.
// Roll back: delete this function and the two callers marked 2026-10-05 cart audit S02 / S11 below.
function aoamOpenDrawerAfterRows(product, after) {
  var pop = document.querySelector(".custom-addtocart-popup");
  try { if (!pop || window.getComputedStyle(pop).display !== "none") return false; } catch (e) { return false; }
  var holder = document.querySelector("#header_minicart [data-products]"), fp = window.__aoamFastP;
  var rows = !holder, fast = !(fp && fp.then), done = false, mo = null, t = null;
  var go = function (force) {
    if (done || (!force && !(rows && fast))) return;
    done = true; clearTimeout(t);
    try { if (mo) mo.disconnect(); } catch (e) {}
    addToCartPopup_fn(product);
    if (after) { try { after(); } catch (e) {} }
  };
  try { if (holder && window.MutationObserver) { mo = new MutationObserver(function () { rows = true; go(); }); mo.observe(holder, { childList: true }); } else { rows = true; } } catch (e) { rows = true; }
  if (!fast) fp.then(function () { fast = true; go(); }, function () { fast = true; go(); });
  t = setTimeout(function () { go(true); }, 1500);
  go();
  return true;
}
function addToCartPopup_fn(product){
  if (!product) return;
  
  // console.log("add to cart popup function called...");
  const addToCartPopup = document.querySelector(".custom-addtocart-popup");
  addToCartPopup.classList.add("active");
  // 2026-09-28 cart-fix-l low-drawer-clean C42: aoam-cart-fix hides this popup (display:none!important) and only needs the .active class above to open the
  // drawer, so skip filling it (a /cart.js read, a /products/<h>.js read per _product_N property, and listeners that pile up
  // per add). If the popup is ever shown again the full path runs as before. Rollback: delete the next line.
  try { if (window.getComputedStyle(addToCartPopup).display === "none") return; } catch (e) {}

  const bfBadge = addToCartPopup.querySelector(".pdp-bfd-button");
  if (bfBadge) {
    bfBadge.style.display =
      product.compare_at_price && product.compare_at_price > product.price
        ? "flex"
        : "none";
  }
  // console.log("Product",product);

  if (addToCartPopup) {
      // 2026-09-15 (Claude, Clarity/GA4 sweep): featured_image.url can be missing, and assigning
      // undefined made the browser request /products/undefined (GA4 js_error, 19 users since Aug 15)
      // and showed a broken image in the popup. Fall back to line.image, else leave the old src.
      var aoamPopImg = addToCartPopup.querySelector(".poup-main-content .image-wrapper img");
      var aoamPopSrc = (product.featured_image && product.featured_image.url) || product.image || "";
      if (aoamPopImg && aoamPopSrc) aoamPopImg.src = aoamPopSrc;
      addToCartPopup.querySelector(".poup-main-content .title").innerHTML = `<h2>${product.product_title}</h2>`;

      if(product.variant_title){
        addToCartPopup.querySelector(".poup-main-content .variant-title").innerHTML = `${product.variant_title}`;
      }
  
      addToCartPopup.querySelector(".view-cart-btn").setAttribute("disabled","disabled");
      const comparePriceHTML = product.compare_at_price
        ? `<div class="compare-price">${formatMoneyWithSuperscript(product.compare_at_price)}</div>`
        : "";

      const priceHTML = `<div class="price">${formatMoneyWithSuperscript(product.price)}</div>`;

      addToCartPopup.querySelector(".poup-main-content .price-wrapper").innerHTML =
      comparePriceHTML + priceHTML;

      // ADD THIS PART (Discount Percentage)
      let discountPercentHTML = "";

      if (product.compare_at_price && product.compare_at_price > product.price) {
        const discountValue = product.compare_at_price - product.price;
        const discountPercent = Math.round((discountValue / product.compare_at_price) * 100);
        // discountPercentHTML = `<span class="discount-percent">${discountPercent}% OFF</span>`;
        discountPercentHTML = `<span class="discount-percent">You save ${formatMoneyWithSuperscript(discountValue)}</span>`;
      }

      addToCartPopup.querySelector(".cst-per").innerHTML = discountPercentHTML;

      fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        // Optional: show in popup
        const popupCount = addToCartPopup.querySelector(".view-cart-btn .count");
        if (popupCount) {
          popupCount.textContent = `(${cart.item_count})`;
        }
      })
      .catch((error) => console.error("Cart fetch error:", error));

      addToCartPopup.querySelector(".view-cart-btn").removeAttribute("disabled");

      const closeBtn = addToCartPopup.querySelector(".close-btn-wrapper");
      if(closeBtn){
        closeBtn.addEventListener('click',function(){
          addToCartPopup.classList.remove("active");
        });
      }

      // Close on outside click
      setTimeout(() => {
        const handleOutsideClick = (e) => {
          if (!addToCartPopup.classList.contains("active")) return;

          // Ignore clicks triggered in the cart or on warranty buttons
          if (e.target.closest(".cart__item_wrp") || e.target.closest(".extended-warranty")) return;

          const content = addToCartPopup.querySelector(".poup-main-content");
          const recommendedItems = addToCartPopup.querySelector(".popup-bottom-position");
          if (content && !content.contains(e.target) && !recommendedItems.contains(e.target)) {
            addToCartPopup.classList.remove("active");
            document.removeEventListener("click", handleOutsideClick);
          }
        };

        document.addEventListener("click", handleOutsideClick);
      }, 100);

      setTimeout(()=>{
        const viewCartBtn = document.querySelector(".view-cart-btn");

        viewCartBtn.addEventListener("click", function (e) {
          e.preventDefault();

          // Close the popup
          const addToCartPopup = document.querySelector(".popup-action-content.qq");
          if (addToCartPopup) {
            addToCartPopup.classList.remove("active");
          }

          if (window.innerWidth >= 768) {
            // Desktop: redirect to cart page
            window.location.href = "/cart";
          // new theme.Drawer("header_minicart", "right").open();
          } else {
            // Mobile: open minicart drawer
            setTimeout(() => {
              const minCartTrigger = document.querySelector(".block-mincart .cstm_icon");
              if (minCartTrigger) minCartTrigger.click();
              
            }, 500);
          }
        });
      },1500);


    // Display currently added items

    // Recommended items in cart popup

      const properties = product.properties || {};
      const productKeys = Object.keys(properties).filter(key => key.startsWith("_product"));
      const container = document.querySelector(".recommended-pro-list");
      container.innerHTML = '';

      if (productKeys.length === 0) return;
      const fetchPromises = productKeys.map(key => {
        const handle = properties[key];

        return fetch(`/products/${handle}.js`)
          .then(res => res.json())
          .then(product => {
            const variant = product.variants[0];

            const image = product.featured_image;
            const title = product.title;
            const url = product.url;
            const description = product.description.replace(/(<([^>]+)>)/gi, "").slice(0, 120);
            const price = (variant.price / 100).toFixed(2);
            const comparePrice = variant.compare_at_price
              ? (variant.compare_at_price / 100).toFixed(2)
              : "";

            const html = `
              <div class="pro-list">
                <div class="image-wrapper">
                  <img src="${image}" alt="${title}" loading="lazy">
                </div>

                <div class="data-wrapper">
                  <div class="details-left">
                    <h2 class="title">
                      <a href="${url}">${title}</a>
                    </h2>

                    <p class="additional-cts-text">${description}</p>

                    <div class="price-wrapper">
                      ${comparePrice ? `<div class="compare-price">${formatMoneyWithSuperscript(variant.compare_at_price)}</div>` : ""}
                      <div class="price">${formatMoneyWithSuperscript(variant.price)}</div>
                    </div>

                    <div class="product-info"></div>
                  </div>

                  <div class="action-btn-right">
                    <button class="add-pro-btn" data-variant-id="${variant.id}">
                      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="20" cy="20" r="20" fill="#87F614"/>
                          <path d="M12.5 18.75H27.5V21.25H12.5V18.75Z" fill="black"/>
                          <path d="M21.25 12.5V27.5H18.75V12.5L21.25 12.5Z" fill="black"/>
                      </svg>
                    </button>

                    <button class="already-added-pro-btn hide">
                       <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="20" cy="20" r="19.5" stroke="white"/>
                          <path d="M13.6428 18.1694L19.83 24.3566L18.0622 26.1244L11.875 19.9372L13.6428 18.1694Z" fill="#87F614"/>
                          <path d="M28.6688 15.5178L18.0622 26.1244L16.2944 24.3566L26.901 13.75L28.6688 15.5178Z" fill="#87F614"/>
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            `;

            container.insertAdjacentHTML("beforeend", html);
          })
          .catch(err => {
            console.error("Product fetch failed:", handle, err);
          });     
      });

      Promise.all(fetchPromises).then(() => {

        const productList = container.querySelectorAll(".pro-list");
        if (productList.length) {
          productList.forEach(function (productItem) {
            const add_btn = productItem.querySelector(".add-pro-btn");
            if (!add_btn) return;

            add_btn.addEventListener("click", function (event) {
              event.preventDefault();

              const pro_id = this.getAttribute("data-variant-id");
              if (!pro_id) return;

              this.classList.add("btn--loading");
              fetch("/cart/add.js", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  id: parseInt(pro_id, 10),
                  quantity: 1,
                }),
              })
                .then((res) => res.json())
                .then((data) => {
                  const product = data;

                  document.dispatchEvent(
                    new CustomEvent("ajaxProduct:added", {
                      detail: {
                        product: product,
                      },
                    })
                  );
                  this.classList.add("hide");
                  productItem.querySelector(".already-added-pro-btn").classList.remove("hide");
                  this.classList.remove("btn--loading");
                })
                .catch((err) => {
                  console.error("Add to cart error:", err);
                  this.classList.remove("btn--loading");
                });
            });
          });
        }
      });
     
     
    // Recommended items in cart popup
   
  }

 


}

window.theme = window.theme || {};
window.Shopify = window.Shopify || {};

theme.config = {
  vimeoReady: false,
  stickyHeader: false,
  youTubeReady: false,
  vimeoLoading: false,
  hasLocalStorage: true,
  hasSessionStorage: true,
  rtl: document.documentElement.getAttribute("dir") == "rtl" ? true : false,
};

theme.recentlyViewedIds = [];

(function () {
  "use strict";

  theme.delegate = {
    on: function (event, callback, options) {
      if (!this.namespaces)
        // save the namespaces on the DOM element itself
        this.namespaces = {};

      this.namespaces[event] = callback;
      options = options || false;

      this.addEventListener(event.split(".")[0], callback, options);
      return this;
    },
    off: function (event) {
      if (!this.namespaces) {
        return;
      }
      this.removeEventListener(event.split(".")[0], this.namespaces[event]);
      delete this.namespaces[event];
      return this;
    },
  };

  // Extend the DOM with these above custom methods
  window.on = Element.prototype.on = theme.delegate.on;
  window.off = Element.prototype.off = theme.delegate.off;

  theme.utils = {
    defaultTo: function (value, defaultValue) {
      return value == null || value !== value ? defaultValue : value;
    },

    wrap: function (el, wrapper) {
      el.parentNode.insertBefore(wrapper, el);
      wrapper.appendChild(el);
    },

    debounce: function (wait, callback, immediate) {
      var timeout;
      return function () {
        var context = this,
          args = arguments;
        var later = function () {
          timeout = null;
          if (!immediate) callback.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) callback.apply(context, args);
      };
    },

    throttle: function (limit, callback) {
      var waiting = false;
      return function () {
        if (!waiting) {
          callback.apply(this, arguments);
          waiting = true;
          setTimeout(function () {
            waiting = false;
          }, limit);
        }
      };
    },

    prepareTransition: function (el, callback) {
      el.addEventListener("transitionend", removeClass);

      function removeClass(evt) {
        el.classList.remove("is-transitioning");
        el.removeEventListener("transitionend", removeClass);
      }

      el.classList.add("is-transitioning");
      el.offsetWidth; // check offsetWidth to force the style rendering

      if (typeof callback === "function") {
        callback();
      }
    },

    // _.compact from lodash
    // Creates an array with all falsey values removed. The values `false`, `null`,
    // `0`, `""`, `undefined`, and `NaN` are falsey.
    // _.compact([0, 1, false, 2, '', 3]);
    // => [1, 2, 3]
    compact: function (array) {
      var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    },

    serialize: function (form) {
      var arr = [];
      Array.prototype.slice.call(form.elements).forEach(function (field) {
        if (
          !field.name ||
          field.disabled ||
          ["file", "reset", "submit", "button"].indexOf(field.type) > -1
        )
          return;
        if (field.type === "select-multiple") {
          Array.prototype.slice.call(field.options).forEach(function (option) {
            if (!option.selected) return;
            arr.push(
              encodeURIComponent(field.name) +
              "=" +
              encodeURIComponent(option.value)
            );
          });
          return;
        }
        if (["checkbox", "radio"].indexOf(field.type) > -1 && !field.checked)
          return;
        arr.push(
          encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value)
        );
      });
      return arr.join("&");
    },
  };

  theme.a11y = {
    trapFocus: function (options) {
      var eventsName = {
        focusin: options.namespace ? "focusin." + options.namespace : "focusin",
        focusout: options.namespace
          ? "focusout." + options.namespace
          : "focusout",
        keydown: options.namespace
          ? "keydown." + options.namespace
          : "keydown.handleFocus",
      };

      // Get every possible visible focusable element
      var focusableEls = options.container.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'
      );
      var elArray = [].slice.call(focusableEls);
      var focusableElements = elArray.filter((el) => el.offsetParent !== null);

      var firstFocusable = focusableElements[0];
      var lastFocusable = focusableElements[focusableElements.length - 1];

      if (!options.elementToFocus) {
        options.elementToFocus = options.container;
      }

      options.container.setAttribute("tabindex", "-1");
      options.elementToFocus.focus();

      document.documentElement.off("focusin");
      document.documentElement.on(eventsName.focusout, function () {
        document.documentElement.off(eventsName.keydown);
      });

      document.documentElement.on(eventsName.focusin, function (evt) {
        if (evt.target !== lastFocusable && evt.target !== firstFocusable)
          return;

        document.documentElement.on(eventsName.keydown, function (evt) {
          _manageFocus(evt);
        });
      });

      function _manageFocus(evt) {
        if (evt.keyCode !== 9) return;
        /**
         * On the first focusable element and tab backward,
         * focus the last element
         */
        if (evt.target === firstFocusable && evt.shiftKey) {
          evt.preventDefault();
          lastFocusable.focus();
        }
      }
    },
    removeTrapFocus: function (options) {
      var eventName = options.namespace
        ? "focusin." + options.namespace
        : "focusin";

      if (options.container) {
        options.container.removeAttribute("tabindex");
      }

      document.documentElement.off(eventName);
    },

    lockMobileScrolling: function (namespace, element) {
      var el = element ? element : document.documentElement;
      document.documentElement.classList.add("lock-scroll");
      el.on("touchmove" + namespace, function () {
        return true;
      });
    },

    unlockMobileScrolling: function (namespace, element) {
      document.documentElement.classList.remove("lock-scroll");
      var el = element ? element : document.documentElement;
      el.off("touchmove" + namespace);
    },
  };

  theme.cookies = {
    getCookie: function (cname) {
      let name = cname + "=";
      let ca = document.cookie.split(";");
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];

        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
  };

  // Add class when tab key starts being used to show outlines
  document.documentElement.on("keyup.tab", function (evt) {
    if (evt.keyCode === 9) {
      document.documentElement.classList.add("tab-outline");
      document.documentElement.off("keyup.tab");
    }
  });

  /**
   * Currency Helpers
   * -----------------------------------------------------------------------------
   * A collection of useful functions that help with currency formatting
   *
   * Current contents
   * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
   *   - When theme.settings.superScriptPrice is enabled, format cents in <sup> tag
   * - getBaseUnit - Splits unit price apart to get value + unit
   *
   */

  theme.Currency = (function () {
    var moneyFormat = "${{amount}}";
    var superScript = false;

    function formatMoney(cents, format) {
      if (!format) {
        format = theme.settings.moneyFormat;
      }

      if (typeof cents === "string") {
        cents = cents.replace(".", "");
      }
      var value = "";
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = format || moneyFormat;

      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = theme.utils.defaultTo(precision, 2);
        thousands = theme.utils.defaultTo(thousands, ",");
        decimal = theme.utils.defaultTo(decimal, ".");

        if (isNaN(number) || number == null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split(".");
        var dollarsAmount = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          "$1" + thousands
        );
        var centsAmount = parts[1] ? decimal + parts[1] : "";

        return dollarsAmount + centsAmount;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case "amount":
          value = formatWithDelimiters(cents, 2);

          if (superScript && value && value.includes(".")) {
            value = value.replace(".", "<sup>") + "</sup>";
          }

          break;
        case "amount_no_decimals":
          value = formatWithDelimiters(cents, 0);
          break;
        case "amount_with_comma_separator":
          value = formatWithDelimiters(cents, 2, ".", ",");
          if (superScript && value && value.includes(".")) {
            value = value.replace(",", "<sup>") + "</sup>";
          }

          break;
        case "amount_no_decimals_with_comma_separator":
          value = formatWithDelimiters(cents, 0, ".", ",");
          break;
        case "amount_no_decimals_with_space_separator":
          value = formatWithDelimiters(cents, 0, " ");
          break;
        // 2026-09-26 cartfix (currency): SEK drawer TOTAL/Subtotal/warranty read " kr" because this case was missing.
        // Delete these three cases and the default to roll back.
        case "amount_with_space_separator":
          value = formatWithDelimiters(cents, 2, " ", ",");
          break;
        case "amount_with_period_and_space_separator":
          value = formatWithDelimiters(cents, 2, " ", ".");
          break;
        case "amount_with_apostrophe_separator":
          value = formatWithDelimiters(cents, 2, "'", ".");
          break;
        default:
          value = formatWithDelimiters(cents, 2);
          break;
      }

      return formatString.replace(placeholderRegex, value);
    }

    function getBaseUnit(variant) {
      if (!variant) {
        return;
      }

      if (
        !variant.unit_price_measurement ||
        !variant.unit_price_measurement.reference_value
      ) {
        return;
      }

      return variant.unit_price_measurement.reference_value === 1
        ? variant.unit_price_measurement.reference_unit
        : variant.unit_price_measurement.reference_value +
        variant.unit_price_measurement.reference_unit;
    }

    return {
      formatMoney: formatMoney,
      getBaseUnit: getBaseUnit,
    };
  })();

  theme.Images = (function () {
    /**
     * Preloads an image in memory and uses the browsers cache to store it until needed.
     *
     * @param {Array} images - A list of image urls
     * @param {String} size - A shopify image size attribute
     */

    function preload(images, size) {
      if (typeof images === "string") {
        images = [images];
      }

      for (var i = 0; i < images.length; i++) {
        var image = images[i];
        this.loadImage(this.getSizedImageUrl(image, size));
      }
    }

    /**
     * Loads and caches an image in the browsers cache.
     * @param {string} path - An image url
     */
    function loadImage(path) {
      new Image().src = path;
    }

    /**
     * Find the Shopify image attribute size
     *
     * @param {string} src
     * @returns {null}
     */
    function imageSize(src) {
      if (!src) {
        return "680x";
      }

      var match = src.match(
        /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/
      );

      if (match) {
        return match[1];
      } else {
        return null;
      }
    }

    /**
     * Adds a Shopify size attribute to a URL
     *
     * @param src
     * @param size
     * @returns {*}
     */
    function getSizedImageUrl(src, size) {
      if (size === null) {
        return src;
      }

      if (size === "master") {
        return this.removeProtocol(src);
      }

      var match = src.match(
        /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
      );

      if (match) {
        var prefix = src.split(match[0]);
        var suffix = match[0];

        return this.removeProtocol(prefix[0] + "_" + size + suffix);
      } else {
        return null;
      }
    }

    function removeProtocol(path) {
      return path.replace(/http(s)?:/, "");
    }

    return {
      preload: preload,
      loadImage: loadImage,
      imageSize: imageSize,
      getSizedImageUrl: getSizedImageUrl,
      removeProtocol: removeProtocol,
    };
  })();

  // AOAM 2026-07-06 (Claude): restore predictive-search render helpers (JS-1).
  // buildProducts() calls these two; neither existed, so predictive search threw a TypeError.
  theme.Images.lazyloadImagePath = function _lazy(src) {
    if (!src) { return ''; }
    var clean = theme.Images.removeProtocol(src).split('?')[0];
    clean = clean.replace(/_(?:pico|icon|thumb|small|compact|medium|large|grande|original|\d{1,4}x\d{0,4}|x\d{1,4})(?=\.(?:jpg|jpeg|gif|png|bmp|bitmap|tiff|tif|webp)$)/i, '');
    var m = clean.match(/\.(?:jpg|jpeg|gif|png|bmp|bitmap|tiff|tif|webp)$/i);
    if (!m) { return clean; }
    return clean.replace(m[0], '_{width}x' + m[0]);
  };
  theme.buildProductGridItem = function _build(products) {
    if (!products) { return ''; }
    if (!Array.isArray(products)) { products = [products]; }
    var esc = function (s) {
      return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    };
    var widths = [165, 360, 533, 720];
    return products.map(function (p) {
      var tmpl = p.image_responsive_url || '';
      var hasTmpl = tmpl.indexOf('{width}') !== -1;
      var src = hasTmpl ? tmpl.replace('{width}', '360') : tmpl;
      var srcset = hasTmpl ? widths.map(function (w) { return tmpl.replace('{width}', w) + ' ' + w + 'w'; }).join(', ') : '';
      var title = esc(p.title);
      var url = esc(p.url);
      var img = '<img class="grid-product__image" loading="lazy" alt="' + title + '" src="' + esc(src) + '"' + (srcset ? ' srcset="' + esc(srcset) + '" sizes="(min-width: 990px) 20vw, 40vw"' : '') + '>';
      // 2026-07-29 - Joel: "improve the format and structure of this search drop down".
      // Square aspect box (was per-product ratio, so tiles landed at different heights
      // and the grid rows never lined up) plus an optional price row. Price renders
      // only when the caller passes price_min, so any other use of this builder is
      // byte-identical to before. Delete this block and the priceHtml usage to roll back.
      var priceHtml = '';
      var priceMin = parseFloat(p.price_min);
      if (!isNaN(priceMin)) {
        var money = function (v) {
          try { return theme.Currency.formatMoney(Math.round(parseFloat(v) * 100), theme.settings.moneyFormat); }
          catch (e) { return '$' + v; }
        };
        var from = parseFloat(p.price_max) > priceMin ? 'From ' : '';
        var compare = parseFloat(p.compare_at_price_min) > priceMin
          ? ' <s class="grid-product__compare">' + money(p.compare_at_price_min) + '</s>' : '';
        var soldOut = p.available === false ? ' <span class="grid-product__soldout">Sold out</span>' : '';
        priceHtml = '<div class="grid-product__price">' + from + money(priceMin) + compare + soldOut + '</div>';
      }
      return '<div class="grid__item grid-product large--one-third" data-product-card>' +
        '<div class="grid-item__content product-card__inner">' +
        '<a href="' + url + '" class="grid-item__link">' +
        '<div class="grid-product__image-wrap">' +
        '<div style="height:0;padding-bottom:100%;">' + img + '</div>' +
        '</div>' +
        '<div class="grid-item__meta"><div class="grid-item__meta-main">' +
        '<h3 class="grid-product__title">' + title + '</h3>' +
        priceHtml +
        '</div></div>' +
        '</a></div></div>';
    }).join('');
  };

  // AOAM 2026-07-06 (Claude): predictive-search helpers for collections/pages/articles (JS-1 completion).
  theme.buildCollectionItem = function _buildCollectionItem(collections){
    if(!collections){return '';}
    if(!Array.isArray(collections)){collections=[collections];}
    return collections.map(function(c){
      var img='';
      if(c.featured_image && c.featured_image.url){
        var u=theme.Images.getSizedImageUrl(c.featured_image.url,'100x100_crop_center')||c.featured_image.url;
        img='<img src="'+function(s){return String(s==null?"":s).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;");}(u)+'" alt="'+function(s){return String(s==null?"":s).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;");}(c.title)+'" width="40" height="40" loading="lazy">';
      }
      return '<li class="predictive-item predictive-item--collection"><a href="'+function(s){return String(s==null?"":s).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;");}(c.url)+'">'+img+'<span>'+function(s){return String(s==null?"":s).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;");}(c.title)+'</span></a></li>';
    }).join('');
  };
  theme.buildPageItem = function _buildPageItem(pages){
    if(!pages){return '';}
    if(!Array.isArray(pages)){pages=[pages];}
    return pages.map(function(p){
      return '<li class="predictive-item predictive-item--page"><a href="'+function(s){return String(s==null?"":s).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;");}(p.url)+'"><span>'+function(s){return String(s==null?"":s).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;");}(p.title)+'</span></a></li>';
    }).join('');
  };
  theme.buildArticleItem = function _buildArticleItem(articles){
    if(!articles){return '';}
    if(!Array.isArray(articles)){articles=[articles];}
    return articles.map(function(a){
      var img=a.image ? '<img src="'+function(s){return String(s==null?"":s).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;");}(a.image)+'" alt="'+function(s){return String(s==null?"":s).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;");}(a.title)+'" loading="lazy">' : '';
      return '<div class="grid__item predictive-item predictive-item--article"><a href="'+function(s){return String(s==null?"":s).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;");}(a.url)+'">'+img+'<span>'+function(s){return String(s==null?"":s).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;");}(a.title)+'</span></a></div>';
    }).join('');
  };

  // Init section function when it's visible, then disable observer
  theme.initWhenVisible = function (options) {
    var threshold = options.threshold ? options.threshold : 0;

    var observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (typeof options.callback === "function") {
              options.callback();
              observer.unobserve(entry.target);
            }
          }
        });
      },
      { rootMargin: "0px 0px " + threshold + "px 0px" }
    );

    observer.observe(options.element);
  };

  theme.LibraryLoader = (function () {
    var types = {
      link: "link",
      script: "script",
    };

    var status = {
      requested: "requested",
      loaded: "loaded",
    };

    var cloudCdn = "https://cdn.shopify.com/shopifycloud/";

    var libraries = {
      youtubeSdk: {
        tagId: "youtube-sdk",
        src: "https://www.youtube.com/iframe_api",
        type: types.script,
      },
      vimeo: {
        tagId: "vimeo-api",
        src: "https://player.vimeo.com/api/player.js",
        type: types.script,
      },
      shopifyXr: {
        tagId: "shopify-model-viewer-xr",
        src: cloudCdn + "shopify-xr-js/assets/v1.0/shopify-xr.en.js",
        type: types.script,
      },
      modelViewerUi: {
        tagId: "shopify-model-viewer-ui",
        src: cloudCdn + "model-viewer-ui/assets/v1.0/model-viewer-ui.en.js",
        type: types.script,
      },
      modelViewerUiStyles: {
        tagId: "shopify-model-viewer-ui-styles",
        src: cloudCdn + "model-viewer-ui/assets/v1.0/model-viewer-ui.css",
        type: types.link,
      },
    };

    function load(libraryName, callback) {
      var library = libraries[libraryName];

      if (!library) return;
      if (library.status === status.requested) return;

      callback = callback || function () { };
      if (library.status === status.loaded) {
        callback();
        return;
      }

      library.status = status.requested;

      var tag;

      switch (library.type) {
        case types.script:
          tag = createScriptTag(library, callback);
          break;
        case types.link:
          tag = createLinkTag(library, callback);
          break;
      }

      tag.id = library.tagId;
      library.element = tag;

      var firstScriptTag = document.getElementsByTagName(library.type)[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }

    function createScriptTag(library, callback) {
      var tag = document.createElement("script");
      tag.src = library.src;
      tag.addEventListener("load", function () {
        library.status = status.loaded;
        callback();
      });
      return tag;
    }

    function createLinkTag(library, callback) {
      var tag = document.createElement("link");
      tag.href = library.src;
      tag.rel = "stylesheet";
      tag.type = "text/css";
      tag.addEventListener("load", function () {
        library.status = status.loaded;
        callback();
      });
      return tag;
    }

    return {
      load: load,
    };
  })();

  theme.rteInit = function () {
    // Wrap tables so they become scrollable on small screens
    document.querySelectorAll(".rte table").forEach((table) => {
      var wrapWith = document.createElement("div");
      wrapWith.classList.add("table-wrapper");
      theme.utils.wrap(table, wrapWith);
    });

    // Wrap video iframe embeds so they are responsive
    document
      .querySelectorAll('.rte iframe[src*="youtube.com/embed"]')
      .forEach((iframe) => {
        wrapVideo(iframe);
      });
    document
      .querySelectorAll('.rte iframe[src*="player.vimeo"]')
      .forEach((iframe) => {
        wrapVideo(iframe);
      });

    function wrapVideo(iframe) {
      // Reset the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      iframe.src = iframe.src;
      var wrapWith = document.createElement("div");
      wrapWith.classList.add("video-wrapper");
      theme.utils.wrap(iframe, wrapWith);
    }

    // Remove CSS that adds animated underline under image links
    document.querySelectorAll(".rte a img").forEach((img) => {
      img.parentNode.classList.add("rte__image");
    });
  };

  theme.Sections = function Sections() {
    this.constructors = {};
    this.instances = [];

    document.addEventListener(
      "shopify:section:load",
      this._onSectionLoad.bind(this)
    );
    document.addEventListener(
      "shopify:section:unload",
      this._onSectionUnload.bind(this)
    );
    document.addEventListener(
      "shopify:section:select",
      this._onSelect.bind(this)
    );
    document.addEventListener(
      "shopify:section:deselect",
      this._onDeselect.bind(this)
    );
    document.addEventListener(
      "shopify:block:select",
      this._onBlockSelect.bind(this)
    );
    document.addEventListener(
      "shopify:block:deselect",
      this._onBlockDeselect.bind(this)
    );
  };

  theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
    _createInstance: function (container, constructor, scope) {
      var id = container.getAttribute("data-section-id");
      var type = container.getAttribute("data-section-type");

      constructor = constructor || this.constructors[type];

      if (typeof constructor === "undefined") {
        return;
      }

      // If custom scope passed, check to see if instance
      // is already initialized so we don't double up
      if (scope) {
        var instanceExists = this._findInstance(id);
        if (instanceExists) {
          this._removeInstance(id);
        }
      }

      // If a section fails to init, handle the error without letting all subsequest section registers to fail
      try {
        var instance = Object.assign(new constructor(container), {
          id: id,
          type: type,
          container: container,
        });
        this.instances.push(instance);
      } catch (e) {
        console.error(e);
      }
    },

    _findInstance: function (id) {
      for (var i = 0; i < this.instances.length; i++) {
        if (this.instances[i].id === id) {
          return this.instances[i];
        }
      }
    },

    _removeInstance: function (id) {
      var i = this.instances.length;
      var instance;

      while (i--) {
        if (this.instances[i].id === id) {
          instance = this.instances[i];
          this.instances.splice(i, 1);
          break;
        }
      }

      return instance;
    },

    _onSectionLoad: function (evt, subSection, subSectionId) {
      if (window.AOS) {
        AOS.refreshHard();
      }
      if (theme && theme.initGlobals) {
        theme.initGlobals();
      }

      var container = subSection ? subSection : evt.target;
      var section = subSection
        ? subSection
        : evt.target.querySelector("[data-section-id]");

      if (!section) {
        return;
      }

      this._createInstance(section);

      var instance = subSection
        ? subSectionId
        : this._findInstance(evt.detail.sectionId);

      // Check if we have subsections to load
      var haveSubSections = container.querySelectorAll("[data-subsection]");
      if (haveSubSections.length) {
        this.loadSubSections(container);
      }

      // Run JS only in case of the section being selected in the editor
      // before merchant clicks "Add"
      if (instance && typeof instance.onLoad === "function") {
        instance.onLoad(evt);
      }

      // Force editor to trigger scroll event when loading a section
      setTimeout(function () {
        window.dispatchEvent(new Event("scroll"));
      }, 200);
    },

    _onSectionUnload: function (evt) {
      this.instances = this.instances.filter(function (instance) {
        var isEventInstance = instance.id === evt.detail.sectionId;

        if (isEventInstance) {
          if (typeof instance.onUnload === "function") {
            instance.onUnload(evt);
          }
        }

        return !isEventInstance;
      });
    },

    loadSubSections: function (scope) {
      if (!scope) {
        return;
      }

      var sections = scope.querySelectorAll("[data-section-id]");

      sections.forEach((el) => {
        this._onSectionLoad(null, el, el.dataset.sectionId);
      });
    },

    _onSelect: function (evt) {
      var instance = this._findInstance(evt.detail.sectionId);

      if (
        typeof instance !== "undefined" &&
        typeof instance.onSelect === "function"
      ) {
        instance.onSelect(evt);
      }
    },

    _onDeselect: function (evt) {
      var instance = this._findInstance(evt.detail.sectionId);

      if (
        typeof instance !== "undefined" &&
        typeof instance.onDeselect === "function"
      ) {
        instance.onDeselect(evt);
      }
    },

    _onBlockSelect: function (evt) {
      var instance = this._findInstance(evt.detail.sectionId);

      if (
        typeof instance !== "undefined" &&
        typeof instance.onBlockSelect === "function"
      ) {
        instance.onBlockSelect(evt);
      }
    },

    _onBlockDeselect: function (evt) {
      var instance = this._findInstance(evt.detail.sectionId);

      if (
        typeof instance !== "undefined" &&
        typeof instance.onBlockDeselect === "function"
      ) {
        instance.onBlockDeselect(evt);
      }
    },

    register: function (type, constructor, scope) {
      this.constructors[type] = constructor;

      var sections = document.querySelectorAll(
        '[data-section-type="' + type + '"]'
      );

      if (scope) {
        sections = scope.querySelectorAll('[data-section-type="' + type + '"]');
      }

      sections.forEach(
        function (container) {
          this._createInstance(container, constructor, scope);
        }.bind(this)
      );
    },

    reinit: function (section) {
      for (var i = 0; i < this.instances.length; i++) {
        var instance = this.instances[i];
        if (instance["type"] === section) {
          if (typeof instance.forceReload === "function") {
            instance.forceReload();
          }
        }
      }
    },
  });

  theme.Variants = (function () {
    function Variants(options) {
      this.container = options.container;
      this.variants = options.variants;
      this.singleOptionSelector = options.singleOptionSelector;
      this.originalSelectorId = options.originalSelectorId;
      this.enableHistoryState = options.enableHistoryState;
      this.currentVariant = this._getVariantFromOptions();

      this.container
        .querySelectorAll(this.singleOptionSelector)
        .forEach((el) => {
          el.addEventListener("change", this._onSelectChange.bind(this));
        });
    }

    Variants.prototype = Object.assign({}, Variants.prototype, {
      _getCurrentOptions: function () {
        var result = [];

        this.container
          .querySelectorAll(this.singleOptionSelector)
          .forEach((el) => {
            var type = el.getAttribute("type");

            if (type === "radio" || type === "checkbox") {
              if (el.checked) {
                result.push({
                  value: el.value,
                  index: el.dataset.index,
                });
              }
            } else {
              result.push({
                value: el.value,
                index: el.dataset.index,
              });
            }
          });

        // remove any unchecked input values if using radio buttons or checkboxes
        result = theme.utils.compact(result);

        return result;
      },

      _getVariantFromOptions: function () {
        var selectedValues = this._getCurrentOptions();
        var variants = this.variants;
        var found = false;

        variants.forEach(function (variant) {
          var match = true;
          var options = variant.options;

          selectedValues.forEach(function (option) {
            if (match) {
              match = variant[option.index] === option.value;
            }
          });

          if (match) {
            found = variant;
          }
        });

        return found || null;
      },

      // 2026-10-10 audit (variant-no-resize): a tap on a pair that is not a real variant now snaps to the nearest real one instead of sending a null variant (dead Unavailable button, 64-73px jump).
      // The tapped value wins and the other picks move as little as possible (available first, then most picks kept, then the earlier option kept). Runs only when NO variant matches, so a sold-out pair picked on purpose is never touched.
      // Exception: it never moves an option named Model that the shopper did not tap (wrong-compatibility SKU risk, silicone sleeve), so that case keeps the old behavior.
      // Kill switch: window.AOAM_SNAP_COMBOS = false. Roll back: delete _aoamSnap, _aoamSnapDone and the snap block at the top of _onSelectChange.
      _aoamSnap: function (evt) {
        if (window.AOAM_SNAP_COMBOS === false) {
          return null;
        }
        var el = evt && evt.target;
        if (!el || !el.dataset || !el.dataset.index) {
          return null;
        }

        var idx = el.dataset.index;
        var val = el.value;
        var variants = this.variants;
        var picks = this._getCurrentOptions().filter(function (o) {
          return o.index !== idx;
        });

        // Every other pick must be a real option value (a "Choose..." placeholder select is left alone).
        var real = picks.every(function (o) {
          return variants.some(function (v) {
            return v[o.index] === o.value;
          });
        });
        if (!real) {
          return null;
        }

        var best = null;
        var bestScore = -1;
        variants.forEach(function (v) {
          if (v[idx] !== val) {
            return;
          }
          var score = v.available === false ? 0 : 10000;
          picks.forEach(function (o) {
            if (v[o.index] === o.value) {
              score += 100 + (4 - (parseInt(String(o.index).replace("option", ""), 10) || 3));
            }
          });
          if (score > bestScore) {
            bestScore = score;
            best = v;
          }
        });
        if (!best) {
          return null;
        }

        // Plan first and change nothing until every target input is known to exist.
        var inputs = Array.prototype.slice.call(
          this.container.querySelectorAll(this.singleOptionSelector)
        );
        var plan = [];
        for (var n = 1; n <= 3; n++) {
          var key = "option" + n;
          var want = best[key];
          var group = inputs.filter(function (i) {
            return i.dataset.index === key;
          });
          if (!group.length) {
            continue;
          }
          // Model guard: never move a Model pick the shopper did not tap (it would switch which product the part fits). Leave the old behavior there.
          if (
            key !== idx &&
            /^model$/i.test(String(group[0].getAttribute("name") || "").trim()) &&
            picks.some(function (o) {
              return o.index === key && o.value !== want;
            })
          ) {
            return null;
          }
          var found = false;
          group.forEach(function (i) {
            if (i.tagName === "SELECT") {
              if (
                Array.prototype.some.call(i.options, function (o) {
                  return o.value === want;
                })
              ) {
                found = true;
              }
            } else if (i.value === want) {
              found = true;
            }
          });
          if (!found) {
            return null;
          }
          plan.push({ group: group, want: want });
        }

        var moved = [];
        plan.forEach(function (p) {
          p.group.forEach(function (i) {
            if (i.tagName === "SELECT") {
              if (i.value !== p.want) {
                i.value = p.want;
                moved.push(i);
              }
            } else if (i.value === p.want) {
              if (!i.checked) {
                i.checked = true;
                moved.push(i);
              }
            } else if (i.checked) {
              i.checked = false;
            }
          });
        });

        return { variant: best, moved: moved, clicked: el };
      },

      // Setting .checked from code fires no change event, so tell the page about every input the snap moved
      // (guarded so this class ignores its own events), and announce the switch to screen readers with no layout change.
      _aoamSnapDone: function (snap) {
        this._aoamSnapping = true;
        try {
          snap.moved.forEach(function (i) {
            i.dispatchEvent(new Event("change", { bubbles: true }));
          });
        } catch (err) {
          /* never let the announcement break the picker */
        } finally {
          this._aoamSnapping = false;
        }

        try {
          var said = {};
          var parts = [];
          snap.moved.forEach(function (i) {
            if (i === snap.clicked) {
              return;
            }
            var line = (i.getAttribute("name") || "Option") + " to " + i.value;
            if (!said[line]) {
              said[line] = 1;
              parts.push(line);
            }
          });
          if (!parts.length) {
            return;
          }
          var live = document.getElementById("aoam-snap-live");
          if (!live) {
            live = document.createElement("div");
            live.id = "aoam-snap-live";
            live.setAttribute("role", "status");
            live.setAttribute("aria-live", "polite");
            live.style.cssText =
              "position:fixed;left:0;top:0;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;border:0";
            document.body.appendChild(live);
          }
          live.textContent =
            "Switched " + parts.join(" and ") + " so this combination is available.";
        } catch (err) {
          /* announcement is best effort */
        }
      },

      _onSelectChange: function (evt) {
        if (this._aoamSnapping) {
          return;
        }

        var variant = this._getVariantFromOptions();

        if (!variant) {
          var snap = null;
          try {
            snap = this._aoamSnap(evt);
          } catch (err) {
            snap = null;
          }
          if (snap) {
            variant = this._getVariantFromOptions();
            this._aoamSnapDone(snap);
          }
        }

        this.container.dispatchEvent(
          new CustomEvent("variantChange", {
            detail: {
              variant: variant,
            },
          })
        );

        document.dispatchEvent(
          new CustomEvent("variant:change", {
            detail: {
              variant: variant,
            },
          })
        );

        if (!variant) {
          return;
        }

        this._updateMasterSelect(variant);
        this._updateImages(variant);
        this._updatePrice(variant);
        this._updateUnitPrice(variant);
        this._updateSKU(variant);
        this.currentVariant = variant;

        if (this.enableHistoryState) {
          this._updateHistoryState(variant);
        }
        if(variant){
         let fp_compare_at_price = document.querySelector(".fp-compare-at-price");
         let fp_main_price = document.querySelector(".fp-main-price");
         let fp_discount_percentages = document.querySelectorAll(".fp-discount-percentage");
         if(!fp_compare_at_price || !fp_main_price){ return; }
         if(variant.compare_at_price){
          fp_compare_at_price.classList.remove("hide");
          fp_compare_at_price.innerHTML = Shopify.formatMoney(variant.compare_at_price)
          if (variant.compare_at_price > variant.price) {
            let discount_percentage = '';
            discount_percentage = Math.round(
              ((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price
            ) + '%';
            fp_discount_percentages.forEach((fp_discount_percentage)=>{
              fp_discount_percentage.innerText = discount_percentage;
              fp_discount_percentage.closest('.fp-discount-tagline')?fp_discount_percentage.closest('.fp-discount-tagline').classList.remove("hide"):'';
            })
          }
         }else{
          fp_compare_at_price.classList.add("hide");
          fp_discount_percentages.forEach((fp_discount_percentage)=>{
            fp_discount_percentage.closest('.fp-discount-tagline')?fp_discount_percentage.closest('.fp-discount-tagline').classList.add("hide"):'';
          })
         }
         fp_main_price.innerHTML = Shopify.formatMoney(variant.price);
        }
      },

      _updateImages: function (variant) {
        var variantImage = variant.featured_image || {};
        var currentVariantImage = this.currentVariant.featured_image || {};

        if (
          !variant.featured_image ||
          variantImage.src === currentVariantImage.src
        ) {
          return;
        }

        this.container.dispatchEvent(
          new CustomEvent("variantImageChange", {
            detail: {
              variant: variant,
            },
          })
        );
      },

      _updatePrice: function (variant) {
        if (
          variant.price === this.currentVariant.price &&
          variant.compare_at_price === this.currentVariant.compare_at_price
        ) {
          return;
        }

        this.container.dispatchEvent(
          new CustomEvent("variantPriceChange", {
            detail: {
              variant: variant,
            },
          })
        );
      },

      _updateUnitPrice: function (variant) {
        if (variant.unit_price === this.currentVariant.unit_price) {
          return;
        }

        this.container.dispatchEvent(
          new CustomEvent("variantUnitPriceChange", {
            detail: {
              variant: variant,
            },
          })
        );
      },

      _updateSKU: function (variant) {
        if (variant.sku === this.currentVariant.sku) {
          return;
        }

        this.container.dispatchEvent(
          new CustomEvent("variantSKUChange", {
            detail: {
              variant: variant,
            },
          })
        );
      },

      _updateHistoryState: function (variant) {
        if (!history.replaceState || !variant) {
          return;
        }

        var newurl =
          window.location.protocol +
          "//" +
          window.location.host +
          window.location.pathname +
          "?variant=" +
          variant.id;
        window.history.replaceState({ path: newurl }, "", newurl);
      },

      _updateMasterSelect: function (variant) {
        this.container.querySelector(this.originalSelectorId).value =
          variant.id;
        // Force a change event so Shop Pay installments works after a variant is changed
        this.container
          .querySelector(this.originalSelectorId)
          .dispatchEvent(new Event("change", { bubbles: true }));
      },
    });

    return Variants;
  })();

  window.vimeoApiReady = function () {
    theme.config.vimeoLoading = true;

    // Because there's no way to check for the Vimeo API being loaded
    // asynchronously, we use this terrible timeout to wait for it being ready
    checkIfVimeoIsReady().then(function () {
      theme.config.vimeoReady = true;
      theme.config.vimeoLoading = false;
      document.dispatchEvent(new CustomEvent("vimeoReady"));
    });
  };

  function checkIfVimeoIsReady() {
    var wait;
    var timeout;

    var deferred = new Promise((resolve, reject) => {
      wait = setInterval(function () {
        if (!Vimeo) {
          return;
        }

        clearInterval(wait);
        clearTimeout(timeout);
        resolve();
      }, 500);

      timeout = setTimeout(function () {
        clearInterval(wait);
        reject();
      }, 4000); // subjective. test up to 8 times over 4 seconds
    });

    return deferred;
  }

  theme.VimeoPlayer = (function () {
    var classes = {
      loading: "loading",
      loaded: "loaded",
      interactable: "video-interactable",
    };

    var defaults = {
      background: true,
      byline: false,
      controls: false,
      loop: true,
      muted: true,
      playsinline: true,
      portrait: false,
      title: false,
    };

    function VimeoPlayer(divId, videoId, options) {
      this.divId = divId;
      this.el = document.getElementById(divId);
      this.videoId = videoId;
      this.iframe = null;
      this.options = options;

      if (this.options && this.options.videoParent) {
        this.parent = this.el.closest(this.options.videoParent);
      }

      this.setAsLoading();

      if (theme.config.vimeoReady) {
        this.init();
      } else {
        theme.LibraryLoader.load("vimeo", window.vimeoApiReady);
        document.addEventListener("vimeoReady", this.init.bind(this));
      }
    }

    VimeoPlayer.prototype = Object.assign({}, VimeoPlayer.prototype, {
      init: function () {
        var args = defaults;
        args.id = this.videoId;

        this.videoPlayer = new Vimeo.Player(this.el, args);

        this.videoPlayer.ready().then(this.playerReady.bind(this));
      },

      playerReady: function () {
        this.iframe = this.el.querySelector("iframe");
        this.iframe.setAttribute("tabindex", "-1");

        this.videoPlayer.setMuted(true);

        this.setAsLoaded();

        // pause when out of view
        var observer = new IntersectionObserver(
          (entries, observer) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.play();
              } else {
                this.pause();
              }
            });
          },
          { rootMargin: "0px 0px 50px 0px" }
        );

        observer.observe(this.iframe);
      },

      setAsLoading: function () {
        if (!this.parent) return;
        this.parent.classList.add(classes.loading);
      },

      setAsLoaded: function () {
        if (!this.parent) return;
        this.parent.classList.remove(classes.loading);
        this.parent.classList.add(classes.loaded);
        if (Shopify && Shopify.designMode) {
          if (window.AOS) {
            AOS.refreshHard();
          }
        }
      },

      enableInteraction: function () {
        if (!this.parent) return;
        this.parent.classList.add(classes.interactable);
      },

      play: function () {
        if (this.videoPlayer && typeof this.videoPlayer.play === "function") {
          this.videoPlayer.play();
        }
      },

      pause: function () {
        if (this.videoPlayer && typeof this.videoPlayer.pause === "function") {
          this.videoPlayer.pause();
        }
      },

      destroy: function () {
        if (
          this.videoPlayer &&
          typeof this.videoPlayer.destroy === "function"
        ) {
          this.videoPlayer.destroy();
        }
      },
    });

    return VimeoPlayer;
  })();

  window.onYouTubeIframeAPIReady = function () {
    theme.config.youTubeReady = true;
    document.dispatchEvent(new CustomEvent("youTubeReady"));
  };

  /*============================================================================
  YouTube SDK method
  Parameters:
    - player div id (required)
    - arguments
    - videoId (required)
    - videoParent (selector, optional for section loading state)
    - events (object, optional)
  ==============================================================================*/
  theme.YouTube = (function () {
    var classes = {
      loading: "loading",
      loaded: "loaded",
      interactable: "video-interactable",
    };

    var defaults = {
      width: 1280,
      height: 720,
      playerVars: {
        autohide: 0,
        autoplay: 1,
        cc_load_policy: 0,
        controls: 0,
        fs: 0,
        iv_load_policy: 3,
        modestbranding: 1,
        playsinline: 1,
        rel: 0,
      },
    };

    function YouTube(divId, options) {
      this.divId = divId;
      this.iframe = null;

      this.attemptedToPlay = false;

      // API callback events
      defaults.events = {
        onReady: this.onVideoPlayerReady.bind(this),
        onStateChange: this.onVideoStateChange.bind(this),
      };

      this.options = Object.assign({}, defaults, options);
      // console.log(this.options);

      if (this.options) {
        if (this.options.videoParent) {
          this.parent = document
            .getElementById(this.divId)
            .closest(this.options.videoParent);
        }

        // Most YT videos will autoplay. If in product media,
        // will handle in theme.Product instead
        if (!this.options.autoplay) {
          this.options.playerVars.autoplay = this.options.autoplay;
        }

        if (this.options.style === "sound") {
          this.options.playerVars.controls = 1;
          this.options.playerVars.autoplay = 0;
        }
      }

      this.setAsLoading();

      if (theme.config.youTubeReady) {
        this.init();
      } else {
        theme.LibraryLoader.load("youtubeSdk");
        document.addEventListener("youTubeReady", this.init.bind(this));
      }
    }

    YouTube.prototype = Object.assign({}, YouTube.prototype, {
      init: function () {
        this.videoPlayer = new YT.Player(this.divId, this.options);
      },

      onVideoPlayerReady: function (evt) {
        this.iframe = document.getElementById(this.divId); // iframe once YT loads
        this.iframe.setAttribute("tabindex", "-1");

        if (this.options.style !== "sound") {
          evt.target.mute();
        }

        // pause when out of view
        var observer = new IntersectionObserver(
          (entries, observer) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.play();
              } else {
                this.pause();
              }
            });
          },
          { rootMargin: "0px 0px 50px 0px" }
        );

        observer.observe(this.iframe);
      },

      onVideoStateChange: function (evt) {
        switch (evt.data) {
          case -1: // unstarted
            // Handle low power state on iOS by checking if
            // video is reset to unplayed after attempting to buffer
            if (this.attemptedToPlay) {
              this.setAsLoaded();
              this.enableInteraction();
            }
            break;
          case 0: // ended, loop it
            this.play(evt);
            break;
          case 1: // playing
            this.setAsLoaded();
            break;
          case 3: // buffering
            this.attemptedToPlay = true;
            break;
        }
      },

      setAsLoading: function () {
        if (!this.parent) return;
        this.parent.classList.add(classes.loading);
      },

      setAsLoaded: function () {
        if (!this.parent) return;
        this.parent.classList.remove(classes.loading);
        this.parent.classList.add(classes.loaded);
        if (Shopify && Shopify.designMode) {
          if (window.AOS) {
            AOS.refreshHard();
          }
        }
      },

      enableInteraction: function () {
        if (!this.parent) return;
        this.parent.classList.add(classes.interactable);
      },

      play: function () {
        if (
          this.videoPlayer &&
          typeof this.videoPlayer.playVideo === "function"
        ) {
          this.videoPlayer.playVideo();
        }
      },

      pause: function () {
        if (
          this.videoPlayer &&
          typeof this.videoPlayer.pauseVideo === "function"
        ) {
          this.videoPlayer.pauseVideo();
        }
      },

      destroy: function () {
        if (
          this.videoPlayer &&
          typeof this.videoPlayer.destroy === "function"
        ) {
          this.videoPlayer.destroy();
        }
      },
    });

    return YouTube;
  })();

  /**
   * Ajax Renderer
   * -----------------------------------------------------------------------------
   * Render sections without reloading the page.
   * @param {Object[]} sections - The section to update on render.
   * @param {string} sections[].sectionId - The ID of the section from Shopify.
   * @param {string} sections[].nodeId - The ID of the DOM node to replace.
   * @param {Function} sections[].onReplace (optional) - The custom render function.
   * @param {string[]} preserveParams - The param name to preserve in the URL.
   * @param {boolean} debug - Output logs to console for debugging.
   *
   */

  theme.AjaxRenderer = (function () {
    function AjaxRenderer({ sections, preserveParams, onReplace, debug } = {}) {
      this.sections = sections || [];
      this.preserveParams = preserveParams || [];
      this.cachedSections = [];
      this.onReplace = onReplace;
      this.debug = Boolean(debug);
    }

    AjaxRenderer.prototype = Object.assign({}, AjaxRenderer.prototype, {
      renderPage: function (basePath, searchParams, updateURLHash = true) {
        if (searchParams) this.appendPreservedParams(searchParams);

        const sectionRenders = this.sections.map((section) => {
          const url = `${basePath}?section_id=${section.sectionId}&${searchParams}`;
          const cachedSectionUrl = (cachedSection) => cachedSection.url === url;

          return this.cachedSections.some(cachedSectionUrl)
            ? this.renderSectionFromCache(cachedSectionUrl, section)
            : this.renderSectionFromFetch(url, section);
        });

        if (updateURLHash) this.updateURLHash(searchParams);

        return Promise.all(sectionRenders);
      },

      renderSectionFromCache: function (url, section) {
        const cachedSection = this.cachedSections.find(url);

        this.log(
          `[AjaxRenderer] rendering from cache: url=${cachedSection.url}`
        );
        this.renderSection(cachedSection.html, section);
        return Promise.resolve(section);
      },

      renderSectionFromFetch: function (url, section) {
        this.log(`[AjaxRenderer] redering from fetch: url=${url}`);

        return new Promise((resolve, reject) => {
          fetch(url)
            .then((response) => response.text())
            .then((responseText) => {
              const html = responseText;
              this.cachedSections = [...this.cachedSections, { html, url }];
              this.renderSection(html, section);
              resolve(section);
            })
            .catch((err) => reject(err));
        });
      },

      renderSection: function (html, section) {
        this.log(
          `[AjaxRenderer] rendering section: section=${JSON.stringify(section)}`
        );

        const newDom = new DOMParser().parseFromString(html, "text/html");
        if (this.onReplace) {
          this.onReplace(newDom, section);
        } else {
          if (typeof section.nodeId === "string") {
            document.getElementById(section.nodeId).innerHTML =
              newDom.getElementById(section.nodeId).innerHTML;
          } else {
            section.nodeId.forEach((id) => {
              document.getElementById(id).innerHTML =
                newDom.getElementById(id).innerHTML;
            });
          }
        }

        return section;
      },

      appendPreservedParams: function (searchParams) {
        this.preserveParams.forEach((paramName) => {
          const param = new URLSearchParams(window.location.search).get(
            paramName
          );

          if (param) {
            this.log(`[AjaxRenderer] Preserving ${paramName} param`);
            searchParams.append(paramName, param);
          }
        });
      },

      updateURLHash: function (searchParams) {
        history.pushState(
          {},
          "",
          `${window.location.pathname}${searchParams && "?".concat(searchParams)
          }`
        );
      },

      log: function (...args) {
        if (this.debug) {
          console.log(...args);
        }
      },
    });

    return AjaxRenderer;
  })();

  theme.Cart = {
    getCart: function () {
      var url = "".concat(theme.routes.cart, "?t=").concat(Date.now());
      return fetch(url, {
        credentials: "same-origin",
        method: "GET",
      }).then((response) => response.json());
    },

    getCartProductMarkup: function () {
      var url = "".concat(theme.routes.cartPage, "?t=").concat(Date.now());

      url = url.indexOf("?") === -1 ? url + "?view=ajax" : url + "&view=ajax";

      return fetch(url, {
        credentials: "same-origin",
        method: "GET",
      }).then(function (response) {
        return response.text();
      });
    },

    changeItem: function (key, qty) {
      var self = this;
      var run = function () {
        return self._updateCart({
          url: "".concat(theme.routes.cartChange, "?t=").concat(Date.now()),
          data: JSON.stringify({
            id: key,
            quantity: qty,
          }),
        });
      };
      // 2026-11-03 cart audit B-007 (Claude, W1a): +/- writes join the same write queue as the merged add and the
      // duplicate-line collapse (aoam-cart-fix.js aoamSerialize, which has a 12s deadline), so an absolute quantity
      // written from a stale read cannot land between them. Rollback: return run();
      return (typeof window.aoamSerializeCartWrite === "function") ? window.aoamSerializeCartWrite(run) : run();
    },

    _updateCart: function (params) {
      return fetch(params.url, {
        method: "POST",
        body: params.data,
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
      })
        .then((response) => response.json())
        .then(function (cart) {
          return cart;
        });
    },

    updateAttribute: function (key, value) {
      return this._updateCart({
        url: "/cart/update.js",
        data: JSON.stringify({
          attributes: {
            [key]: theme.Cart.attributeToString(value),
          },
        }),
      });
    },

    updateNote: function (note) {
      return this._updateCart({
        url: "/cart/update.js",
        data: JSON.stringify({
          note: theme.Cart.attributeToString(note),
        }),
      });
    },

    attributeToString: function (attribute) {
      if (typeof attribute !== "string") {
        attribute += "";
        if (attribute === "undefined") {
          attribute = "";
        }
      }
      return attribute.trim();
    },
  };

  /*============================================================================
    HeaderCart
  ==============================================================================*/
  theme.HeaderCart = (function () {
    var selectors = {
      cart: "[data-header-cart]",
      cartTrigger: "[data-header-cart-trigger]",

      closeBtn: ".js-close-header-cart",
      noteBtn: "[data-cart-notes]",
    };

    var classes = {
      hidden: "hide",
    };

    var config = {
      cartOpen: false,
      namespace: ".cart-header",
    };

    function HeaderCart() {
      this.wrapper = document.querySelector(selectors.cart);
      if (!this.wrapper) {
        return;
      }
      this.trigger = document.querySelector(selectors.cartTrigger);
      this.noteBtn = this.wrapper.querySelector(selectors.noteBtn);
      this.form = this.wrapper.querySelector("form");

      // Close header cart
      document.addEventListener("MobileNav:open", this.close.bind(this));
      document.addEventListener("ModalOpen", this.close.bind(this));

      this.init();
    }

    HeaderCart.prototype = Object.assign({}, HeaderCart.prototype, {
      init: function () {
        this.cartForm = new theme.CartForm(this.form);
        this.cartForm.buildCart();

        document.querySelectorAll(selectors.closeBtn).forEach((btn) => {
          btn.addEventListener(
            "click",
            function () {
              this.close();
            }.bind(this)
          );
        });

        if (this.noteBtn) {
          this.noteBtn.addEventListener(
            "click",
            function () {
              this.noteBtn.classList.toggle("is-active");
              this.wrapper
                .querySelector(".cart__note")
                .classList.toggle("hide");
            }.bind(this)
          );
        }

        document.addEventListener(
          "ajaxProduct:added",
          function (evt) {
            this.cartForm.buildCart();
            /* 2026-10-11 (Claude): a shopper who shut the cart mid-add wins (aoam-cart-fix-2 __aoamCloseHolds), so the landing add no longer slides it back in. */
            if (!config.cartOpen && !(window.__aoamCloseHolds && window.__aoamCloseHolds())) {
              this.open();
            }
          }.bind(this)
        );

        // Dev-friendly way to open cart
        document.addEventListener("cart:open", this.open.bind(this));
        document.addEventListener("cart:close", this.close.bind(this));
      },

      open: function (evt) {
        if (evt) {
          evt.preventDefault();
        }

        theme.a11y.lockMobileScrolling(config.namespace);

        // Esc closes cart popup
        window.on(
          "keyup" + config.namespace,
          function (evt) {
            if (evt.keyCode === 27) {
              this.close();
            }
          }.bind(this)
        );

        document.dispatchEvent(new CustomEvent("CartDrawer:open"));
        document.dispatchEvent(new CustomEvent("drawerOpen"));

        // Clicking out of cart closes it. Timeout to prevent immediate bubbling
        setTimeout(
          function () {
            window.on(
              "click" + config.namespace,
              function (evt) {
                this.close(evt);
              }.bind(this)
            );
          }.bind(this),
          0
        );

        config.cartOpen = true;
      },

      close: function (evt) {
        // Do not close if click event came from inside drawer
        if (
          evt &&
          evt.target.closest &&
          evt.target.closest(".site-header__drawer")
        )
          return;

        if (!config.cartOpen) {
          return;
        }

        // If custom event, close without transition
        if (evt && evt.type === "MobileNav:open") {
          this.wrapper.classList.remove("is-active");
        } else {
          theme.utils.prepareTransition(
            this.wrapper,
            function () {
              this.wrapper.classList.remove("is-active");
            }.bind(this)
          );
        }

        window.off("keyup" + config.namespace);
        window.off("click" + config.namespace);

        theme.a11y.unlockMobileScrolling(config.namespace);

        config.cartOpen = false;
      },
    });

    return HeaderCart;
  })();

  theme.QuickAdd = (function () {

    var selectors = {
      quickAddBtn: "[data-quick-addbutton]",
      quickLoadForm: "[data-quick-loadform]",
      quickLoadHolder: "#QuickLoadHolder",
    };

    var modal;
    var modalInitailized = false;

    function QuickAdd(container) {
      if (!container) {
        return;
      }

      if (!theme.settings.quickAdd) {
        return;
      }

      this.container = container;
      this.init();
    }

    QuickAdd.prototype = Object.assign({}, QuickAdd.prototype, {
      // init: function () {
      //   // When a single variant, auto add it to cart
      //   var quickAddBtns = this.container.querySelectorAll(
      //     selectors.quickAddBtn
      //   );
      //   if (quickAddBtns) {
      //     quickAddBtns.forEach((btn) => {
      //       btn.addEventListener("click", this.addToCart.bind(this));
      //     });
      //   }

      //   // Button loads form when 1+ variants
      //   var quickLoadForms = this.container.querySelectorAll(
      //     selectors.quickLoadForm
      //   );
      //   console.log("quickLoadForms",quickLoadForms);

      //   if (quickLoadForms.length) {
      //     this.quickLoadHolder = document.querySelector(
      //       selectors.quickLoadHolder
      //     );
      //     if (!modalInitailized) {
      //       modal = new theme.Modals("QuickLoadModal", "quick-add");
      //       modalInitailized = true;

      //       // Empty cart form when closed
      //       document.addEventListener(
      //         "modalClose.QuickAddModal",
      //         function () {
      //           setTimeout(
      //             function () {
      //               this.quickLoadHolder.innerHTML = "";
      //             }.bind(this),
      //             300
      //           );
      //         }.bind(this)
      //       );
      //     }

      //     quickLoadForms.forEach((btn) => {
      //       btn.addEventListener("click", this.loadQuickLoadForm.bind(this));
      //     });
      //   }
      // },

      init: function () {
        //  Attach single variant quick add (direct add to cart)
        var quickAddBtns = document.querySelectorAll(selectors.quickAddBtn);
        if (quickAddBtns && quickAddBtns.length) {
          quickAddBtns.forEach((btn) => {
            btn.addEventListener("click", this.addToCart.bind(this));
          });
        }

        //  Initialize modal once globally
        if (!modalInitailized) {
          modal = new theme.Modals("QuickLoadModal", "quick-add");
          modalInitailized = true;

          document.addEventListener("modalClose.QuickAddModal", () => {
            setTimeout(() => {
              const holder = document.querySelector(selectors.quickLoadHolder);
              if (holder) holder.innerHTML = "";
            }, 300);
          });
        }

        // Attach click event to all quick load form buttons globally
        document.querySelectorAll(selectors.quickLoadForm).forEach((btn) => {
          btn.addEventListener("click", (evt) => {
            evt.preventDefault();
            evt.stopPropagation();

            const gridItem = btn.closest("[data-product-card]");
            if (!gridItem) {
              console.warn("No [data-product-card] found for button:", btn);
              return;
            }

            // prevent double popup
            if (btn.classList.contains("btn--loading")) return;
            btn.classList.add("btn--loading");

            // Create QuickAdd instance for this product
            const quickAddInstance = new QuickAdd(gridItem);
            quickAddInstance.quickLoadHolder = document.querySelector(selectors.quickLoadHolder);
            quickAddInstance.loadQuickLoadForm(evt);

            setTimeout(() => btn.classList.remove("btn--loading"), 1500);
          });
        });
      },
      
      addToCart: function (evt) {
        const _this = this;
        let button = evt.currentTarget;
        let variantId = button.dataset.id;

        button.classList.add("btn--loading");

        let productId = button.dataset.productId;
        // var data = {
        //   items: [
        //     {
        //       id: productId,
        //       quantity: 1,
        //     },
        //   ],
        // };


        const countryCode = document.documentElement.getAttribute('country');
        if (countryCode !== 'US') {
          if(productId == '6078153326755'){
            customNonUsRestricted();
            return;
          }
        }

        let itemData = {
          id: variantId,
          quantity: 1,
        };

        // Only for Quick Add
        if (button.hasAttribute("data-quick-addbutton")) {
          let properties = {};

          // Step 3: Read from the button’s dataset
          if (button.dataset._warranty_pro_des) {
            properties["_warranty_pro_des"] = button.dataset._warranty_pro_des;
          }
          if (button.dataset._warranty_pro_id) {
            properties["_warranty_pro_id"] = button.dataset._warranty_pro_id;
          }
          if (button.dataset._warranty_pro_price) {
            properties["_warranty_pro_price"] = button.dataset._warranty_pro_price;
          }

          if (button.dataset.relatedProduct) {
            properties["_related_product"] = button.dataset.relatedProduct;
          }

          if(button.dataset.product1){
            properties["_product_1"] = button.dataset.product1;
          }

          if(button.dataset.product2){
            properties["_product_2"] = button.dataset.product2;
          }

          // Add to item only if exists
          if (Object.keys(properties).length > 0) {
            itemData.properties = properties;
          }
        }

        // AOAM warranty fix (2026-06-19): the MAIN Add to Cart is not a quick-add button, so the
        // block above never ran and warranty items reached the cart with no _warranty_pro_* props
        // (price summed to 0, cart toggle disabled itself). product-form.liquid already renders
        // these as hidden inputs when the product has the custom.extended_warranty metafield; read
        // them off the button's own form so normally-added items carry the warranty data. The
        // theme's existing logic then auto-adds the warranty line + shows the toggle (opt-out).
        if (!button.hasAttribute("data-quick-addbutton")) {
          let _warrantyForm = button.closest("form");
          if (_warrantyForm) {
            let _warrantyProps = itemData.properties || {};
            ["_warranty_pro_des", "_warranty_pro_id", "_warranty_pro_price", "_related_product"].forEach(function (_k) {
              let _inp = _warrantyForm.querySelector('input[name="properties[' + _k + ']"]');
              if (_inp && _inp.value) { _warrantyProps[_k] = _inp.value; }
            });
            if (Object.keys(_warrantyProps).length > 0) { itemData.properties = _warrantyProps; }
          }
        }

        // Build payload
        const data = {
          items: [itemData],
        };

        fetch(theme.routes.cartAdd, {
          method: "POST",
          body: JSON.stringify(data),
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
          },
        })
          .then((response) => response.json())
          .then(
            function (data) {
              if (data.status === 422 || data.status === "bad_request") {
              } else {
                var product = data;
                document.dispatchEvent(
                  new CustomEvent("ajaxProduct:added", {
                    detail: {
                      product: product,
                      addToCartBtn: button,
                    },
                  })
                );
                Promise.resolve(null)
                .then(res => res)
                .then(productData => {
                  // console.log("productData",productData);
                });

                if (product.items && Array.isArray(product.items)) {
                  product = product.items[0]; // get the first added item
                }

                // Now product is guaranteed correct
                fetch(`/variants/${product.id}.js`)
                  .then(res => res.json())
                  .then(variantData => {
                    product.price = variantData.price;
                    product.compare_at_price = variantData.compare_at_price;
                    button.classList.remove("btn--loading");
                    addToCartPopup_fn(product);
                    
                  })
                  .catch(err => {
                    console.error("Error fetching variant details:", err);
                    button.classList.remove("btn--loading");
                    addToCartPopup_fn(product);
                  });
                  
                let productobj = data.items[0];
                let variantId = productobj.id;

                setTimeout(() => {
                  let warrantyBtn = document.querySelector(
                    `.cart__item_wrp[data-id="${variantId}"] .extended-warranty[data-extended-submit]`
                  );

                  if (warrantyBtn && warrantyBtn.dataset.inCart !== "true") {
                    // warrantyBtn.click();
                  }
                }, 2000);
                // updateExtendedWarranty();
              }
            }.bind(this)
          );
      },

      loadQuickLoadForm: function (evt) {
        this.quickLoadHolder.innerHTML = "";        
       const button_dev = evt.currentTarget;            
        button_dev.classList.add("btn--loading");
          setTimeout(() => {
            button_dev.classList.remove("btn--loading");
          }, 1000);
        var gridItem = evt.currentTarget.closest("[data-product-card]");
        var handle = gridItem.getAttribute("data-product-handle");
        var productId = gridItem.getAttribute("data-product-id");
        var url = theme.routes.home + "/products/" + handle + "?view=form";

        // remove double `/` in case shop might have /en or language in URL
        url = url.replace("//", "/");

        fetch(url)
          .then(function (response) {
            return response.text();
          })
          .then(
         // setTimeout(() => {
         //      evt.currentTarget.classList.remove("btn--loading")
         //  }, "5000");
            function (html) {
              var parser = new DOMParser();
              var doc = parser.parseFromString(html, "text/html");
              var html = doc.querySelector(
                '.product-section[data-product-handle="' + handle + '"]'
              );

              this.quickLoadHolder.append(html);
              // Register product template inside modal
              theme.sections.register(
                "product",
                theme.Product,
                this.quickLoadHolder
              );

              // if (Shopify && Shopify.PaymentButton) {
              // 	Shopify.PaymentButton.init();
              // }

              window.dispatchEvent(
                new CustomEvent("quickadd:loaded:" + productId)
              );

              document.dispatchEvent(
                new CustomEvent("quickadd:loaded", {
                  detail: {
                    productId: productId,
                    handle: handle,
                  },
                })
              );
              modal.open();
            }.bind(this)
     
          );
      },
    });

    return QuickAdd;
  })();

  theme.QuickShop = (function () {
    var loadedIds = [];
    var selectors = {
      product: "[data-product-card]",
      triggers: "[data-quick-shopbutton]",
      modalContainer: "#ProductModals",
    };

    function QuickShop(container) {
      if (!theme.settings.quickView) {
        return;
      }

      this.container = container;
      this.init();
    }

    function getData(el) {
      return {
        id: el.dataset.productId,
        handle: el.dataset.productHandle,
      };
    }

    function productMouseover(evt) {
      var el = evt.currentTarget;

      // No quick view on mobile breakpoint
      if (theme.config.bpSmall) {
        return;
      }

      // No product or onboarding content, bail
      if (!el || !el.dataset.productId) {
        return;
      }

      var data = getData(el);
      el.removeEventListener("mouseover", productMouseover);

      preloadProductModal(data);
    }

    function preloadProductModal(data) {
      var modals = document.querySelectorAll(
        '.modal--quick-shop[data-product-id="' + data.id + '"]'
      );

      if (!modals.length) {
        return;
      }

      // If already loaded, no need to refetch info
      if (loadedIds.indexOf(data.id) > -1) {
        removeDuplicateModals(modals);
        enableTriggers(data);
      } else {
        // Move modal to storage element so animations work regardless
        // of where original markup is. Will also remove duplicates.
        moveModal(modals);

        var holder = document.getElementById("QuickShopHolder-" + data.handle);
        var url =
          theme.routes.home + "/products/" + data.handle + "?view=modal";

        // remove double `/` in case shop might have /en or language in URL
        url = url.replace("//", "/");

        fetch(url)
          .then(function (response) {
            return response.text();
          })
          .then(function (html) {
            // Convert the HTML string into a document object
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, "text/html");
            var div = doc.querySelector(
              '.product-section[data-product-handle="' + data.handle + '"]'
            );

            if (!holder) {
              return;
            }

            holder.append(div);

            // Register product template inside quick view
            theme.sections.register("product", theme.Product, holder);

            // Register collapsible elements
            theme.collapsibles.init();

            // Register potential video modal links (when video has sound)
            theme.videoModal();

            // There may be multiple triggers for the same modal, so enable them all
            enableTriggers(data);
          });
      }

      // Add ID to global array so we don't double-load
      loadedIds.push(data.id);
    }

    function moveModal(modals) {
      var el = modals[0];
      if (!el) {
        return;
      }

      // If we have multiple modals, keep the first and remove all the rest
      if (modals.length > 1) {
        modals.forEach(function (m, i) {
          if (i > 0) {
            m.remove();
          }
        });
      }

      var container = document.querySelector(selectors.modalContainer);
      container.appendChild(el);
    }

    // Remove any modal not already in #ProductModals
    function removeDuplicateModals(modals) {
      if (modals.length > 1) {
        modals.forEach(function (m, i) {
          if (!m.closest("#ProductModals")) {
            m.remove();
          }
        });
      }
    }

    function enableTriggers(data) {
      // Setup quick view modal
      var modalId = "QuickShopModal-" + data.id;
      var name = "quick-modal-" + data.id;
      new theme.Modals(modalId, name);

      var triggers = document.querySelectorAll(
        selectors.triggers + '[data-handle="' + data.handle + '"]'
      );

      if (!triggers.length) {
        return;
      }

      triggers.forEach((trigger) => {
        trigger.classList.remove("quick-product__btn--not-ready");
      });
    }

    QuickShop.prototype = Object.assign({}, QuickShop.prototype, {
      init: function () {
        var products = this.container.querySelectorAll(selectors.product);

        if (!products.length) {
          return;
        }

        products.forEach((product) => {
          product.addEventListener("mouseover", productMouseover);
        });
      },
    });

    return QuickShop;
  })();

/*============================================================================
CartForm
- Prevent checkout when terms checkbox exists
- Listen to quantity changes, rebuild cart (both widget and page)
  ==============================================================================*/
theme.CartForm = (function () {
  var selectors = {
    products: "[data-products]",
    discounts: "[data-discounts]",
    savings: "[data-savings]",
    subTotal: "[data-subtotal]",
    qtySelector: ".js-qty__wrapper",
    devdiscount: "[data-dev-discount]",
    cartBubble: ".cart-link__bubble",
    cartNote: '[name="note"]',
    termsCheckbox: ".cart__terms-checkbox",
    checkoutBtn: ".btn-cart__checkout",
    progressBar: "[data-progress-selector]",
  };

  var classes = {
    btnLoading: "btn--loading",
  };

  var config = {
    requiresTerms: false,
  };

  function CartForm(form) {
    if (!form) {
      return;
    }

    this.form = form;
    this.wrapper = form.parentNode;

    this.location = form.dataset.location;
    this.namespace = ".cart-" + this.location;
    this.products = form.querySelector(selectors.products);
    this.submitBtn = form.querySelector(selectors.checkoutBtn);
    this.discounts = form.querySelector(selectors.discounts);
    this.savings = form.querySelector(selectors.savings);
    this.subtotal = form.querySelectorAll(selectors.subTotal);
    this.progressSelect = form.querySelectorAll(selectors.progressBar);
    this.termsCheckbox = form.querySelector(selectors.termsCheckbox);
    this.noteInput = form.querySelector(selectors.cartNote);
    this.devdiscount = form.querySelector(selectors.devdiscount);

    if (this.termsCheckbox) {
      config.requiresTerms = true;
    }

    this.init();
  }

  CartForm.prototype = Object.assign({}, CartForm.prototype, {
    init: function () {
      this.initQtySelectors();
      this.initDeleteProduct();
      // DISABLED FOR CONVERSION FIX
      this.addExtendeWarranty();

      document.addEventListener(
        "cart:quantity" + this.namespace,
        this.quantityChanged.bind(this)
      );
      document.addEventListener(
        "cart:delete" + this.namespace,
        this.deleteProduct.bind(this)
      );
      this.form.on("submit" + this.namespace, this.onSubmit.bind(this));

      if (this.noteInput) {
        this.noteInput.addEventListener("change", function () {
          var newNote = this.value;
          theme.Cart.updateNote(newNote);
        });
      }

      document.addEventListener(
        "cart:build",
        function () {
          this.buildCart();
        }.bind(this)
      );
    },

    reInit: function () {
      this.initQtySelectors();
      this.initDeleteProduct();
      // DISABLED FOR CONVERSION FIX
      this.addExtendeWarranty();
    },

    onSubmit: function (evt) {
      this.submitBtn.classList.add(classes.btnLoading);

      if (config.requiresTerms) {
        if (this.termsCheckbox.checked) {
          // continue to checkout
        } else {
          this.submitBtn.classList.remove(classes.btnLoading);
          this.form.querySelector(".text-label__terms").style =
            "border-color: #d41010";
          evt.preventDefault();
          return false;
        }
      }
    },
      /*============================================================================
        Query cart page to get markup
      ==============================================================================*/
      _parseProductHTML: function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, "text/html");
        return {
          items: doc.querySelector(".cart__items"),
          discounts: doc.querySelector(".cart-discounts"),
          progress: doc.querySelector("[data-progress-selector]"),
          devdiscount: doc.querySelector("[data-dev-discount]"),
        };
      },

      buildCart: function () {
        // 2026-08-06 - Clarity/GA4 error-click sweep. A cart refresh over a flaky mobile
        // connection rejects ("Load failed" on iOS Safari) and surfaced as an uncaught
        // promise rejection on every PDP add-to-cart that raced a dropped connection.
        // Nothing to recover: the drawer keeps its last markup. Delete the catch to roll back.
        theme.Cart.getCartProductMarkup().then(this.cartMarkup.bind(this)).catch(function () {});

      },

      cartMarkup: function (html) {

        var markup = this._parseProductHTML(html);
        var items = markup.items;
        // 2026-08-06 - same sweep. When /cart?view=ajax comes back as anything but the cart
        // partial (a 429 throttle page, a bot challenge, an error page), .cart__items is
        // absent and items.dataset threw "null is not an object" mid add-to-cart, reproduced
        // headless under a real Shopify 429. Keep the previous markup instead. Delete this
        // guard to roll back.
        if (!items) { return; }
        var count = parseInt(items.dataset.count);
        var savings = items.dataset.cartSavings;
        var subtotal = items.dataset.cartSubtotal;
        //var discountTotal = items.dataset.discountTotal;
        this.updateCartDiscounts(markup.discounts);
        this.updateSavings(savings);
        // this.updateCartdevdiscount(markup.devdiscount);
        // 2026-08-16 (Claude) - write the PRE-DISCOUNT subtotal here, where the freshly fetched ajax
        // markup is in hand and cannot be stale. This is the only writer of .total_com_price that is
        // guaranteed to be looking at the current cart; updateCompareTotal() re-derives it from
        // /cart.js and aoam-cart-fix re-derives it again, and both defer to the same attribute.
        try {
          var cmpTotal = parseInt(items.dataset.compareTotal, 10);
          if (isFinite(cmpTotal)) {
            var cmpText = formatMoneyNoTrailing(cmpTotal);
            document.querySelectorAll('.total_com_price').forEach(function (el) { el.textContent = cmpText; });
          }
        } catch (e) {}
        if (count > 0) {
          this.wrapper.classList.remove("is-empty");
        } else {
          this.wrapper.classList.add("is-empty");
        }
        this.updateCount(count);

        // Append item markup
        this.products.innerHTML = ""; 
        this.products.append(items);

        // Update subtotal - with decimal pricing with ex. Rs, 1200.00
        // this.subtotal.forEach((subItem) => {
        //   console.log("subItem",subItem);
        //   subItem.innerHTML = theme.Currency.formatMoney(
        //     subtotal,
        //     theme.settings.moneyFormat
        //   );
        // });

        // Update subtotal - Without decimal pricing with ex. Rs, 1200
        // this.subtotal.forEach((subItem) => {
        //   let formattedPrice = theme.Currency.formatMoney(
        //     subtotal,
        //     theme.settings.moneyFormat
        //   );

        //   // Remove trailing .00
        //   formattedPrice = formattedPrice.replace(/\.00$/, '');
        //   console.log("UPDATING");
        //   subItem.innerHTML = formattedPrice;
        // });

        // 2026-07-28 - Joel issue sweep: markup.progress is null for every non-US visitor. The
        // [data-progress-selector] free-shipping block in cart.ajax.liquid is wrapped in
        // {% if localization.country.iso_code == 'US' %}, so a non-US cart partial has no progress
        // element. Reading .innerHTML on null threw an uncaught promise rejection (buildCart's
        // getCartProductMarkup().then(cartMarkup) has no catch) on every cart update, the single
        // largest own-code js_error in GA4 (~138 in 7 days). Guard it: only sync the progress UI
        // when the markup actually carries it. Delete this guard (restore the bare lines) to roll back.
        if (markup.progress) {
          var progressHtml = markup.progress.innerHTML;
          var messageEl = markup.progress.querySelector("[data-message]");
          var messageHtml = messageEl ? messageEl.innerHTML : "";
          if(document.querySelector("[data-message-bottom]")){
            document.querySelector("[data-message-bottom]").innerHTML =messageHtml;
          }
          if(document.querySelector("[data-progress-selector]")){
          document.querySelector("[data-progress-selector]").innerHTML =  progressHtml;
          }
        }
        
        // const shippingLink = document.querySelector(".text-link__shipping");

        // shippingLink.classList.remove("hide");
        // if (subtotal > 14900) {
        //   shippingLink.classList.add("hide");
        // }

        this.reInit();

        if (Shopify && Shopify.StorefrontExpressButtons) {
          Shopify.StorefrontExpressButtons.initialize();
        }
      },       
      updateCartDiscounts: function (markup) {
       
        if (!this.discounts) {
          return;
        }
        this.discounts.innerHTML = "";
        this.discounts.append(markup);
      },
      updateCartdevdiscount: function (markup) {        
        if (!this.devdiscount) {
          return;
        }
        this.devdiscount.innerHTML = "";
        this.devdiscount.append(markup);
      },

      /*============================================================================
        Quantity handling
      ==============================================================================*/
      initQtySelectors: function () {
        this.form.querySelectorAll(selectors.qtySelector).forEach((el) => {
          var selector = new theme.QtySelector(el, {
            namespace: this.namespace,
            isCart: true,
          });
        });
      },

      initDeleteProduct: function () {
        this.form.querySelectorAll("[data-remove-product]").forEach((el) => {
          var selector = new theme.DeleteProduct(el, {
            namespace: this.namespace,
            isCart: true,
            key: el.dataset.key,
          });
        });
      },

      quantityChanged: function (evt) {
        var key = evt.detail[0];
        var qty = evt.detail[1];
        var el = evt.detail[2];

        if (!key || qty == null || Number.isNaN(qty)) {
          return;
        }

        // Disable qty selector so multiple clicks can't happen while loading
        if (el) {
          // Only qty 0 - minus pressed at 1, or 0 typed into the field - which silently deletes
          // the line over a 1-3s write. An ordinary +/- stays optimistic and gets no wheel.
          // QtySelector._change clamps to the min ATTRIBUTE, so 0 arrives here as the STRING "0"
          // and cannot be compared with ===.
          if (Number(qty) === 0) el.classList.add("is-loading");
        }
        // 2026-10-10 audit: serialize +/- writes per line. Parallel absolute change.js POSTs are last-finisher-wins, so a fast burst on a slow connection could end on a stale quantity. One request per line at a time; taps made meanwhile only update st.want, and the newest want is sent when the in-flight one lands. A stale response paints nothing. Delete this block, the two st checks below and the self var to roll back.
        var self = this;
        var qSt = this._qSer || (this._qSer = {});
        var st = qSt[key] || (qSt[key] = { busy: false, want: null });
        st.want = qty;
        if (st.busy) return;
        st.busy = true;
        theme.Cart.changeItem(key, qty)
          .then(
            function (cart) {
              st.busy = false;
              // 2026-11-03 cart audit F-002 / F-010 (Claude, W1a): a refused write (error body, no item_count) drops any
              // tap queued behind it (its absolute quantity was counted from the refused number) and puts the box back
              // to the cart's real quantity, then the existing notice / rebuild below runs.
              if (!cart || typeof cart.item_count !== "number") { st.want = qty; aoamQtyFailed(key, el, !!(cart && (cart.description || cart.message))); }
              else aoamQtyOk(key, cart);
              if (String(st.want) !== String(qty)) {
                // 2026-10-10 audit: a newer tap is waiting, so skip this stale paint and send the newest quantity
                var nextQty = st.want;
                self.quantityChanged({ detail: [key, nextQty, el] });
                return;
              }
              st.want = null;
              if (el) el.classList.remove("is-loading");
              // 2026-08-09 - same defect class as deleteProduct below: a /cart/change error body
              // (400/404 JSON) has no item_count, so the else-branch stamped is-empty over a
              // NON-empty cart. Resync the drawer instead of trusting it. Delete to roll back.
              if (!cart || typeof cart.item_count !== "number") {
                // 2026-09-28 cart-fix-l low-drawer-logic C121: a refused +/- (422 'Only 2 items were added...') is now read out to screen readers. Nothing visible changes. Delete to roll back.
                try { if (cart && (cart.description || cart.message) && typeof window.aoamCartAnnounce === "function") window.aoamCartAnnounce(cart.description || cart.message); } catch (e) {}
                // 2026-09-28 cart-fix-l visual-site-low C121: and shows it under that row for 4 seconds (drawer-cart.liquid notice). Delete to roll back.
                try { if (cart && (cart.description || cart.message) && typeof window.aoamDrawerNotice === "function") window.aoamDrawerNotice(String(cart.description || cart.message), { key: key, ms: 4000, silent: true }); } catch (e) {}
                document.dispatchEvent(new CustomEvent("ajaxProduct:added", { detail: {} }));
                return;
              }
              if (cart.item_count > 0) {
                this.wrapper.classList.remove("is-empty");
              } else {
                this.wrapper.classList.add("is-empty");
              }

              // this.buildCart();

              document.dispatchEvent(
                new CustomEvent("cart:updated", {
                  detail: {
                    cart: cart,
                  },
                })
              );
              
              let protection_product_checkbox = document.querySelector('.protection_product_checkbox');
              if(localStorage.getItem('warranty_toogle_is_disable_by_user') == 'false' /* 2026-09-24 opt-in: a missing flag is OFF now */){
                update_protection_products('Update');
              }else{
                update_protection_total_price();
              }

            }.bind(this)
          )
          .catch(function (XMLHttpRequest) { 
            // 2026-10-10 audit: network failure of a serialized write.
            // 2026-11-03 cart audit F-002 / F-010 (Claude, W1a): a newer tap queued behind a FAILED write is dropped, not
            // sent: its absolute quantity was counted from the box's unconfirmed number, which is how one offline plus
            // and one plus took the cart from 1 to 3. The box goes back to the cart's real quantity and a short line under
            // the row says so. Rollback: restore the wasBusy re-send line and delete aoamQtyFailed.
            st.busy = false;
            aoamQtyFailed(key, el, false);
            st.want = null;
            if (el) el.classList.remove("is-loading");
            document.dispatchEvent(new CustomEvent("ajaxProduct:added", {detail: {}}));
            let protection_product_checkbox = document.querySelector('.protection_product_checkbox');
            if(localStorage.getItem('warranty_toogle_is_disable_by_user') == 'false' /* 2026-09-24 opt-in: a missing flag is OFF now */){
              update_protection_products('Update');
            }else{
              update_protection_total_price();
            }
          });
      },

      deleteProduct: function (evt) {
        var key = evt.detail[0];
        var qty = evt.detail[1];
        var el = evt.detail[2];

        if (!key) {
          return;
        }

        theme.Cart.changeItem(key, qty)
          .then(
            function (cart) {
              // 2026-08-09 - Joel: "spinning wheel on the trash can and it doesn't delete then
              // the cart just clears and says its empty". Two defects, both reproduced headless:
              // (1) nothing here rebuilt the drawer, so the removed line stayed on screen with
              // the spinner stuck (the only rebuild path was the warranty writer's
              // ajaxProduct:added, which no-ops on carts with no warranty line), and (2) clicking
              // that stale trash again got a 400 error body whose missing item_count made the
              // else-branch stamp is-empty over a NON-empty cart. Fix: treat a body with no
              // numeric item_count as a failure, and always rebuild through the theme's own
              // ajaxProduct:added -> HeaderCart.buildCart, the exact event the catch below
              // already uses. Delete this guard and the dispatch to roll back.
              if (!cart || typeof cart.item_count !== "number") {
                if (el && el.classList) el.classList.remove("btn--loading");
                document.dispatchEvent(new CustomEvent("ajaxProduct:added", { detail: {} }));
                return;
              }
              if (cart.item_count > 0) {
                this.wrapper.classList.remove("is-empty");
              } else {
                this.wrapper.classList.add("is-empty");
              }

              document.dispatchEvent(new CustomEvent("ajaxProduct:added", { detail: {} }));

              document.dispatchEvent(
                new CustomEvent("cart:updated", {
                  detail: {
                    cart: cart,
                  },
                })
              );
              checkaddon_product();
              let protection_product_checkbox = document.querySelector('.protection_product_checkbox');
              if(localStorage.getItem('warranty_toogle_is_disable_by_user') == 'false' /* 2026-09-24 opt-in: a missing flag is OFF now */){
                  update_protection_products('Update');
              }else{
                update_protection_total_price();
              }
            }.bind(this)
          )
          .catch(function (XMLHttpRequest) {
              if (el && el.classList) el.classList.remove("btn--loading"); // 2026-08-09 fix, see above
              document.dispatchEvent(new CustomEvent("ajaxProduct:added", {detail: {}}));
              checkaddon_product();
              let protection_product_checkbox = document.querySelector('.protection_product_checkbox');
              if(localStorage.getItem('warranty_toogle_is_disable_by_user') == 'false' /* 2026-09-24 opt-in: a missing flag is OFF now */){
                  update_protection_products('Update');
              }else{
                update_protection_total_price();
              }
           });
      },

      /*============================================================================
        Update elements of the cart
      ==============================================================================*/
      updateSubtotal: function (subtotal) {
        this.form.querySelector(selectors.subTotal).innerHTML =
          theme.Currency.formatMoney(subtotal, theme.settings.moneyFormat);
      },

      updateSavings: function (savings) {
        // console.log("theme.settings.moneyFormat",theme.settings.moneyFormat);
        if (!this.savings) {
          return;
        }
        // 2026-08-16 (Claude) - TWO CLASS NAMES HIDE THIS ROW AND THIS FUNCTION ONLY KNEW ONE.
        // Liquid renders it with `hidden` (drawer-cart.liquid, main-cart.liquid) and
        // toggleOrderDiscountVisibility() adds/removes `hidden`; this function used only `hide`.
        // So removing `hide` here could not reveal a row that some earlier pass had marked `hidden`,
        // and the savings stayed invisible even once the number reaching it was correct. Both names
        // are cleared and both are set, so whichever writer ran last, the row agrees with the figure.
        var row = this.savings.closest('.cart-item__savings');
        if (savings > 0) {
          var amount = theme.Currency.formatMoney(
            savings,
            theme.settings.moneyFormat
          );
          this.savings.innerHTML = amount;
          this.savings.setAttribute('cus-discount', amount);
          if (row) row.classList.remove("hide", "hidden");
        } else {
          this.savings.setAttribute('cus-discount', theme.Currency.formatMoney(0, theme.settings.moneyFormat));
          if (row) row.classList.add("hide");
        }
      },


    addExtendeWarranty: function () {
      const buttonExtendedWarranty = document.querySelectorAll(
        '.extended-warranty[data-extended-submit]'
      );

       // Get cart on page load
      fetch('/cart.js')
        // 2026-08-06 - Clarity/GA4 error-click sweep. A throttled /cart.js returns an HTML 429
        // page (or a bot-challenge page), so res.json() threw "Unexpected token '<'". Leave the
        // warranty buttons unbound for this page load instead, which is what the old catch below
        // already did on a network failure. Restore the bare res.json() chain to roll back.
        .then(res => (res.ok ? res.json() : null))
        .then(cart => {
          if (!cart || !Array.isArray(cart.items)) { return; }
          buttonExtendedWarranty.forEach((btn) => {

            // Prevent duplicate event binding
            if (btn.dataset.bound === "true") return;
            btn.dataset.bound = "true";

            const warrantyVariantID = parseInt(btn.dataset.product, 10);
            const parentProductHandle = btn.dataset.parentProduct;
            const parentQuantity = parseInt(btn.dataset.parentQuantity, 10);
            const parentTitle = btn.dataset.parentTitle;

            // Check if warranty already exists for this parent product
            let matchingWarranty = cart.items.find(item =>
              item.id === warrantyVariantID &&
              item.properties &&
              item.properties['Extended Warranty'] === parentProductHandle
            );

            btn.dataset.inCart = matchingWarranty ? "true" : "false";

            btn.addEventListener('click', (e) => {
              e.preventDefault();
              // console.log("Btn clicked...");

              // Prevent double click
              if (btn.classList.contains('is-processing')) return;
              btn.classList.add('is-processing');

              // ================= REMOVE WARRANTY =================
              if (btn.dataset.inCart === "true") {
                if (!matchingWarranty) {
                  btn.classList.remove('is-processing');
                  return;
                }

                const formData = {
                  updates: {
                    [matchingWarranty.key]: 0
                  }
                };

                fetch('/cart/update.js', {
                  method: "POST",
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify(formData)
                })
                  // 2026-08-06 - Clarity/GA4 error-click sweep. A throttled /cart/update.js
                  // returns an HTML 429 page, so res.json() threw "Unexpected token '<'", and a
                  // JSON error body (422) was being treated as a successful removal. Route both
                  // to the catch below so the button keeps its real in-cart state. Restore the
                  // bare res.json() chain to roll back.
                  .then(res => {
                    if (!res.ok) { throw new Error('cart/update.js ' + res.status); }
                    return res.json();
                  })
                  .then(() => {
                    btn.dataset.inCart = "false";
                    btn.closest(".cart__item_wrp")
                      ?.querySelector(".cart__item")
                      ?.classList.remove("has-extended-product");

                     document.dispatchEvent(new CustomEvent("ajaxProduct:added", {detail: {}}));

                    setTimeout(()=>{
                      updateCompareTotal();
                    },1000);

                    // if(document.body.classList.contains("template-cart")){
                    //   location.reload();
                    // }
                  })
                  .catch(console.error)
                  .finally(() => btn.classList.remove('is-processing'));

              } 
              // ================= ADD WARRANTY =================
              else {
                const formData = {
                  items: [{
                    id: warrantyVariantID,
                    quantity: parentQuantity,
                    properties: {
                      'Extended Warranty': parentProductHandle,
                      '_related_product': `${warrantyVariantID}_${parentTitle}`
                    }
                  }]
                };

                fetch('/cart/add.js', {
                  method: "POST",
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify(formData)
                })
                  // 2026-08-06 - same sweep. A throttled /cart/add.js returns an HTML 429 page,
                  // so res.json() threw "Unexpected token '<'", and a 422 JSON error body was
                  // being treated as a successful add (button flipped to "in cart" with nothing
                  // added). Route both to the catch below. Restore the bare res.json() chain to
                  // roll back.
                  .then(res => {
                    if (!res.ok) { throw new Error('cart/add.js ' + res.status); }
                    return res.json();
                  })
                  .then(response => {
                    btn.dataset.inCart = "true";
                    btn.closest(".cart__item_wrp")
                      ?.querySelector(".cart__item")
                      ?.classList.add("has-extended-product");

                    document.dispatchEvent(
                      new CustomEvent("ajaxProduct:added", {
                        detail: { product: response }
                      })
                    );

                    setTimeout(()=>{
                      updateCompareTotal();
                    },1000);

                    if(document.body.classList.contains("template-cart")){
                      location.reload();
                    }
                  })
                  .catch(console.error)
                  .finally(() => btn.classList.remove('is-processing'));
              }
            });
          });
        })
        .catch(console.error);
    },


      // addExtendeWarranty: function () {
      //   let buttonExtendedWarranty = document.querySelectorAll('.extended-warranty[data-extended-submit]');

      //   // Get cart on page load
      //   fetch('/cart.js')
      //     .then(res => res.json())
      //     .then(cart => {
      //       buttonExtendedWarranty.forEach((btn) => {
      //         // Prevent duplicate event binding
      //         if (btn.dataset.bound === "true") return;
      //         btn.dataset.bound = "true";

      //         let warrantyVariantID = parseInt(btn.dataset.product);
      //         let parentProductHandle = btn.dataset.parentProduct;
      //         let parentQuantity = parseInt(btn.dataset.parentQuantity);
      //         let parentTitle = btn.dataset.parentTitle;

      //         // Check if warranty for this specific parent product exists
      //         let matchingWarranty = cart.items.find(item => {
      //           return item.id == warrantyVariantID &&
      //             item.properties &&
      //             item.properties['Extended Warranty'] == parentProductHandle;
      //         });

      //         btn.dataset.inCart = matchingWarranty ? "true" : "false";

      //         btn.addEventListener('click', (e) => {
      //           e.preventDefault();

      //           // Prevent multiple clicks in short time (double add)
      //           if (btn.classList.contains('is-processing')) return;
      //           btn.classList.add('is-processing');

      //           if (btn.dataset.inCart === "true") {
      //             // --- Remove ONLY this warranty ---
      //             if (matchingWarranty) {
      //               console.log("is-process!!!!");
      //               let formData = { updates: { [matchingWarranty.key]: 0 } };
      //               fetch('/cart/update.js', {
      //                 method: "POST",
      //                 body: JSON.stringify(formData),
      //                 headers: { 'Content-Type': 'application/json' }
      //               })
      //                 .then(res => res.json())
      //                 .then(response => {
      //                   btn.dataset.inCart = "false";
      //                   btn.closest(".cart__item_wrp").querySelector(".cart__item")
      //                     .classList.remove("has-extended-product");
      //                   document.dispatchEvent(new CustomEvent("ajaxProduct:added", { detail: { product: response } }));
                        
      //                 })
      //                 .catch(console.error)
      //                 .finally(() => btn.classList.remove('is-processing'));
      //             }
      //           } else {
      //             // --- Add warranty for THIS parent product ---
      //             let formData = {
      //               items: [{
      //                 id: warrantyVariantID,
      //                 quantity: parentQuantity, // Always same as main product
      //                 properties: {
      //                   'Extended Warranty': parentProductHandle,
      //                   '_related_product': warrantyVariantID + "_" + parentTitle
      //                 }
      //               }]
      //             };

      //              console.log("formData", formData);

      //             fetch('/cart/add.js', {
      //               method: "POST",
      //               body: JSON.stringify(formData),
      //               headers: { 'Content-Type': 'application/json' }
      //             })
      //               .then(res => res.json())
      //               .then(response => {
      //                  console.log("product added successfully..");
                      
      //                 btn.dataset.inCart = "true";
      //                 btn.closest(".cart__item_wrp").querySelector(".cart__item")
      //                   .classList.add("has-extended-product");
      //                 document.dispatchEvent(new CustomEvent("ajaxProduct:added", { detail: { product: response } }));
      //                 setTimeout(()=>{
      //                   updateCompareTotal();
                        
      //                 },1000);
                       
      //               })
      //               .catch(console.error)
      //               .finally(() => btn.classList.remove('is-processing'));
      //           }
      //         });
      //       });
      //     })
      //     .catch(console.error);
      // },
      updateCount: function (count) {
        var countEls = document.querySelectorAll(".cart-linkbubble-count");
        // 2026-08-06 - Clarity/GA4 error-click sweep. This runs after every cart change, so a
        // throttled /cart.js (HTML 429 page) made res.json() throw "Unexpected token '<'" as an
        // uncaught rejection on ordinary PDP add-to-cart. Leave the bubble on its previous count
        // instead. Restore the bare res.json() chain and drop the catch to roll back.
        fetch('/cart.js').then(res => (res.ok ? res.json() : null)).then(cart =>{
          if (!cart || !Array.isArray(cart.items)) { return; }

          let subtotal_prices = document.querySelectorAll('.subtotal-price');
          subtotal_prices.forEach((subtotal_price)=>{
            // 2026-08-16: shipping rides in the TOTAL now. aoamShipCents is published by
            // snippets/aoam-cart-fix.liquid and returns 0 for every case where the rate is not
            // exactly known (international, free-shipping carts, a cart too light to ship), so this
            // is a no-op wherever that file has not loaded.
            let formattedPrice = theme.Currency.formatMoney( cart.total_price + (window.aoamShipCents ? window.aoamShipCents(cart) : 0), theme.settings.moneyFormat);
            // 2026-10-10 audit: keep the decimals so this writer prints what aoamWriteTotals does (it stripped ".00", so a whole-unit TOTAL flipped between "$247.00" and "$247"). Restore formattedPrice = formattedPrice.replace(/\.00$/, ''); to roll back.
            subtotal_price.innerHTML = formattedPrice;
          })
          let count_total = 0;
          cart.items.forEach((item) => {
            if (item.properties && !item.properties['_protection_product']) {
              count_total+=item.quantity;
            }
          });
          count = count_total;
          if (countEls.length) {
            countEls.forEach((el) => {
              el.innerText = count;
            });
          }
          // show/hide bubble(s)
          // 2026-08-11 - Joel: "cart icon shows that there is something in the cart after i removed
          // the product". This toggled ONLY cart-link__bubble--visible, but the Liquid that renders
          // the bubble (widget-minicart.liquid, site-menu-mobile.liquid) stamps a SECOND class,
          // cart--linkbubble-visible, when the cart is non-empty - and widget-minicart.css /
          // head-styles.liquid light the dot when EITHER is present. Removing one left the other,
          // so emptying the cart kept the dot lit until the next page load. Both are written now.
          // Drop the cart--linkbubble-visible lines to roll back.
          var bubbles = document.querySelectorAll(selectors.cartBubble);
          if (bubbles.length) {
            if (count > 0) {
              bubbles.forEach((b) => {
                b.classList.add("cart-link__bubble--visible");
                b.classList.add("cart--linkbubble-visible");
              });
            } else {
              bubbles.forEach((b) => {
                b.classList.remove("cart-link__bubble--visible");
                b.classList.remove("cart--linkbubble-visible");
              });
            }
          }
        }).catch(function (err) {
          console.error("Cart count refresh failed:", err);
        });
      },
    });

    return CartForm;
  })();

  theme.headerSearch = (function () {
    var currentString = "";
    var isLoading = false;
    var searchTimeout;

    var selectors = {
      form: ".header-search__form",
      input: 'input[type="search"]',

      searchInlineContainer: ".site-header__search-container",
      searchInlineBtn: ".js-search-header",

      searchButton: "[data-predictive-search-button]",
      closeSearch: ".site-header__search-btn--cancel",

      wrapper: "#search-results",
      predictiveWrapper: "#search-predictive",
      resultDiv: "#predictive-search-results",
    };

    var cache = {};
    var activeForm;

    var classes = {
      isActive: "predicitive-active",
    };

    var config = {
      namespace: ".search",
      predictiveSearch: false,
      imageSize: "square",
    };

    var keys = {
      esc: 27,
      up_arrow: 38,
      down_arrow: 40,
      tab: 9,
    };

    function init() {
      initInlineSearch();

      cache.wrapper = document.querySelector(selectors.wrapper);
      if (!cache.wrapper) {
        return;
      }

      if (theme.settings.predictiveSearch) {
        // Only some languages support predictive search
        if (document.getElementById("shopify-features")) {
          var supportedShopifyFeatures = JSON.parse(
            document.getElementById("shopify-features").innerHTML
          );
          if (supportedShopifyFeatures.predictiveSearch) {
            config.predictiveSearch = true;
          }
        }
      }

      if (config.predictiveSearch) {
        cache.predictiveWrapper = document.querySelector(
          selectors.predictiveWrapper
        );
        config.imageSize = cache.predictiveWrapper.dataset.imageSize;
        cache.results = document.querySelector(selectors.resultDiv);
        cache.submit = cache.predictiveWrapper.querySelector(
          selectors.searchButton
        );
        cache.submit.on("click" + config.namespace, triggerSearch);
      }

      document.querySelectorAll(selectors.form).forEach((form) => {
        initForm(form);
      });
    }

    function initForm(form) {
      form.setAttribute("autocomplete", "off");
      form.on("submit" + config.namespace, submitSearch);

      var input = form.querySelector(selectors.input);
      input.on("focus" + config.namespace, handleFocus);
      if (config.predictiveSearch) {
        input.on("keyup" + config.namespace, handleKeyup);
      }
    }

    function reset() {
      if (config.predictiveSearch) {
        cache.predictiveWrapper.classList.add("hide");
        cache.results.innerHTML = "";
        clearTimeout(searchTimeout);
      }
    }

    function close(evt) {
      // If close button is clicked, close as expected.
      // Otherwise, ignore clicks in search results, search form, or container elements
      if (evt && evt.target.closest) {
        if (evt.target.closest(selectors.closeSearch)) {
        } else {
          if (evt.target.closest(".header-search__form")) {
            return;
          } else if (evt.target.closest(".site-header__element--sub")) {
            return;
          } else if (evt.target.closest("#SearchResultsWrapper")) {
            return;
          } else if (evt.target.closest(".site-header__search-container")) {
            return;
          }
        }
      }

      // deselect any focused form elements
      document.activeElement.blur();

      cache.wrapper.classList.add("hide");

      if (config.predictiveSearch) {
        cache.predictiveWrapper.classList.add("hide");
        clearTimeout(searchTimeout);
      }

      if (cache.inlineSearchContainer) {
        cache.inlineSearchContainer.classList.remove("is-active");
      }

      document.querySelectorAll(selectors.form).forEach((form) => {
        form.classList.remove("is-active");
      });

      window.off("click" + config.namespace);
    }

    function initInlineSearch() {
      cache.inlineSearchContainer = document.querySelector(
        selectors.searchInlineContainer
      );
      document.querySelectorAll(selectors.searchInlineBtn).forEach((btn) => {
        btn.addEventListener("click", openInlineSearch);
      });
    }

    function openInlineSearch(evt) {
      evt.preventDefault();
      evt.stopImmediatePropagation();
      var container = document.querySelector(selectors.searchInlineContainer);
      container.classList.add("is-active");
      container.querySelector(".site-header__search-input").focus();

      enableCloseListeners();
    }

    function triggerSearch() {
      if (activeForm) {
        // A native form.submit() fires no submit event, so submitSearch never runs for this press.
        if (window.AOAM_LOAD) window.AOAM_LOAD.show();
        activeForm.submit();
      }
    }

    // Append * wildcard to search
    function submitSearch(evt) {
      evt.preventDefault ? evt.preventDefault() : (evt.returnValue = false);

      var obj = {};
      var formData = new FormData(evt.target);
      for (var key of formData.keys()) {
        obj[key] = formData.get(key);
      }

      if (obj.q) {
        obj.q += "*";
      }

      var params = paramUrl(obj);

      if (window.AOAM_LOAD) window.AOAM_LOAD.show();
      // 2026-10-10 audit: was a hard-coded "/search?", which sent every market search to the US store in USD. theme.routes.search is "/en-gb/search" on a market and "/search" on the US store (layout/theme.liquid). Joel: "ship any fixes/finds". Roll back: restore the literal "/search?" string.
      window.location.href = ((window.theme && window.theme.routes && window.theme.routes.search) || "/search") + "?" + params;
      return false;
    }

    function handleKeyup(evt) {
      activeForm = evt.currentTarget.closest("form");

      if (evt.keyCode === keys.up_arrow) {
        return;
      }

      if (evt.keyCode === keys.down_arrow) {
        return;
      }

      if (evt.keyCode === keys.tab) {
        return;
      }

      if (evt.keyCode === keys.esc) {
        close();
        return;
      }

      search(evt.currentTarget);
    }

    function handleFocus(evt) {
      evt.currentTarget.parentNode.classList.add("is-active");
      enableCloseListeners();
    }

    function enableCloseListeners() {
      // Clicking out of search area closes it. Timeout to prevent immediate bubbling
      setTimeout(function () {
        window.on("click" + config.namespace, function (evt) {
          close(evt);
        });
      }, 0);

      // Esc key also closes search
      window.on("keyup", function (evt) {
        if (evt.keyCode === 27) {
          close();
        }
      });
    }

    function search(input) {
      var keyword = input.value;

      if (keyword === "") {
        reset();
        return;
      }

      var q = _normalizeQuery(keyword);

      clearTimeout(searchTimeout);
      searchTimeout = setTimeout(
        function () {
          predictQuery(q);
        }.bind(this),
        500
      );
    }

    function predictQuery(q) {
      if (isLoading) {
        return;
      }

      // Do not re-search the same thing
      if (currentString === q) {
        return;
      }

      currentString = q;
      isLoading = true;

      var searchObj = {
        q: q,
        "resources[type]": theme.settings.predictiveSearchType,
        // 2026-09-16 - Joel: "when searching kit there is only 1 result". Not a tagging problem:
        // resources[limit] is shared across all four types unless limit_scope is "each", so
        // products got 1 of the 4 slots ("kit" matches 13+ products). Now up to 6 of EACH type.
        // The dropdown redraw in snippets/predictive-search.liquid trims chips and articles.
        // Delete the limit_scope line and set the limit back to 4 to roll back.
        "resources[limit]": 6,
        "resources[limit_scope]": "each",
        "resources[options][unavailable_products]": "last",
        "resources[options][fields]":
          "title,product_type,variants.title,vendor,tag",
      };

      var params = paramUrl(searchObj);

      // 2026-10-10 audit: same fix for the dropdown, a root fetch returned US prices and links and flipped cart_currency to USD on a market page. Joel: "ship any fixes/finds". Roll back: restore the literal "/search/suggest.json?" string.
      fetch(((window.theme && window.theme.routes && window.theme.routes.search) || "/search") + "/suggest.json?" + params)
        .then((response) => response.json())
        .then((suggestions) => {
          isLoading = false;
          var data = {};
          var resultCount = 0;

          cache.predictiveWrapper.classList.remove("hide");
          var resultTypes = Object.entries(suggestions.resources.results);

          Object.keys(resultTypes).forEach(function (i) {
            var obj = resultTypes[i];
            var type = obj[0];
            var results = obj[1];
            resultCount += results.length;

            switch (type) {
              case "products":
                data[type] = buildProducts(results);
                break;
              case "collections":
                data[type] = buildCollections(results);
                break;
              case "pages":
                data[type] = buildPages(results);
                break;
              case "articles":
                data[type] = buildArticles(results);
                break;
            }
          });

          if (resultCount === 0) {
            reset();
            return;
          }

          // Build and append result markup
          var output = buildOutput(data);
          cache.results.innerHTML = "";
          cache.results.innerHTML = output;

          cache.wrapper.classList.remove("hide");
        });
    }

    function buildProducts(results) {
      var output = "";
      var products = [];

      results.forEach((product) => {
        var new_product = {
          title: product.title,
          url: product.url,
          image_responsive_url: theme.Images.lazyloadImagePath(product.image),
          image_aspect_ratio: product.featured_image.aspect_ratio,
          // 2026-07-29 - Joel: "improve the format and structure of this search
          // drop down". Pass pricing through so the cards can show it, and give
          // the section the same label treatment the other result types get.
          // Delete this block and the label line below to roll back.
          price_min: product.price_min,
          price_max: product.price_max,
          compare_at_price_min: product.compare_at_price_min,
          available: product.available,
        };

        products.push(new_product);
      });

      if (products.length) {
        var markup = theme.buildProductGridItem(products, config.imageSize);

        output = `
			  <div data-type-products>
				<p class="h6 predictive__label">${theme.strings.searchProducts || "Products"}</p>
				<div class="new-grid product-grid" data-view="small">
				  ${markup}
				</div>
			  </div>
			`;
      }

      return output;
    }

    function buildCollections(collections) {
      var output = "";

      if (collections.length) {
        var markup = theme.buildCollectionItem(collections);

        output = `
			  <div data-type-collections>
				<p class="h6 predictive__label">${theme.strings.searchCollections}</p>
				<ul class="no-bullets">
				  ${markup}
				</ul>
			  </div>
			`;
      }

      return output;
    }

    function buildPages(pages) {
      var output = "";

      if (pages.length) {
        var markup = theme.buildPageItem(pages);

        output = `
			  <div data-type-pages>
				<p class="h6 predictive__label">${theme.strings.searchPages}</p>
				<ul class="no-bullets">
				  ${markup}
				</ul>
			  </div>
			`;
      }

      return output;
    }

    // Overwrite full sized image returned form API
    // with lazyloading-friendly path
    function buildArticles(articles) {
      var output = "";

      articles.forEach((article) => {
        if (article.image) {
          article.image = theme.Images.getSizedImageUrl(
            article.image,
            "200x200_crop_center"
          );
        }
      });

      if (articles.length) {
        var markup = theme.buildArticleItem(articles, config.imageSize);

        output = `
			  <div data-type-articles>
				<p class="h6 predictive__label">${theme.strings.searchArticles}</p>
				<div class="grid grid--uniform grid--no-gutters">
				  ${markup}
				</div>
			  </div>
			`;
      }

      return output;
    }

    // Combine all search result markup and print to page
    function buildOutput(data) {
      var output = "";

      if (data.products && data.products !== "") {
        output += data.products;
      }

      if (data.collections && data.collections !== "") {
        output += data.collections;
      }

      if (data.pages && data.pages !== "") {
        output += data.pages;
      }

      if (data.articles && data.articles !== "") {
        output += data.articles;
      }

      return output;
    }

    function _normalizeQuery(string) {
      if (typeof string !== "string") {
        return null;
      }

      return string.trim().replace(/\ /g, "-").toLowerCase();
    }

    function paramUrl(obj) {
      return Object.keys(obj)
        .map(function (key) {
          return key + "=" + encodeURIComponent(obj[key]);
        })
        .join("&");
    }

    return {
      init: init,
    };
  })();

  // Either collapsible containers all acting individually,
  // or tabs that can only have one open at a time
  theme.collapsibles = (function () {
    var selectors = {
      trigger: ".collapsible-trigger",
      module: ".collapsible-content",
      moduleInner: ".collapsible-content__inner",
      tabs: ".collapsible-trigger--tab",
    };

    var classes = {
      hide: "hide",
      open: "is-open",
      autoHeight: "collapsible--auto-height",
      tabs: "collapsible-trigger--tab",
    };

    var namespace = ".collapsible";

    var isTransitioning = false;

    function init(scope) {
      var el = scope ? scope : document;
      el.querySelectorAll(selectors.trigger).forEach((trigger) => {
        var state = trigger.classList.contains(classes.open);
        trigger.setAttribute("aria-expanded", state);

        trigger.off("click" + namespace);
        trigger.on("click" + namespace, toggle);
      });
    }

    function toggle(evt) {
      if (isTransitioning) {
        return;
      }

      isTransitioning = true;

      var el = evt.currentTarget;
      var isOpen = el.classList.contains(classes.open);
      var isTab = el.classList.contains(classes.tabs);
      var moduleId = el.getAttribute("aria-controls");
      var container = document.getElementById(moduleId);

      if (!moduleId) {
        moduleId = el.dataset.controls;
      }

      // No ID, bail
      if (!moduleId) {
        return;
      }

      // If container=null, there isn't a matching ID.
      // Check if data-id is set instead. Could be multiple.
      // Select based on being in the same parent div.
      if (!container) {
        var multipleMatches = document.querySelectorAll(
          '[data-id="' + moduleId + '"]'
        );
        if (multipleMatches.length > 0) {
          container = el.parentNode.querySelector(
            '[data-id="' + moduleId + '"]'
          );
        }
      }

      if (!container) {
        isTransitioning = false;
        return;
      }

      var height = container.querySelector(selectors.moduleInner).offsetHeight;
      var isAutoHeight = container.classList.contains(classes.autoHeight);
      var parentCollapsibleEl = container.parentNode.closest(selectors.module);
      var childHeight = height;

      if (isTab) {
        if (isOpen) {
          isTransitioning = false;
          return;
        }

        var newModule;
        document
          .querySelectorAll(
            selectors.tabs + '[data-id="' + el.dataset.id + '"]'
          )
          .forEach((el) => {
            el.classList.remove(classes.open);
            newModule = document.querySelector(
              "#" + el.getAttribute("aria-controls")
            );
            setTransitionHeight(newModule, 0, true);
          });
      }

      // If isAutoHeight, set the height to 0 just after setting the actual height
      // so the closing animation works nicely
      if (isOpen && isAutoHeight) {
        setTimeout(function () {
          height = 0;
          setTransitionHeight(container, height, isOpen, isAutoHeight);
        }, 0);
      }

      if (isOpen && !isAutoHeight) {
        height = 0;
      }

      el.setAttribute("aria-expanded", !isOpen);
      if (isOpen) {
        el.classList.remove(classes.open);
      } else {
        el.classList.add(classes.open);
      }

      setTransitionHeight(container, height, isOpen, isAutoHeight);

      // If we are in a nested collapsible element like the mobile nav,
      // also set the parent element's height
      if (parentCollapsibleEl) {
        var totalHeight = isOpen
          ? parentCollapsibleEl.offsetHeight - childHeight
          : height + parentCollapsibleEl.offsetHeight;

        setTransitionHeight(parentCollapsibleEl, totalHeight, false, false);
      }

      // If Shopify Product Reviews app installed,
      // resize container on 'Write review' click
      // that shows form
      if (window.SPR) {
        var btn = container.querySelector(".spr-summary-actions-newreview");
        if (!btn) {
          return;
        }
        btn.off("click" + namespace);
        btn.on("click" + namespace, function () {
          height = container.querySelector(selectors.moduleInner).offsetHeight;
          setTransitionHeight(container, height, isOpen, isAutoHeight);
        });
      }
    }

    function setTransitionHeight(container, height, isOpen, isAutoHeight) {
      container.classList.remove(classes.hide);
      theme.utils.prepareTransition(container, function () {
        container.style.height = height + "px";
        if (isOpen) {
          container.classList.remove(classes.open);
        } else {
          container.classList.add(classes.open);
        }
      });

      if (!isOpen && isAutoHeight) {
        var o = container;
        window.setTimeout(function () {
          o.css("height", "auto");
          isTransitioning = false;
        }, 500);
      } else {
        isTransitioning = false;
      }
    }

    return {
      init: init,
    };
  })();

  // Shopify-built select-like popovers for currency and language selection
  theme.Disclosure = (function () {
    var selectors = {
      disclosureForm: "[data-disclosure-form]",
      disclosureList: "[data-disclosure-list]",
      disclosureToggle: "[data-disclosure-toggle]",
      disclosureInput: "[data-disclosure-input]",
      disclosureOptions: "[data-disclosure-option]",
    };

    var classes = {
      listVisible: "disclosure-list--visible",
    };

    function Disclosure(disclosure) {
      this.container = disclosure;
      this._cacheSelectors();
      this._setupListeners();
    }

    Disclosure.prototype = Object.assign({}, Disclosure.prototype, {
      _cacheSelectors: function () {
        this.cache = {
          disclosureForm: this.container.closest(selectors.disclosureForm),
          disclosureList: this.container.querySelector(
            selectors.disclosureList
          ),
          disclosureToggle: this.container.querySelector(
            selectors.disclosureToggle
          ),
          disclosureInput: this.container.querySelector(
            selectors.disclosureInput
          ),
          disclosureOptions: this.container.querySelectorAll(
            selectors.disclosureOptions
          ),
        };
      },

      _setupListeners: function () {
        this.eventHandlers = this._setupEventHandlers();

        this.cache.disclosureToggle.addEventListener(
          "click",
          this.eventHandlers.toggleList
        );

        this.cache.disclosureOptions.forEach(function (disclosureOption) {
          disclosureOption.addEventListener(
            "click",
            this.eventHandlers.connectOptions
          );
        }, this);

        this.container.addEventListener(
          "keyup",
          this.eventHandlers.onDisclosureKeyUp
        );

        this.cache.disclosureList.addEventListener(
          "focusout",
          this.eventHandlers.onDisclosureListFocusOut
        );

        this.cache.disclosureToggle.addEventListener(
          "focusout",
          this.eventHandlers.onDisclosureToggleFocusOut
        );

        document.body.addEventListener("click", this.eventHandlers.onBodyClick);
      },

      _setupEventHandlers: function () {
        return {
          connectOptions: this._connectOptions.bind(this),
          toggleList: this._toggleList.bind(this),
          onBodyClick: this._onBodyClick.bind(this),
          onDisclosureKeyUp: this._onDisclosureKeyUp.bind(this),
          onDisclosureListFocusOut: this._onDisclosureListFocusOut.bind(this),
          onDisclosureToggleFocusOut:
            this._onDisclosureToggleFocusOut.bind(this),
        };
      },

      _connectOptions: function (event) {
        event.preventDefault();

        this._submitForm(event.currentTarget.dataset.value);
      },

      _onDisclosureToggleFocusOut: function (event) {
        var disclosureLostFocus =
          this.container.contains(event.relatedTarget) === false;

        if (disclosureLostFocus) {
          this._hideList();
        }
      },

      _onDisclosureListFocusOut: function (event) {
        var childInFocus = event.currentTarget.contains(event.relatedTarget);

        var isVisible = this.cache.disclosureList.classList.contains(
          classes.listVisible
        );

        if (isVisible && !childInFocus) {
          this._hideList();
        }
      },

      _onDisclosureKeyUp: function (event) {
        if (event.which !== 27) return;
        this._hideList();
        this.cache.disclosureToggle.focus();
      },

      _onBodyClick: function (event) {
        var isOption = this.container.contains(event.target);
        var isVisible = this.cache.disclosureList.classList.contains(
          classes.listVisible
        );

        if (isVisible && !isOption) {
          this._hideList();
        }
      },

      _submitForm: function (value) {
        this.cache.disclosureInput.value = value;
        if (window.AOAM_LOAD) window.AOAM_LOAD.show();
        this.cache.disclosureForm.submit();
      },

      _hideList: function () {
        this.cache.disclosureList.classList.remove(classes.listVisible);
        this.cache.disclosureToggle.setAttribute("aria-expanded", false);
      },

      _toggleList: function () {
        var ariaExpanded =
          this.cache.disclosureToggle.getAttribute("aria-expanded") === "true";
        this.cache.disclosureList.classList.toggle(classes.listVisible);
        this.cache.disclosureToggle.setAttribute(
          "aria-expanded",
          !ariaExpanded
        );
      },

      destroy: function () {
        this.cache.disclosureToggle.removeEventListener(
          "click",
          this.eventHandlers.toggleList
        );

        this.cache.disclosureOptions.forEach(function (disclosureOption) {
          disclosureOption.removeEventListener(
            "click",
            this.eventHandlers.connectOptions
          );
        }, this);

        this.container.removeEventListener(
          "keyup",
          this.eventHandlers.onDisclosureKeyUp
        );

        this.cache.disclosureList.removeEventListener(
          "focusout",
          this.eventHandlers.onDisclosureListFocusOut
        );

        this.cache.disclosureToggle.removeEventListener(
          "focusout",
          this.eventHandlers.onDisclosureToggleFocusOut
        );

        document.body.removeEventListener(
          "click",
          this.eventHandlers.onBodyClick
        );
      },
    });

    return Disclosure;
  })();

  theme.Drawer = (function () {
    function Drawer(id, position, options) {
      var defaults = {
        close: ".js-drawer-close",
        open: ".js-drawer-open-" + position,
        openClass: "js-drawer-open",
        dirOpenClass: "js-drawer-open-" + position,
        transition: "is-transitioning",
      };

      this.id = id;
      this.drawer = document.getElementById(id);

      if (!this.drawer) {
        return false;
      }

      this.drawerIsOpen = false;

      this.config = Object.assign(defaults, options);
      this.focusOnOpen = this.config.focusIdOnOpen
        ? document.getElementById(this.config.focusIdOnOpen)
        : this.drawer;

      this.init();
    }

    Drawer.prototype = Object.assign({}, Drawer.prototype, {
      init: function () {
        var _self = this;
        var pageElement = document.querySelector(".site-content");

        /* 2026-08-17 (Claude) - Joel, from an iPhone: "i added the flashlight to the cart then
           removed it then added it again with the sticky add to cart on the product page then the
           x in the top right of the page no longer works".
           config.open is ".js-drawer-open-" + position and config.dirOpenClass is
           "js-drawer-open-" + position - THE SAME STRING. The first is the class on the buttons
           that open the drawer; the second is the STATE class this very object writes onto <html>
           while the drawer is open (aoam-cart-fix.liquid applyDrawerOpen() writes it too). So any
           Drawer constructed WHILE the drawer is open matches <html> here and binds click ->
           open() to the whole document: from that moment every click anywhere re-opens the cart,
           including the click on the X. The X fires close first (it is bound to the button), the
           event then bubbles to <html> and re-opens it in the same tick, so the drawer never goes
           away and the button reads as dead for the rest of the page load.
           Measured on live at 390x844: after ONE press of the mobile sticky Add to Cart -
           theme.js line ~9120 builds a fresh Drawer on every press - init() reported
           matches: 2 for ".js-drawer-open-right" with document.documentElement.matches() true,
           and a click listener was added straight to <html>.
           A state class must never be able to act as a trigger. Delete this filter to roll back. */
        document.querySelectorAll(this.config.open).forEach((btn) => {
          if (btn === document.documentElement || btn === document.body) return;
          btn.setAttribute("aria-expanded", "false");
          btn.addEventListener("click", this.open.bind(this));
        });

        document.querySelectorAll(this.config.close).forEach((btn) => {
          btn.addEventListener("click", this.close.bind(this));
        });

        pageElement.addEventListener("click", function (event) {
          if (!event.target.contains(this.drawer)) {
            _self.close();
          }
        });
      },

      open: function (evt) {
        var externalCall = false;

        if (this.drawerIsOpen) {
          return;
        }

        if (evt) {
          evt.preventDefault();
        } else {
          externalCall = true;
        }

        if (evt && evt.stopPropagation) {
          evt.stopPropagation();
          this.activeSource = evt.currentTarget;
          evt.currentTarget.setAttribute("aria-expanded", "true");
        }

        if (this.drawerIsOpen && !externalCall) {
          this.close();
        }

        this.drawer.classList.add(this.config.openClass);
        this.drawer.classList.add(this.config.transition);

        document.documentElement.classList.add(this.config.openClass);
        document.documentElement.classList.add(this.config.dirOpenClass);

        window.setTimeout(
          function () {
            this.drawer.classList.remove(this.config.transition);
          }.bind(this),
          500
        );

        this.drawerIsOpen = true;

        theme.a11y.trapFocus({
          container: this.drawer,
          elementToFocus: this.focusOnOpen,
          namespace: "drawer_focus",
        });

        document.dispatchEvent(new CustomEvent("drawerOpen"));
        document.dispatchEvent(new CustomEvent("drawerOpen." + this.id));
        let protection_product_checkbox = document.querySelector('.protection_product_checkbox');
        if(localStorage.getItem('warranty_toogle_is_disable_by_user') == 'false' /* 2026-09-24 opt-in: a missing flag is OFF now */){
          update_protection_products('Update');
        }else{
          update_protection_total_price();
        }
      },

      close: function () {
        if (!this.drawerIsOpen) {
          return;
        }
        // if (this.drawerIsOpen) return;
        document.activeElement.blur();

        this.drawer.classList.remove(this.config.openClass);
        this.drawer.classList.add(this.config.transition);

        document.documentElement.classList.remove(this.config.openClass),
        document.documentElement.classList.remove(this.config.dirOpenClass);

        window.setTimeout(
          function () {
            this.drawer.classList.remove(this.config.transition);

            if (
              this.activeSource &&
              this.activeSource.getAttribute("aria-expanded")
            ) {
              this.activeSource.setAttribute("aria-expanded", "false");
            }
          }.bind(this),
          500
        );

        this.drawerIsOpen = false;

        theme.a11y.removeTrapFocus({
          container: this.drawer,
          namespace: "drawer_focus",
        });

        document.dispatchEvent(new CustomEvent("drawerClose." + this.id));
      },
    });

    return Drawer;
  })();

  theme.Modals = (function () {
    function Modal(id, name, options) {
      var defaults = {
        close: ".js-modal-close",
        open: ".js-modal-open-" + name,
        openClass: "modal--is-active",
        closingClass: "modal--is-closing",
        bodyOpenClass: ["modal-open"],
        bodyOpenSolidClass: "modal-open--solid",
        bodyClosingClass: "modal-closing",
        closeOffContentClick: true,
      };

      this.id = id;
      this.modal = document.getElementById(id);

      if (!this.modal) {
        return false;
      }

      this.modalContent = this.modal.querySelector(".modal__inner");

      this.config = Object.assign(defaults, options);
      this.modalIsOpen = false;
      this.focusOnOpen = this.config.focusIdOnOpen
        ? document.getElementById(this.config.focusIdOnOpen)
        : this.modal;
      this.isSolid = this.config.solid;

      this.init();
    }

    Modal.prototype.init = function () {
      document.querySelectorAll(this.config.open).forEach((btn) => {
        btn.setAttribute("aria-expanded", "false");
        btn.addEventListener("click", this.open.bind(this));
      });

      this.modal.querySelectorAll(this.config.close).forEach((btn) => {
        btn.addEventListener("click", this.close.bind(this));
      });

      // Close modal if a drawer is opened
      document.addEventListener(
        "drawerOpen",
        function () {
          this.close();
        }.bind(this)
      );
    };

    Modal.prototype.open = function (evt) {
      // Keep track if modal was opened from a click, or called by another function
      var externalCall = false;

      // don't open an opened modal
      if (this.modalIsOpen) {
        return;
      }

      // Prevent following href if link is clicked
      if (evt) {
        evt.preventDefault();
      } else {
        externalCall = true;
      }

      // Without this, the modal opens, the click event bubbles up to $nodes.page
      // which closes the modal.
      if (evt && evt.stopPropagation) {
        evt.stopPropagation();
        // save the source of the click, we'll focus to this on close
        this.activeSource = evt.currentTarget.setAttribute(
          "aria-expanded",
          "true"
        );
      }

      if (this.modalIsOpen && !externalCall) {
        this.close();
      }

      this.modal.classList.add(this.config.openClass);

      document.documentElement.classList.add(...this.config.bodyOpenClass);

      if (this.isSolid) {
        document.documentElement.classList.add(this.config.bodyOpenSolidClass);
      }

      this.modalIsOpen = true;

      theme.a11y.trapFocus({
        container: this.modal,
        elementToFocus: this.focusOnOpen,
        namespace: "modal_focus",
      });

      document.dispatchEvent(new CustomEvent("modalOpen"));
      document.dispatchEvent(new CustomEvent("modalOpen." + this.id));

      this.bindEvents();
    };

    Modal.prototype.close = function (evt) {
      // don't close a closed modal
      if (!this.modalIsOpen) {
        return;
      }

      // Do not close modal if click happens inside modal content
      if (evt) {
        if (evt.target.closest(".js-modal-close")) {
          // Do not close if using the modal close button
        } else if (evt.target.closest(".modal-content__inner")) {
          return;
        }
      }

      // deselect any focused form elements
      document.activeElement.blur();

      this.modal.classList.remove(this.config.openClass);
      this.modal.classList.add(this.config.closingClass);

      document.documentElement.classList.remove(...this.config.bodyOpenClass);
      document.documentElement.classList.add(this.config.bodyClosingClass);

      window.setTimeout(
        function () {
          document.documentElement.classList.remove(
            this.config.bodyClosingClass
          );
          this.modal.classList.remove(this.config.closingClass);
          if (
            this.activeSource &&
            this.activeSource.getAttribute("aria-expanded")
          ) {
            this.activeSource.setAttribute("aria-expanded", "false").focus();
          }
        }.bind(this),
        500
      ); // modal close css transition

      if (this.isSolid) {
        document.documentElement.classList.remove(
          this.config.bodyOpenSolidClass
        );
      }

      this.modalIsOpen = false;

      theme.a11y.removeTrapFocus({
        container: this.modal,
        namespace: "modal_focus",
      });

      document.dispatchEvent(new CustomEvent("modalClose." + this.id));

      this.unbindEvents();
    };

    Modal.prototype.bindEvents = function () {
      window.on(
        "keyup.modal",
        function (evt) {
          if (evt.keyCode === 27) {
            this.close();
          }
        }.bind(this)
      );

      if (this.config.closeOffContentClick) {
        // Clicking outside of the modal content also closes it
        this.modal.on("click.modal", this.close.bind(this));
      }
    };

    Modal.prototype.unbindEvents = function () {
      document.documentElement.off(".modal");

      if (this.config.closeOffContentClick) {
        this.modal.off(".modal");
      }
    };

    return Modal;
  })();

  // Initialize in theme.js with theme.pageTransitions();
  window.onpageshow = function (evt) {
    /* 2026-08-18 (Claude) - THE CHECKOUT BUTTON HAS TO BE RE-ENABLED HERE, and on EVERY
       pageshow, not just a bfcache one. The drawer's checkout handler (~line 9855) sets the
       `disabled` attribute before navigating, and this was the only code that ran on the way
       back - it cleared .btn--loading and left `disabled` in place forever. Nothing else in
       the theme re-enables .btn-cart__checkout, and cartMarkup() never re-renders .cart__footer,
       so a shopper who pressed Back from checkout was locked out of checkout for the rest of
       that page load. button[disabled] only sets cursor:default in theme.css, so it still
       looked live and they just tapped it again. On mobile there is no fallback route: the
       .payment-icon-list checkout shim is display:none under 900px.
       Unconditional because evt.persisted is false on real history restores too, and
       re-enabling a button that was never disabled is a no-op. */
    document.querySelectorAll(".btn-cart__checkout").forEach((el) => {
      el.classList.remove("btn--loading");
      el.removeAttribute("disabled");
    });
    // Removes unload class when returning to page via history
    if (evt.persisted) {
      document.body.classList.remove("unloading");
    }
  };

  theme.pageTransitions = function () {
    if (document.body.dataset.transitions === "true") {
      // Hack test to fix Safari page cache issue.
      // window.onpageshow doesn't always run when navigating
      // back to the page, so the unloading class remains, leaving
      // a white page. Setting a timeout to remove that class when leaving
      // the page actually finishes running when they come back.
      if (!!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/)) {
        document.querySelectorAll("a").forEach((a) => {
          window.setTimeout(function () {
            document.body.classList.remove("unloading");
          }, 1200);
        });
      }

      // Add disable transition class to various link types
      document
        .querySelectorAll(
          'a[href^="mailto:"], a[href^="#"], a[target="_blank"], a[href*="youtube.com/watch"], a[href*="youtu.be/"], a[download]'
        )
        .forEach((el) => {
          el.classList.add("js-no-transition");
        });

      document.querySelectorAll("a:not(.js-no-transition)").forEach((el) => {
        el.addEventListener("click", function (evt) {
          if (evt.metaKey) return true;
          evt.preventDefault();
          document.body.classList.add("unloading");
          var src = el.getAttribute("href");
          window.setTimeout(function () {
            location.href = src;
          }, 50);
        });
      });

      document.querySelectorAll("a.mobile-nav__link").forEach((el) => {
        el.addEventListener("click", function () {
          theme.NavDrawer.close();
        });
      });
    }
  };

  theme.PriceRange = (function () {
    var defaultStep = 10;
    var selectors = {
      priceRange: ".price-range",
      priceRangeSlider: ".price-range__slider",
      priceRangeInputMin: ".price-range__input-min",
      priceRangeInputMax: ".price-range__input-max",
      priceRangeDisplayMin: ".price-range__display-min",
      priceRangeDisplayMax: ".price-range__display-max",
    };

    function PriceRange(
      container,
      { onChange, onUpdate, ...sliderOptions } = {}
    ) {
      this.container = container;
      this.onChange = onChange;
      this.onUpdate = onUpdate;
      this.sliderOptions = sliderOptions || {};

      return this.init();
    }

    PriceRange.prototype = Object.assign({}, PriceRange.prototype, {
      init: function () {
        if (!this.container.classList.contains("price-range")) {
          throw new Error(
            "You must instantiate PriceRange with a valid container"
          );
        }

        this.formEl = this.container.closest("form");
        this.sliderEl = this.container.querySelector(
          selectors.priceRangeSlider
        );
        this.inputMinEl = this.container.querySelector(
          selectors.priceRangeInputMin
        );
        this.inputMaxEl = this.container.querySelector(
          selectors.priceRangeInputMax
        );
        this.displayMinEl = this.container.querySelector(
          selectors.priceRangeDisplayMin
        );
        this.displayMaxEl = this.container.querySelector(
          selectors.priceRangeDisplayMax
        );

        this.minRange = parseFloat(this.container.dataset.min) || 0;
        this.minValue = parseFloat(this.container.dataset.minValue) || 0;
        this.maxRange = parseFloat(this.container.dataset.max) || 100;
        this.maxValue =
          parseFloat(this.container.dataset.maxValue) || this.maxRange;

        return this.createPriceRange();
      },

      createPriceRange: function () {
        if (
          this.sliderEl &&
          this.sliderEl.noUiSlider &&
          typeof this.sliderEl.noUiSlider.destroy === "function"
        ) {
          this.sliderEl.noUiSlider.destroy();
        }

        var slider = noUiSlider.create(this.sliderEl, {
          connect: true,
          step: defaultStep,
          ...this.sliderOptions,
          // Do not allow overriding these options
          start: [this.minValue, this.maxValue],
          range: {
            min: this.minRange,
            max: this.maxRange,
          },
        });

        slider.on("update", (values) => {
          this.displayMinEl.innerHTML = theme.Currency.formatMoney(
            values[0],
            theme.settings.moneyFormat
          );
          this.displayMaxEl.innerHTML = theme.Currency.formatMoney(
            values[1],
            theme.settings.moneyFormat
          );

          if (this.onUpdate) {
            this.onUpdate(values);
          }
        });

        slider.on("change", (values) => {
          this.inputMinEl.value = values[0];
          this.inputMaxEl.value = values[1];

          if (this.onChange) {
            const formData = new FormData(this.formEl);
            this.onChange(formData);
          }
        });

        return slider;
      },
    });

    return PriceRange;
  })();

  theme.AjaxProduct = (function () {
    var status = {
      loading: false,
    };

    function ProductForm(form, submit, args) {
      this.form = form;
      this.args = args;

      var submitSelector = submit ? submit : ".add-to-cart";

      if (this.form) {
        this.addToCart = form.querySelector(submitSelector);
        this.form.addEventListener("submit", this.addItemFromForm.bind(this));
      }
    }

    ProductForm.prototype = Object.assign({}, ProductForm.prototype, {
      addItemFromForm: function (evt, callback) {
        evt.preventDefault();

        if (status.loading) {
          return;
        }

        // Loading indicator on add to cart button
        this.addToCart.classList.add("btn--loading");

        status.loading = true;

        var data = theme.utils.serialize(this.form);

        // custom code
          const countryCode = document.documentElement.getAttribute('country');
          if (countryCode !== 'US') {
            if(data.includes("product-id=6078153326755")){
              console.log("product is 2500mAh 18650 Battery");
              this.addToCart.classList.remove("btn--loading");
              status.loading = false;

              customNonUsRestricted();
              return;
            }
          }
        // custom code

        fetch(theme.routes.cartAdd, {
          method: "POST",
          body: data,
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "X-Requested-With": "XMLHttpRequest",
          },
        })
          // 2026-08-06 - Clarity/GA4 error-click sweep. This is the main PDP add-to-cart. A
          // throttled or bot-challenged /cart/add returns an HTML page, so response.json() threw
          // "Unexpected token '<'" with no catch on the chain: an uncaught rejection, and the
          // button stayed stuck in btn--loading with status.loading true, so every later add was
          // ignored until reload. 422 still has a JSON body and must pass through to this.error.
          // Restore the bare response.json() chain and drop the catch to roll back.
          .then((response) => {
            if (!response.ok && response.status !== 422) {
              throw new Error('cart/add ' + response.status);
            }
            return response.json();
          })
          .then(
            function (data) {
              if (data.status === 422) {
                this.error(data);
                // 2026-10-05 cart audit S02 (regression of C119, Claude). Shopify answers a TRIMMED add ("Only 2 items were added to your
                // cart due to availability.") with a 422, yet the units it could add ARE in the cart. Handled as a plain error, nothing
                // repainted the header badge or the rows and nothing opened the drawer, so the C119 drawer notice never showed. Now it
                // repaints and opens like an add, and the same sentence shows on top of the open drawer. Other 422s (sold out, already
                // at the limit) are unchanged. Roll back: delete this if block.
                if (/^Only \d+ items? (was|were) added/i.test(String(data.description || ""))) {
                  var aoamTrimMsg = String(data.description);
                  document.dispatchEvent(new CustomEvent("ajaxProduct:added", { detail: { aoamTrimmed: true } }));
                  aoamOpenDrawerAfterRows({ aoamTrimmed: true }, function () {
                    setTimeout(function () {
                      if (typeof window.aoamDrawerNotice === "function" && !document.querySelector("#header_minicart .aoam-add-notice")) window.aoamDrawerNotice(aoamTrimMsg);
                    }, 250);
                  });
                }
              } else {
                var product = data;
                this.success(product);

                // new theme.Drawer("header_minicart", "right").open();
              }

              status.loading = false;
              // 2026-10-09 (Claude) Joel "NO SPIN" / "ship A": keep the Add to Cart wheel spinning until the cart drawer has
              // actually opened (it used to stop ~0.9s before the drawer, so the button sat idle). aoamOpenDrawerAfterRows calls
              // back when it opens; 3s fallback. Roll back: restore the plain classList.remove line and "!aoamOpenDrawerAfterRows(product)" below.
              var aoamAtcBtn = this.addToCart;
              var aoamAtcOff = function () { aoamAtcBtn.classList.remove("btn--loading"); };
              var aoamAtcHeld = !!(product && product.id) && aoamOpenDrawerAfterRows(product, aoamAtcOff);
              if (aoamAtcHeld) setTimeout(aoamAtcOff, 3000); else aoamAtcOff();
              // console.log("Added Product",product);

              // 2026-08-06 - same sweep. `product` is only assigned in the success branch above,
              // so on a 422 (sold out, cart limit) product.id threw a TypeError inside this then,
              // which is another uncaught rejection. A throttled /variants/<id>.js returns HTML
              // too, so guard the parse and still show the popup with the cart's own prices.
              // 2026-10-05 cart audit S11 (C42 left this request): the read below only filled the hidden popup, so it is skipped while
              // the popup is hidden and aoamOpenDrawerAfterRows opens the drawer instead. Roll back: restore "if (product && product.id) {".
              if (product && product.id && !aoamAtcHeld) {
                fetch(`/variants/${product.id}.js`)
                .then(res => (res.ok ? res.json() : null))
                .then(variantData => {
                  // Merge relevant variant info into the product object
                  if (variantData) {
                    product.price = variantData.price;
                    product.compare_at_price = variantData.compare_at_price;
                  }

                  addToCartPopup_fn(product);
                })
                .catch(err => {
                  console.error("Error fetching variant details:", err);
                  addToCartPopup_fn(product); // fallback
                });
              }

              // Reload page if adding product from a section on the cart page
              if (document.body.classList.contains("template-cart")) {
                window.scrollTo(0, 0);
                location.reload();
              }
            }.bind(this)
          )
          .catch(
            function (err) {
              console.error("Add to cart failed:", err);
              status.loading = false;
              this.addToCart.classList.remove("btn--loading");
            }.bind(this)
          );
      },

      success: function (product) {
        var errors = this.form.querySelector(".errors");
        if (errors) {
          errors.remove();
        }

        document.dispatchEvent(
          new CustomEvent("ajaxProduct:added", {
            detail: {
              product: product,
              addToCartBtn: this.addToCart,
            },
          })
        );

        if (this.args && this.args.scopedEventId) {
          document.dispatchEvent(
            new CustomEvent("ajaxProduct:added:" + this.args.scopedEventId, {
              detail: {
                product: product,
                addToCartBtn: this.addToCart,
              },
            })
          );
        }
      },

      error: function (error) {
        if (!error.description) {
          console.warn(error);
          return;
        }

        var errors = this.form.querySelector(".errors");
        if (errors) {
          errors.remove();
        }

        var errorDiv = document.createElement("div");
        errorDiv.classList.add("errors", "text-center");
        errorDiv.textContent = error.description;
        // 2026-10-10 audit: put the refusal message right under the Add button (was the end of the form, ~800px below on the Critter PDP); stays inside the form so success()/error() still remove it. text-wrap avoids a one-word last line.
        errorDiv.style.textWrap = "balance";
        var f19btn = this.addToCart;
        var f19anchor = f19btn && (f19btn.closest(".product-single__add-to-cart, .payment-buttons") || f19btn);
        if (f19anchor && f19anchor !== this.form && this.form.contains(f19anchor)) {
          f19anchor.insertAdjacentElement("afterend", errorDiv);
        } else {
          this.form.append(errorDiv);
        }

        document.dispatchEvent(
          new CustomEvent("ajaxProduct:error", {
            detail: {
              errorMessage: error.description,
            },
          })
        );

        if (this.args && this.args.scopedEventId) {
          document.dispatchEvent(
            new CustomEvent("ajaxProduct:error:" + this.args.scopedEventId, {
              detail: {
                errorMessage: error.description,
              },
            })
          );
        }
      },
    });

    return ProductForm;
  })();

  theme.ProductUpsellForm = (function () {
    var status = {
      loading: false,
    };

    function UpsellForm(form, submit, args) {
      this.form = form;
      this.args = args;

      var submitSelector = submit ? submit : ".add-upsell-product";

      if (this.form) {
        this.addToCart = form.querySelector(submitSelector);
        this.form.addEventListener("submit", this.addItemFromForm.bind(this));
      }
    }

    UpsellForm.prototype = Object.assign({}, UpsellForm.prototype, {
      addItemFromForm: function (evt, callback) {
        evt.preventDefault();

        if (status.loading) {
          return;
        }

        // Loading indicator on add to cart button
        this.addToCart.classList.add("btn--loading");
        this.addToCart.querySelector("[data-upsell-text]").innerText =
          theme.strings.upgrading;
        status.loading = true;

        var data = theme.utils.serialize(this.form);

        fetch(theme.routes.cartAdd, {
          method: "POST",
          body: data,
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "X-Requested-With": "XMLHttpRequest",
          },
        })
          // 2026-08-06 - Clarity/GA4 error-click sweep, same shape as ProductForm above. A
          // throttled or bot-challenged /cart/add returns HTML, so response.json() threw
          // "Unexpected token '<'" uncaught and left the upsell button stuck on "upgrading" with
          // status.loading true. 422 keeps its JSON body and still reaches this.error. Restore
          // the bare response.json() chain and drop the catch to roll back.
          .then((response) => {
            if (!response.ok && response.status !== 422) {
              throw new Error('cart/add ' + response.status);
            }
            return response.json();
          })
          .then(
            function (data) {
              if (data.status === 422) {
                this.error(data);
              } else {
                var product = data;
                this.success(product);
                // new theme.Drawer("header_minicart", "right").open();
              }

              status.loading = false;
              this.addToCart.classList.remove("btn--loading");
              this.addToCart.querySelector("[data-upsell-text]").innerText =
                theme.strings.upgraded;
              this.addToCart.disabled = true;

              // Reload page if adding product from a section on the cart page
              if (document.body.classList.contains("template-cart")) {
                window.scrollTo(0, 0);
                location.reload();
              }
            }.bind(this)
          )
          .catch(
            function (err) {
              console.error("Upsell add to cart failed:", err);
              status.loading = false;
              this.addToCart.classList.remove("btn--loading");
              // theme.strings.upgrade does not exist; the label's own data-text is what the
              // re-enable path further down this file uses to restore the resting caption.
              var upsellLabel = this.addToCart.querySelector("[data-upsell-text]");
              var restingText = upsellLabel && upsellLabel.getAttribute("data-text");
              if (upsellLabel && restingText) {
                upsellLabel.innerText = restingText;
              }
            }.bind(this)
          );
      },

      success: function (product) {
        var errors = this.form.querySelector(".errors");
        if (errors) {
          errors.remove();
        }

        document.dispatchEvent(
          new CustomEvent("ajaxProduct:added", {
            detail: {
              product: product,
              addToCartBtn: this.addToCart,
            },
          })
        );

        if (this.args && this.args.scopedEventId) {
          document.dispatchEvent(
            new CustomEvent("ajaxProduct:added:" + this.args.scopedEventId, {
              detail: {
                product: product,
                addToCartBtn: this.addToCart,
              },
            })
          );
        }
      },

      error: function (error) {
        if (!error.description) {
          console.warn(error);
          return;
        }

        var errors = this.form.querySelector(".errors");
        if (errors) {
          errors.remove();
        }

        var errorDiv = document.createElement("div");
        errorDiv.classList.add("errors", "text-center");
        errorDiv.textContent = error.description;
        // 2026-10-10 audit: put the refusal message right under the Add button (was the end of the form, ~800px below on the Critter PDP); stays inside the form so success()/error() still remove it. text-wrap avoids a one-word last line.
        errorDiv.style.textWrap = "balance";
        var f19btn = this.addToCart;
        var f19anchor = f19btn && (f19btn.closest(".product-single__add-to-cart, .payment-buttons") || f19btn);
        if (f19anchor && f19anchor !== this.form && this.form.contains(f19anchor)) {
          f19anchor.insertAdjacentElement("afterend", errorDiv);
        } else {
          this.form.append(errorDiv);
        }

        document.dispatchEvent(
          new CustomEvent("ajaxProduct:error", {
            detail: {
              errorMessage: error.description,
            },
          })
        );

        if (this.args && this.args.scopedEventId) {
          document.dispatchEvent(
            new CustomEvent("ajaxProduct:error:" + this.args.scopedEventId, {
              detail: {
                errorMessage: error.description,
              },
            })
          );
        }
      },
    });

    return UpsellForm;
  })();

  theme.ProductMedia = (function () {
    var modelJsonSections = {};
    var models = {};
    var xrButtons = {};

    var selectors = {
      mediaGroup: "[data-product-single-media-group]",
      xrButton: "[data-shopify-xr]",
    };

    function init(modelViewerContainers, sectionId) {
      modelJsonSections[sectionId] = {
        loaded: false,
      };

      modelViewerContainers.forEach(function (container, index) {
        var mediaId = container.dataset.mediaId;
        var modelViewerElement = container.querySelector("model-viewer");
        var modelId = modelViewerElement.dataset.modelId;

        if (index === 0) {
          var mediaGroup = container.closest(selectors.mediaGroup);
          var xrButton = mediaGroup.querySelector(selectors.xrButton);
          xrButtons[sectionId] = {
            element: xrButton,
            defaultId: modelId,
          };
        }

        models[mediaId] = {
          modelId: modelId,
          sectionId: sectionId,
          container: container,
          element: modelViewerElement,
        };
      });

      window.Shopify.loadFeatures([
        {
          name: "shopify-xr",
          version: "1.0",
          onLoad: setupShopifyXr,
        },
        {
          name: "model-viewer-ui",
          version: "1.0",
          onLoad: setupModelViewerUi,
        },
      ]);

      theme.LibraryLoader.load("modelViewerUiStyles");
    }

    function setupShopifyXr(errors) {
      if (errors) return;

      if (!window.ShopifyXR) {
        document.addEventListener("shopify_xr_initialized", function () {
          setupShopifyXr();
        });
        return;
      }

      for (var sectionId in modelJsonSections) {
        if (modelJsonSections.hasOwnProperty(sectionId)) {
          var modelSection = modelJsonSections[sectionId];

          if (modelSection.loaded) continue;

          var modelJson = document.querySelector("#ModelJson-" + sectionId);

          window.ShopifyXR.addModels(JSON.parse(modelJson.innerHTML));
          modelSection.loaded = true;
        }
      }
      window.ShopifyXR.setupXRElements();
    }

    function setupModelViewerUi(errors) {
      if (errors) return;

      for (var key in models) {
        if (models.hasOwnProperty(key)) {
          var model = models[key];
          if (!model.modelViewerUi && Shopify) {
            model.modelViewerUi = new Shopify.ModelViewerUI(model.element);
          }
          setupModelViewerListeners(model);
        }
      }
    }

    function setupModelViewerListeners(model) {
      var xrButton = xrButtons[model.sectionId];

      model.container.addEventListener("mediaVisible", function () {
        xrButton.element.setAttribute("data-shopify-model3d-id", model.modelId);
        if (theme.config.isTouch) return;
        model.modelViewerUi.play();
      });

      model.container.addEventListener("mediaHidden", function () {
        xrButton.element.setAttribute(
          "data-shopify-model3d-id",
          xrButton.defaultId
        );
        model.modelViewerUi.pause();
      });

      model.container.addEventListener("xrLaunch", function () {
        model.modelViewerUi.pause();
      });
    }

    function removeSectionModels(sectionId) {
      for (var key in models) {
        if (models.hasOwnProperty(key)) {
          var model = models[key];
          if (model.sectionId === sectionId) {
            delete models[key];
          }
        }
      }
      delete modelJsonSections[sectionId];
    }

    return {
      init: init,
      removeSectionModels: removeSectionModels,
    };
  })();

  /* 2026-11-03 cart audit F-002 / F-010 (Claude, W1a): the qty box writes its new number BEFORE the request, and
     nothing put it back when the write failed, so the next tap counted from a number the cart never had. Each box now
     remembers the last confirmed quantity (data-aoam-ok); a failed write restores it at once, re-reads /cart.js to be
     sure, and (unless Shopify already sent its own sentence) shows a short line under the row. */
  function aoamQtyInputs(key) {
    var out = [];
    try { document.querySelectorAll(".js-qty__num").forEach(function (i) { if (i.getAttribute("data-id") === String(key)) out.push(i); }); } catch (e) {}
    return out;
  }
  function aoamQtyOk(key, cart) {
    try {
      var line = (cart && cart.items || []).filter(function (i) { return i.key === key; })[0];
      aoamQtyInputs(key).forEach(function (i) { i.setAttribute("data-aoam-ok", String(line ? line.quantity : 0)); });
    } catch (e) {}
  }
  function aoamQtyFailed(key, el, hasMsg) {
    try {
      aoamQtyInputs(key).forEach(function (i) { var ok = i.getAttribute("data-aoam-ok"); if (ok != null && ok !== "") i.value = ok; });
      fetch("/cart.js?_=" + Date.now(), { credentials: "same-origin", cache: "no-store", headers: { "X-Requested-With": "XMLHttpRequest" } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (c) {
          if (!c || !c.items) return;
          var line = c.items.filter(function (i) { return i.key === key; })[0];
          if (!line) return;
          aoamQtyInputs(key).forEach(function (i) { i.value = String(line.quantity); i.setAttribute("data-aoam-ok", String(line.quantity)); });
        })
        .catch(function () {});
      if (!hasMsg && typeof window.aoamDrawerNotice === "function") window.aoamDrawerNotice("That didn’t update, so your cart is unchanged. Please try again.", { key: key, ms: 5000 });
    } catch (e) {}
  }

  theme.QtySelector = (function () {
    var selectors = {
      input: ".js-qty__num",
      plus: ".js-qty__adjust--plus",
      minus: ".js-qty__adjust--minus",
    };

    function QtySelector(el, options) {
      this.wrapper = el;
      this.plus = el.querySelector(selectors.plus);
      this.minus = el.querySelector(selectors.minus);
      this.input = el.querySelector(selectors.input);
      this.minValue = this.input.getAttribute("min") || 1;

      var defaults = {
        namespace: null,
        isCart: false,
        key: this.input.dataset.id,
      };

      this.options = Object.assign({}, defaults, options);

      this.init();
    }

    QtySelector.prototype = Object.assign({}, QtySelector.prototype, {
      init: function () {
        this.plus.addEventListener(
          "click",
          function () {
            var qty = this._getQty();
            this._change(qty + 1);
          }.bind(this)
        );

        this.minus.addEventListener(
          "click",
          function () {
            var qty = this._getQty();
            this._change(qty - 1);
          }.bind(this)
        );

        this.input.addEventListener(
          "change",
          function (evt) {
            this._change(this._getQty());
          }.bind(this)
        );
      },

      _getQty: function () {
        var qty = this.input.value;
        if (parseFloat(qty) == parseInt(qty) && !isNaN(qty)) {
          // We have a valid number!
        } else {
          // Not a number. Default to 1.
          qty = 1;
        }
        return parseInt(qty);
      },

      _change: function (qty) {
        if (qty <= this.minValue) {
          qty = this.minValue;
        }

        // 2026-11-03 cart audit F-002 (Claude, W1a): remember the confirmed number before the first optimistic write.
        if (this.options.isCart && !this.input.hasAttribute("data-aoam-ok")) this.input.setAttribute("data-aoam-ok", this.input.value);
        this.input.value = qty;

        if (this.options.isCart) {
          document.dispatchEvent(
            new CustomEvent("cart:quantity" + this.options.namespace, {
              detail: [this.options.key, qty, this.wrapper],
            })
          );
        }
      },
    });

    return QtySelector;
  })();

  theme.DeleteProduct = (function () {
    function DeleteProduct(el, options) {
      this.wrapper = el;

      var defaults = {
        namespace: null,
        isCart: false,
      };

      this.options = Object.assign({}, defaults, options);
      this.init();
    }

    DeleteProduct.prototype = Object.assign({}, DeleteProduct.prototype, {
      init: function () {
        this.wrapper.addEventListener(
          "click",
          function (e) {
            e.preventDefault();
            this.wrapper.classList.add('btn--loading');
            this._delete();
          }.bind(this)
        );
      },

      _delete: function () {
        document.dispatchEvent(
          new CustomEvent("cart:delete" + this.options.namespace, {
            detail: [this.options.key, 0, this.wrapper],
          })
        );
      },
    });

    return DeleteProduct;
  })();

  // theme.Slideshow handles all flickity based sliders
  // Child navigation is only setup to work on product images
  theme.Slideshow = (function () {
    var classes = {
      animateOut: "animate-out",
      isPaused: "is-paused",
      isActive: "is-active",
    };

    var selectors = {
      allSlides: ".slideshow__slide",
      currentSlide: ".is-selected",
      wrapper: ".slideshow-wrapper",
      pauseButton: ".slideshow__pause",
    };

    var productSelectors = {
      thumb: ".product__thumb-item:not(.hide)",
      links: ".product__thumb-item:not(.hide) a",
      arrow: ".product__thumb-arrow",
    };

    var defaults = {
      adaptiveHeight: false,
      autoPlay: false,
      avoidReflow: false,
      childNav: null,
      childNavScroller: null,
      childVertical: false,
      dragThreshold: 7,
      fade: false,
      friction: 0.8,
      initialIndex: 0,
      pageDots: false,
      pauseAutoPlayOnHover: false,
      prevNextButtons: false,
      rightToLeft: theme.config.rtl,
      selectedAttraction: 0.14,
      setGallerySize: true,
      wrapAround: true,
      imagesLoaded: true,
    };

    function slideshow(el, args) {
      this.el = el;
      this.args = Object.assign({}, defaults, args);

      // Setup listeners as part of arguments
      this.args.on = {
        ready: this.init.bind(this),
        change: this.slideChange.bind(this),
        settle: this.afterChange.bind(this),
      };

      if (this.args.childNav) {
        this.childNavEls = this.args.childNav.querySelectorAll(
          productSelectors.thumb
        );
        this.childNavLinks = this.args.childNav.querySelectorAll(
          productSelectors.links
        );
        this.arrows = this.args.childNav.querySelectorAll(
          productSelectors.arrow
        );
        if (this.childNavLinks.length) {
          this.initChildNav();
        }
      }

      if (this.args.avoidReflow) {
        avoidReflow(el);
      }

      this.slideshow = new Flickity(el, this.args);

      if (this.args.autoPlay) {
        var wrapper = el.closest(selectors.wrapper);
        this.pauseBtn = wrapper?.querySelector(selectors.pauseButton);
        if (this.pauseBtn) {
          this.pauseBtn.addEventListener("click", this._togglePause.bind(this));
        }
      }

      // Reset dimensions on resize
      window.on(
        "resize",
        theme.utils.debounce(
          300,
          function () {
            this.resize();
          }.bind(this)
        )
      );

      // Set flickity-viewport height to first element to
      // avoid awkward page reflows while initializing.
      // Must be added in a `style` tag because element does not exist yet.
      // Slideshow element must have an ID
      function avoidReflow(el) {
        if (!el.id) return;
        var firstChild = el.firstChild;
        while (firstChild != null && firstChild.nodeType == 3) {
          // skip TextNodes
          firstChild = firstChild.nextSibling;
        }
        var style = document.createElement("style");
        style.innerHTML = `#${el.id} .flickity-viewport{height:${firstChild.offsetHeight}px}`;
        document.head.appendChild(style);
      }
    }

    slideshow.prototype = Object.assign({}, slideshow.prototype, {
      init: function (el) {
        this.currentSlide = this.el.querySelector(selectors.currentSlide);

        // Optional onInit callback
        if (this.args.callbacks && this.args.callbacks.onInit) {
          if (typeof this.args.callbacks.onInit === "function") {
            this.args.callbacks.onInit(this.currentSlide);
          }
        }
      },

      slideChange: function (index) {
        // Outgoing fade styles
        if (this.args.fade && this.currentSlide) {
          this.currentSlide.classList.add(classes.animateOut);
          this.currentSlide.addEventListener(
            "transitionend",
            function () {
              this.currentSlide.classList.remove(classes.animateOut);
            }.bind(this)
          );
        }

        // Match index with child nav
        if (this.args.childNav) {
          this.childNavGoTo(index);
        }

        // Optional onChange callback
        if (this.args.callbacks && this.args.callbacks.onChange) {
          if (typeof this.args.callbacks.onChange === "function") {
            this.args.callbacks.onChange(index);
          }
        }

        // Enable/Disable arrows depending on selected index
        if (this.arrows && this.arrows.length) {
          this.arrows[0].classList.toggle("disable", index === 0);
          this.arrows[1].classList.toggle("disable",index === this.childNavLinks.length - 1);
        }
      },
      afterChange: function (index) {
        // Remove all fade animation classes after slide is done
        if (this.args.fade) {
          this.el.querySelectorAll(selectors.allSlides).forEach((slide) => {
            slide.classList.remove(classes.animateOut);
          });
        }

        this.currentSlide = this.el.querySelector(selectors.currentSlide);

        // Match index with child nav (in case slider height changed first)
        if (this.args.childNav) {
          this.childNavGoTo(this.slideshow.selectedIndex);
        }
      },
      destroy: function () {
        if (this.args.childNav && this.childNavLinks.length) {
          this.childNavLinks.forEach((a) => {
            a.classList.remove(classes.isActive);
          });
        }
        this.slideshow.destroy();
      },
      _togglePause: function () {
        if (this.pauseBtn.classList.contains(classes.isPaused)) {
          this.pauseBtn.classList.remove(classes.isPaused);
          this.slideshow.playPlayer();
        } else {
          this.pauseBtn.classList.add(classes.isPaused);
          this.slideshow.pausePlayer();
        }
      },
      resize: function () {
        this.slideshow.resize();
      },
      play: function () {
        this.slideshow.playPlayer();
      },
      pause: function () {
        this.slideshow.pausePlayer();
      },
      goToSlide: function (i) {
        this.slideshow.select(i);
      },
      setDraggable: function (enable) {
        this.slideshow.options.draggable = enable;
        this.slideshow.updateDraggable();
      },

      initChildNav: function () {
        this.childNavLinks[this.args.initialIndex].classList.add("is-active");

        // Setup events
        this.childNavLinks.forEach((link, i) => {
          // update data-index because image-set feature may be enabled
          link.setAttribute("data-index", i);

          link.addEventListener(
            "click",
            function (evt) {
              evt.preventDefault();
              this.goToSlide(this.getChildIndex(evt.currentTarget));
            }.bind(this)
          );
          link.addEventListener(
            "focus",
            function (evt) {
              this.goToSlide(this.getChildIndex(evt.currentTarget));
            }.bind(this)
          );
          link.addEventListener(
            "keydown",
            function (evt) {
              if (evt.keyCode === 13) {
                this.goToSlide(this.getChildIndex(evt.currentTarget));
              }
            }.bind(this)
          );
        });

        // Setup optional arrows
        if (this.arrows.length) {
          this.arrows.forEach((arrow) => {
            arrow.addEventListener("click", this.arrowClick.bind(this));
          });
        }
      },

      getChildIndex: function (target) {
        return parseInt(target.dataset.index);
      },

      childNavGoTo: function (index) {
        this.childNavLinks.forEach((a) => {
          a.classList.remove(classes.isActive);
        });

        var el = this.childNavLinks[index];
        el.classList.add(classes.isActive);

        if (!this.args.childNavScroller) {
          return;
        }

        if (this.args.childVertical) {
          var elTop = el.offsetTop;
          this.args.childNavScroller.scrollTop = elTop - 100;
        } else {
          var elLeft = el.offsetLeft;
          this.args.childNavScroller.scrollLeft = elLeft - 100;
        }
      },

      arrowClick: function (evt) {
        if (
          evt.currentTarget.classList.contains("product__thumb-arrow--prev")
        ) {
          this.slideshow.previous();
        } else {
          this.slideshow.next();
        }
      },
    });

    return slideshow;
  })();

  theme.StoreAvailability = (function () {
    var selectors = {
      drawerOpenBtn: ".js-drawer-open-availability",
      modalOpenBtn: ".js-modal-open-availability",
      productTitle: "[data-availability-product-title]",
    };

    function StoreAvailability(container) {
      this.container = container;
      this.baseUrl = container.dataset.baseUrl;
      this.productTitle = container.dataset.productName;
    }

    StoreAvailability.prototype = Object.assign(
      {},
      StoreAvailability.prototype,
      {
        updateContent: function (variantId) {
          var variantSectionUrl =
            this.baseUrl +
            "/variants/" +
            variantId +
            "/?section_id=store-availability";

          var self = this;

          fetch(variantSectionUrl)
            .then(function (response) {
              return response.text();
            })
            .then(function (html) {
              if (html.trim() === "") {
                this.container.innerHTML = "";
                return;
              }

              self.container.innerHTML = html;
              self.container.innerHTML =
                self.container.firstElementChild.innerHTML;

              // Setup drawer if have open button
              if (self.container.querySelector(selectors.drawerOpenBtn)) {
                self.drawer = new theme.Drawer(
                  "StoreAvailabilityDrawer",
                  "availability"
                );
              }

              // Setup modal if have open button
              if (self.container.querySelector(selectors.modalOpenBtn)) {
                self.modal = new theme.Modals(
                  "StoreAvailabilityModal",
                  "availability"
                );
              }

              var title = self.container.querySelector(selectors.productTitle);
              if (title) {
                title.textContent = self.productTitle;
              }
            });
        },
      }
    );

    return StoreAvailability;
  })();

  /*============================================================================
  VariantAvailability
  - Cross out sold out or unavailable variants
  - To disable, set dynamicVariantsEnable to false in theme.liquid
  - Required markup:
    - class=variant-input-wrap to wrap select or button group
    - class=variant-input to wrap button/label
    ==============================================================================*/

  theme.VariantAvailability = (function () {
    var classes = {
      disabled: "disabled",
    };

    function VariantAvailability(args) {
      this.type = args.type;
      this.variantsObject = args.variantsObject;
      this.currentVariantObject = args.currentVariantObject;
      this.container = args.container;
      this.namespace = args.namespace;

      this.init();
    }

    VariantAvailability.prototype = Object.assign(
      {},
      VariantAvailability.prototype,
      {
        init: function () {
          this.container.on(
            "variantChange" + this.namespace,
            this.setAvailability.bind(this)
          );

          // Set default state based on current selected variant
          this.setAvailability(null, this.currentVariantObject);
        },

        setAvailability: function (evt, variant) {
          if (evt) {
            var variant = evt.detail.variant;
          }

          // Object to hold all options by value.
          // This will be what sets a button/dropdown as
          // sold out or unavailable (not a combo set as purchasable)
          var valuesToManage = {
            option1: [],
            option2: [],
            option3: [],
          };

          var ignoreIndex = null;
          var availableVariants = this.variantsObject.filter(function (el) {
            if (!variant || variant.id === el.id) {
              return false;
            }

            if (
              variant.option2 === el.option2 &&
              variant.option3 === el.option3
            ) {
              return true;
            }

            if (
              variant.option1 === el.option1 &&
              variant.option3 === el.option3
            ) {
              return true;
            }

            if (
              variant.option1 === el.option1 &&
              variant.option2 === el.option2
            ) {
              return true;
            }
          });

          var variantObject = {
            variant: variant,
          };

          var variants = Object.assign({}, { variant }, availableVariants);

          // Disable all options to start.
          // If coming from a variant change event, do not disable
          // options inside current index group
          this.container
            .querySelectorAll(".variant-input-wrap")
            .forEach((group) => {
              this.disableVariantGroup(group);
            });

          // Loop through each available variant to gather variant values
          for (var property in variants) {
            if (variants.hasOwnProperty(property)) {
              var item = variants[property];
              if (!item) {
                return;
              }

              var value1 = item.option1;
              var value2 = item.option2;
              var value3 = item.option3;
              var soldOut = item.available === false;

              if (value1 && ignoreIndex !== "option1") {
                valuesToManage.option1.push({
                  value: value1,
                  soldOut: soldOut,
                });
              }
              if (value2 && ignoreIndex !== "option2") {
                valuesToManage.option2.push({
                  value: value2,
                  soldOut: soldOut,
                });
              }
              if (value3 && ignoreIndex !== "option3") {
                valuesToManage.option3.push({
                  value: value3,
                  soldOut: soldOut,
                });
              }
            }
          }

          // Loop through all option levels and send each
          // value w/ args to function that determines to show/hide/enable/disable
          for (var [option, values] of Object.entries(valuesToManage)) {
            this.manageOptionState(option, values);
          }
        },

        manageOptionState: function (option, values) {
          var group = this.container.querySelector(
            '.variant-input-wrap[data-index="' + option + '"]'
          );

          // Loop through each option value
          values.forEach((obj) => {
            this.enableVariantOption(group, obj);
          });
        },

        enableVariantOptionByValue: function (array, index) {
          var group = this.container.querySelector(
            '.variant-input-wrap[data-index="' + index + '"]'
          );

          for (var i = 0; i < array.length; i++) {
            this.enableVariantOption(group, array[i]);
          }
        },

        enableVariantOption: function (group, obj) {
          // Selecting by value so escape it
          var value = obj.value.replace(
            /([ #;&,.+*~\':"!^$[\]()=>|\/@])/g,
            "\\$1"
          );

          if (this.type === "dropdown") {
            group.querySelector(
              'option[value="' + value + '"]'
            ).disabled = false;
          } else {
            var buttonGroup = group.querySelector(
              '.variant-input[data-value="' + value + '"]'
            );
            var input = buttonGroup.querySelector("input");
            var label = buttonGroup.querySelector("label");

            // Variant exists - enable & show variant
            input.classList.remove(classes.disabled);
            label.classList.remove(classes.disabled);

            // Variant sold out - cross out option (remains selectable)
            if (obj.soldOut) {
              input.classList.add(classes.disabled);
              label.classList.add(classes.disabled);
            }
          }
        },

        disableVariantGroup: function (group) {
          if (this.type === "dropdown") {
            group.querySelectorAll("option").forEach((option) => {
              option.disabled = true;
            });
          } else {
            group.querySelectorAll("input").forEach((input) => {
              input.classList.add(classes.disabled);
            });
            group.querySelectorAll("label").forEach((label) => {
              label.classList.add(classes.disabled);
            });
          }
        },
      }
    );

    return VariantAvailability;
  })();

  // Video modal will auto-initialize for any anchor link that points to YouTube
  // MP4 videos must manually be enabled with:
  //   - .product-video-trigger--mp4 (trigger button)
  //   - .product-video-mp4-sound video player element (cloned into modal)
  //     - see media.liquid for example of this
  theme.videoModal = function () {
    var youtubePlayer;

    var videoHolderId = "video-wrapper";
    var selectors = {
      youtube: 'a[href*="youtube.com/watch"], a[href*="youtu.be/"]',
      mp4Trigger: ".product-video-trigger--mp4",
      mp4Player: ".product-video-mp4-sound",
    };

    var youtubeTriggers = document.querySelectorAll(selectors.youtube);
    var mp4Triggers = document.querySelectorAll(selectors.mp4Trigger);

    if (!youtubeTriggers.length && !mp4Triggers.length) {
      return;
    }

    var videoHolderDiv = document.getElementById(videoHolderId);

    if (youtubeTriggers.length) {
      theme.LibraryLoader.load("youtubeSdk");
    }

    var modal = new theme.Modals("video-modal", "video-wrapper", {
      closeOffContentClick: true,
      bodyOpenClass: ["modal-open", "video-modal-open"],
      solid: true,
    });

    youtubeTriggers.forEach((btn) => {
      btn.addEventListener("click", triggerYouTubeModal);
    });

    mp4Triggers.forEach((btn) => {
      btn.addEventListener("click", triggerMp4Modal);
    });

    document.addEventListener("modalClose.video-modal", closeVideoModal);

    function triggerYouTubeModal(evt) {
      // If not already loaded, treat as normal link
      if (!theme.config.youTubeReady) {
        return;
      }

      evt.preventDefault();
      emptyVideoHolder();

      modal.open(evt);

      var videoId = getYoutubeVideoId(evt.currentTarget.getAttribute("href"));
      youtubePlayer = new theme.YouTube(videoHolderId, {
        videoId: videoId,
        style: "sound",
        events: {
          onReady: onYoutubeReady,
        },
      });
    }

    function triggerMp4Modal(evt) {
      emptyVideoHolder();

      var el = evt.currentTarget;
      var player = el.parentNode.querySelector(selectors.mp4Player);

      // Clone video element and place it in the modal
      var playerClone = player.cloneNode(true);
      playerClone.classList.remove("hide");

      videoHolderDiv.append(playerClone);
      modal.open(evt);

      // Play new video element
      videoHolderDiv.querySelector("video").play();
    }

    function onYoutubeReady(evt) {
      evt.target.unMute();
      evt.target.playVideo();
    }

    function getYoutubeVideoId(url) {
      var regExp =
        /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
      var match = url.match(regExp);
      return match && match[7].length == 11 ? match[7] : false;
    }

    function emptyVideoHolder() {
      videoHolderDiv.innerHTML = "";
    }

    function closeVideoModal() {
      if (youtubePlayer && typeof youtubePlayer.destroy === "function") {
        youtubePlayer.destroy();
      } else {
        emptyVideoHolder();
      }
    }
  };

  theme.Accordion = (function () {
    function Accordion(container) {
      this.container = container;
      this.init();
    }

    Accordion.prototype = Object.assign({}, Accordion.prototype, {
      init: function () {
        var self = this;
        this.container
          .querySelectorAll("[data-heading-selector]")
          .forEach((el) => {
            let type = el.dataset.value;
            el.addEventListener("click", function () {
              [...self.container.querySelectorAll(".item")].map((x) =>
                x.classList.remove("active")
              );
              [...self.container.querySelectorAll("[data-faq-card]")].map((x) =>
                x.classList.add("hide")
              );
              [...self.container.querySelectorAll("[data-faq-card-head]")].map(
                (x) => x.classList.add("hide")
              );
              [
                ...self.container.querySelectorAll(
                  '[data-type="' + type + '"]'
                ),
              ].map((x) => x.classList.remove("hide"));

              this.classList.add("active");
            });
          });

        this.container
          .querySelectorAll("[data-faq-card]")
          .forEach((element) => {
            if (!element.querySelector("[data-question]")) return;
            element
              .querySelector("[data-question]")
              .addEventListener("click", function () {
                element.closest("[data-faq-card]").classList.toggle("active");
                if (
                  element
                    .closest("[data-faq-card]")
                    .classList.contains("active")
                ) {
                  element
                    .querySelector('[type="button"]')
                    .setAttribute("aria-expanded", "true");
                  element
                    .querySelector("[data-answer]")
                    .setAttribute("aria-hidden", "false");
                } else {
                  element
                    .querySelector('[type="button"]')
                    .setAttribute("aria-expanded", "false");
                  element
                    .querySelector("[data-answer]")
                    .setAttribute("aria-hidden", "true");
                }
              });
          });

        this.container
          .querySelectorAll("[data-faq-card-head]")
          .forEach((element) => {
            let type = element.dataset.type;
            element.addEventListener("click", () => {
              // console.log(
              //   ...self.container.querySelectorAll("[data-faq-card-head]")
              // );
              this.container
                .querySelectorAll('[data-type="' + type + '"]')
                .forEach((el) => {
                  el.classList.toggle("visible");
                });
            });
          });
      },
    });

    return Accordion;
  })();

  theme.Header = (function () {
    var selectors = {
      locale: "[data-disclosure-locale]",
      currency: "[data-disclosure-currency]",
      searchButtonToggle: "[data-search-toggle]",
    };

    function Header(container) {
      this.container = container;
      this.init();
    }

    Header.prototype = Object.assign({}, Header.prototype, {
      init: function () {
        this.__search();
        this.__mobileNav();
        this.__miniCart();
        theme.headerSearch.init();

        // The header holds up to two of each selector: the toolbar widget and the
        // mobile drawer copy. querySelector wired only whichever came first in the
        // DOM, leaving the other dead - init every instance.
        this.localeDisclosures = Array.prototype.map.call(
          this.container.querySelectorAll(selectors.locale),
          function (el) { return new theme.Disclosure(el); }
        );
        this.currencyDisclosures = Array.prototype.map.call(
          this.container.querySelectorAll(selectors.currency),
          function (el) { return new theme.Disclosure(el); }
        );

        // Enable header cart drawer when not on cart page
        if (!document.body.classList.contains("template-cart")) {
          new theme.HeaderCart();
        }
      },

      __search: function () {
        var search = document.querySelector(selectors.searchButtonToggle);
        // search.addEventListener('click', (e) => {
        // 	e.preventDefault();
        // });
      },

      // __mobileNav() {
      //   new theme.Drawer("header-mobile__menu", "left");

      //   document
      //     .querySelectorAll("[data-dropdown-toggle]")
      //     .forEach((element) => {

      //       element.addEventListener("click", (e) => {
      //         e.preventDefault();
      //         element.closest(".site--nav-dropdown").classList.toggle("active");
      //       });
      //     });
      // },
      __mobileNav() {
        new theme.Drawer("header-mobile__menu", "left");

        document
          .querySelectorAll("[data-dropdown-toggle]")
          .forEach((element) => {
            element.addEventListener("click", (e) => {
              e.preventDefault();

              const dropdownWrapper = element.closest(".site--nav-dropdown");
              const parentNav = element.closest(".site-navigation.mobile.main-navigation");

              // Proceed only if inside correct nav
              if (dropdownWrapper && parentNav) {
                // Remove active from all other dropdowns inside same nav
                parentNav.querySelectorAll(".site--nav-dropdown.active").forEach((activeEl) => {
                  if (activeEl !== dropdownWrapper) {
                    activeEl.classList.remove("active");
                  }
                });

                // Toggle only the clicked one
                dropdownWrapper.classList.toggle("active");
              }
            });
          });
      },

      __miniCart() {
        if (!document.body.classList.contains("template-cart")) {
          new theme.Drawer("header_minicart", "right");
        }
      },

      onUnload: function () {
        (this.localeDisclosures || []).forEach(function (d) { d.destroy(); });
        (this.currencyDisclosures || []).forEach(function (d) { d.destroy(); });
      },
    });

    return Header;
  })();

  theme.ProductSlider = (function () {
    function ProductSlider(container) {
      this.container = container;
      var sectionId = container.getAttribute("data-section-id");
      this.slideshow = container.querySelector("#ProductSlider_" + sectionId);

      if (!this.slideshow) {
        return;
      }

      this.init(container);
    }

    ProductSlider.prototype = Object.assign({}, ProductSlider.prototype, {
      init: function (container) {
        var sliderArgs = {
          cellAlign: "left",
          wrapAround: true,
          pageDots: true,
          prevNextButtons: true,
          arrowShape: { x0: 10, x1: 60, y1: 50, x2: 70, y2: 40, x3: 30, }, 
        };

        this.flickity = new theme.Slideshow(this.slideshow, sliderArgs);


        // If container not set, section has been reinitialized.
        // Update this.container to refreshed DOM element
        if (!container) {
          this.container = document.getElementById(this.containerId);
        }

        this.quickAdd = new theme.QuickAdd(this.container);
        this.quickShop = new theme.QuickShop(this.container);
        updateDotPagination(this.container);
      },
    });

    return ProductSlider;
  })();

  theme.Footer = (function () {
    var selectors = {
      scroll: "[data-scrollup]",
      locale: "[data-disclosure-locale]",
      currency: "[data-disclosure-currency]",
    };

    function Footer(container) {
      this.container = container;

      this.init();
    }

    Footer.prototype = Object.assign({}, Footer.prototype, {
      init: function () {
        var localeElement = this.container.querySelector(selectors.locale);
        var currencyElement = this.container.querySelector(selectors.currency);

        if (localeElement) {
          this.localeDisclosure = new theme.Disclosure(localeElement);
        }

        if (currencyElement) {
          this.currencyDisclosure = new theme.Disclosure(currencyElement);
        }

        this.__footerToggle();
        this.__scrollUp();
      },
      __footerToggle: function () {
        this.container
          .querySelectorAll("[data-footer-block]")
          .forEach((element) => {
            let toggleBtn = element.querySelector(".title");
           if(toggleBtn) {
                  toggleBtn.addEventListener("click", function () {
                    element.classList.toggle("active");
                  });
           }
          });
      },
      __scrollUp() {
        let scrollElement = document.querySelector(selectors.scroll);
        if (scrollElement) {
          document.addEventListener("scroll", () => {
            var scrollValue = window.scrollY;
            if (scrollValue > 1000) {
              scrollElement.classList.add("active");
            } else {
              scrollElement.classList.remove("active");
            }
          });

          scrollElement.addEventListener("click", () => {
            document.documentElement.scrollTo({
              top: 0,
              behavior: "smooth",
            });
          });
        }
      },
      onUnload: function () {
        if (this.localeDisclosure) {
          this.localeDisclosure.destroy();
        }

        if (this.currencyDisclosure) {
          this.currencyDisclosure.destroy();
        }
      },
    });

    return Footer;
  })();

  theme.Product = (function () {
    var videoObjects = {};

    var classes = {
      onSale: "on-sale",
      disabled: "disabled",
      isModal: "is-modal",
      loading: "loading",
      loaded: "loaded",
      hidden: "hide",
      interactable: "video-interactable",
      visuallyHide: "visually-invisible",
    };

    var selectors = {
      productVideo: ".product__video",
      videoParent: ".product__video-wrapper",
      slide: ".product-main-slide",
      currentSlide: ".is-selected",
      startingSlide: ".starting-slide",
      variantType: ".variant-wrapper",
      blocks: "[data-product-blocks]",
      blocksHolder: "[data-blocks-holder]",
    };

    function Product(container) {
      this.container = container;
      var sectionId = (this.sectionId =
        container.getAttribute("data-section-id"));
      var productId = (this.productId =
        container.getAttribute("data-product-id"));

      this.inModal = container.dataset.modal === "true";
      this.modal;

      this.settings = {
        enableHistoryState: container.dataset.history === "true" || false,
        namespace: ".product-" + sectionId,
        inventory: false,
        inventoryThreshold: 10,
        modalInit: false,
        hasImages: true,
        imageSetName: null,
        imageSetIndex: null,
        currentImageSet: null,
        imageSize: "680x",
        currentSlideIndex: 0,
        videoLooping: container.dataset.videoLooping,
      };

      // Overwrite some settings when loaded in modal
      if (this.inModal) {
        this.settings.enableHistoryState = false;
        this.settings.namespace = ".product-" + sectionId + "-modal";
        this.modal = document.getElementById("QuickShopModal-" + productId);
      }

      this.selectors = {
        variantsJson: "[data-variant-json]",
        currentVariantJson: "[data-current-variant-json]",
        form: ".product-single__form",

        media: "[data-product-media-type-model]",
        closeMedia: ".product-single__close-media",
        photoThumbs: "[data-product-thumb]",
        thumbSlider: "[data-product-thumbs]",
        thumbScroller: ".product-thumbs__scroller",
        mainSlider: "[data-product-photos]",
        imageContainer: "[data-product-images]",
        productImageMain: "[data-product-image-main]",
        priceWrapper: "[data-product-price-wrap]",
        price: "[data-product-price]",
        comparePrice: "[data-compare-price]",
        savePrice: "[data-save-price]",
        priceA11y: "[data-a11y-price]",
        comparePriceA11y: "[data-compare-price-a11y]",
        unitWrapper: "[data-unit-price-wrapper]",
        unitPrice: "[data-unit-price]",
        unitPriceBaseUnit: "[data-unit-base]",
        sku: "[data-sku]",
        inventory: "[data-product-inventory]",
        incomingInventory: "[data-incoming-inventory]",
        colorLabel: "[data-variant-color-label]",
        addToCart: "[data-add-to-cart]",
        addToCartText: "[data-add-to-cart-text]",
        originalSelectorId: "[data-product-select]",
        singleOptionSelector: "[data-variant-input]",
        variantColorSwatch: ".variant__input--color-swatch",
        availabilityContainer: "[data-store-availability-holder]",
      };

      this.cacheElements();

      this.firstProductImage = this.cache.mainSlider.querySelector("img");

      if (!this.firstProductImage) {
        this.settings.hasImages = false;
      }

      var dataSetEl = this.cache.mainSlider.querySelector("[data-set-name]");
      if (dataSetEl) {
        this.settings.imageSetName = dataSetEl.dataset.setName;
      }

      this.init();
    }

    Product.prototype = Object.assign({}, Product.prototype, {
      init: function () {
        if (this.inModal) {
          this.container.classList.add(classes.isModal);
          document.addEventListener(
            "modalOpen.QuickShopModal-" + this.productId,
            this.openModalProduct.bind(this)
          );
          document.addEventListener(
            "modalClose.QuickShopModal-" + this.productId,
            this.closeModalProduct.bind(this)
          );
        }

        if (!this.inModal) {
          this.formSetup();
          this.productSetup();
          this.videoSetup();
          this.variantDropdownUpdated();
          this.initProductSlider();
          this.customMediaListners();
          this.addIdToRecentlyViewed();
          this.initProductProperties();
        }

        this.reviewScroll();

        // Quick add hook
        window.off("quickadd:loaded:" + this.sectionId);
        window.on(
          "quickadd:loaded:" + this.sectionId,
          this.initQuickAddForm.bind(this)
        );
      },

      variantDropdownUpdated: function () {
        document
          .querySelectorAll(".select-variant__dropdown")
          .forEach((element) => {
            // 2026-08-12 - Joel: "improve these drop down menus". The custom dropdown was
            // mouse-only: no tab stop, no keys, nothing for a screen reader. The toggle is now
            // focusable and carries a real accessible name (the Choose <option> label plus the
            // current value via aria-labelledby); Enter/Space toggles, Escape closes just the
            // list (swallowing the paired Escape KEYUP, because theme.Modals closes on window
            // keyup 27 and keydown-side code cannot cancel that; today this wiring only reaches
            // non-modal sections, so the swallower is a cheap defense for when it ever does),
            // Tab closes the list on the way out, ArrowUp/ArrowDown change the value and keep
            // the list open if it was open. No aria-haspopup on purpose: the ul is not a
            // role=listbox, so this stays a plain disclosure button. The tabindex guard stops
            // duplicate keydown listeners on re-init. Delete this block (and the aria-expanded
            // lines below) to roll back.
            let ddToggle = element.querySelector(".select-selected");
            if (ddToggle && !ddToggle.hasAttribute("tabindex")) {
              ddToggle.setAttribute("tabindex", "0");
              ddToggle.setAttribute("role", "button");
              ddToggle.setAttribute("aria-expanded", "false");
              let ddWrapper = element.closest(".variant-wrapper");
              let ddLabel =
                ddWrapper && ddWrapper.querySelector(".variant__label");
              if (ddLabel) {
                let ddKey = ddLabel.getAttribute("for") || "variant-dd";
                if (!ddLabel.id) ddLabel.id = ddKey + "-label";
                if (!ddToggle.id) ddToggle.id = ddKey + "-toggle";
                ddToggle.setAttribute(
                  "aria-labelledby",
                  ddLabel.id + " " + ddToggle.id
                );
              }
              ddToggle.addEventListener("keydown", function (ev) {
                let items = [...element.querySelectorAll(".item")];
                if (!items.length) return;
                if (ev.key === "Enter" || ev.key === " ") {
                  ev.preventDefault();
                  element.classList.toggle("active");
                  ddToggle.setAttribute(
                    "aria-expanded",
                    element.classList.contains("active")
                  );
                } else if (ev.key === "Escape") {
                  if (element.classList.contains("active")) {
                    element.classList.remove("active");
                    ddToggle.setAttribute("aria-expanded", "false");
                    window.addEventListener(
                      "keyup",
                      function (up) {
                        if (up.key === "Escape") up.stopImmediatePropagation();
                      },
                      { capture: true, once: true }
                    );
                  }
                } else if (ev.key === "Tab") {
                  if (element.classList.contains("active")) {
                    element.classList.remove("active");
                    ddToggle.setAttribute("aria-expanded", "false");
                  }
                } else if (ev.key === "ArrowDown" || ev.key === "ArrowUp") {
                  ev.preventDefault();
                  let wasOpen = element.classList.contains("active");
                  let idx = items.findIndex((i) =>
                    i.classList.contains("selected")
                  );
                  let next =
                    ev.key === "ArrowDown"
                      ? Math.min(idx + 1, items.length - 1)
                      : Math.max(idx - 1, 0);
                  if (next !== idx) items[next].click();
                  if (wasOpen) {
                    element.classList.add("active");
                    ddToggle.setAttribute("aria-expanded", "true");
                  }
                }
              });
            }

            element.addEventListener("click", function (e) {
              let elementToggle = element.querySelector(".select-selected");
              if (e.target.contains(elementToggle)) {
                this.classList.toggle("active");
                elementToggle.setAttribute(
                  "aria-expanded",
                  this.classList.contains("active")
                );
              }
            });

            element.querySelectorAll(".item").forEach((e) => {
              e.addEventListener("click", function () {
                // 2026-08-12 - was e.innerText, which on a CLOSED (display:none) list returns
                // the li's indentation-padded textContent and can never strict-equal the bare
                // data-value, silently desyncing the label from the real variant when the new
                // arrow keys fire while closed. data-value is exact in every state.
                let variantName = e.dataset.value;
                [...element.querySelectorAll(".item")].map((x) =>
                  x.classList.remove("selected")
                );
                element.querySelector(".variant-selected__main").innerText =
                  variantName;
                element
                  .closest(".variant-wrapper")
                  .querySelectorAll(".variant-input")
                  .forEach((elm) => {
                    if (elm.dataset.value === variantName) {
                      elm.querySelector("input").click();
                    }
                  });
                e.classList.add("selected");
                element.classList.remove("active");
                let pickedToggle = element.querySelector(".select-selected");
                if (pickedToggle) {
                  pickedToggle.setAttribute("aria-expanded", "false");
                }
              });
            });
          });

        document.addEventListener("click", function (event) {
          var dropdowns = document.querySelectorAll(
            ".select-variant__dropdown"
          );
          dropdowns.forEach(function (dropdown) {
            if (
              !dropdown.contains(event.target) &&
              !event.target.closest(".select-variant__dropdown")
            ) {
              dropdown.classList.remove("active");
              var awayToggle = dropdown.querySelector(".select-selected");
              if (awayToggle) {
                awayToggle.setAttribute("aria-expanded", "false");
              }
            }
          });
        });
      },

      reviewScroll: function () {
        let reviewStar = document.querySelector(".review-stars");
        if (!reviewStar) return;
        reviewStar.addEventListener("click", function (events) {
          events.preventDefault();
          document.querySelector(".shopify-app-block").scrollIntoView();
        });
      },

      cacheElements: function () {
        this.cache = {
          form: this.container.querySelector(this.selectors.form),
          mainSlider: this.container.querySelector(this.selectors.mainSlider),
          thumbSlider: this.container.querySelector(this.selectors.thumbSlider),
          thumbScroller: this.container.querySelector(
            this.selectors.thumbScroller
          ),
          productImageMain: this.container.querySelector(
            this.selectors.productImageMain
          ),

          // Price-related
          priceWrapper: this.container.querySelector(
            this.selectors.priceWrapper
          ),
          comparePriceA11y: this.container.querySelector(
            this.selectors.comparePriceA11y
          ),
          comparePrice: this.container.querySelector(
            this.selectors.comparePrice
          ),
          price: this.container.querySelector(this.selectors.price),
          savePrice: this.container.querySelector(this.selectors.savePrice),
          priceA11y: this.container.querySelector(this.selectors.priceA11y),
          atcPrice: this.container.querySelector('.custom-atc-price'),
          atcComparePrice: this.container.querySelector('.custom-atc-compare-price'),
          atcSavePrice: this.container.querySelector('.custom-atc-save-price'),
        };
      },

      formSetup: function () {
        this.initQtySelector();
        this.initAjaxProductForm();
        this.initUpsellProductForm();
        this.availabilitySetup();
        this.initVariants();

        // We know the current variant now so setup image sets
        if (this.settings.imageSetName) {
          this.updateImageSet();
        }
      },

      availabilitySetup: function () {
        var container = this.container.querySelector(
          this.selectors.availabilityContainer
        );
        if (container) {
          this.storeAvailability = new theme.StoreAvailability(container);
        }
      },

      productSetup: function () {
        this.setImageSizes();
        this.initImageZoom();
        this.initResponsiveVideo();
        this.initModelViewerLibraries();
        this.initShopifyXrLaunch();

        if (window.SPR) {
          SPR.initDomEls();
          SPR.loadBadges();
        }
      },

      setImageSizes: function () {
        if (!this.settings.hasImages) {
          return;
        }

        // Get srcset image src, works on most modern browsers
        // otherwise defaults to settings.imageSize
        var currentImage = this.firstProductImage.currentSrc;

        if (currentImage) {
          this.settings.imageSize = theme.Images.imageSize(currentImage);
        }
      },

      addIdToRecentlyViewed: function () {
        var id = this.container.getAttribute("data-product-id");

        if (!id) {
          return;
        }

        // Remove current product if already in recently viewed array
        var i = theme.recentlyViewedIds.indexOf(id);
        if (i > -1) {
          theme.recentlyViewedIds.splice(i, 1);
        }

        // Add id to array
        theme.recentlyViewedIds.unshift(id);

        if (theme.config.hasLocalStorage) {
          window.localStorage.setItem(
            "recently-viewed",
            JSON.stringify(theme.recentlyViewedIds)
          );
        }
      },

      initVariants: function () {
        var variantJson = this.container.querySelector(
          this.selectors.variantsJson
        );

        if (!variantJson) {
          return;
        }

        this.variantsObject = JSON.parse(variantJson.innerHTML);

        var options = {
          container: this.container,
          enableHistoryState: this.settings.enableHistoryState,
          singleOptionSelector: this.selectors.singleOptionSelector,
          originalSelectorId: this.selectors.originalSelectorId,
          variants: this.variantsObject,
        };

        var swatches = this.container.querySelectorAll(
          this.selectors.variantColorSwatch
        );
        if (swatches.length) {
          swatches.forEach((swatch) => {
            swatch.addEventListener(
              "change",
              function (evt) {
                var color = swatch.dataset.colorName;
                var index = swatch.dataset.colorIndex;
                this.updateColorName(color, index);
              }.bind(this)
            );
          });
        }

        this.variants = new theme.Variants(options);

        // Product availability on page load
        if (this.storeAvailability) {
          var variant_id = this.variants.currentVariant
            ? this.variants.currentVariant.id
            : this.variants.variants[0].id;

          this.storeAvailability.updateContent(variant_id);
          this.container.on(
            "variantChange" + this.settings.namespace,
            this.updateAvailability.bind(this)
          );
        }

        this.container.on(
          "variantChange" + this.settings.namespace,
          this.updateCartButton.bind(this)
        );
        this.container.on(
          "variantImageChange" + this.settings.namespace,
          this.updateVariantImage.bind(this)
        );
        this.container.on(
          "variantPriceChange" + this.settings.namespace,
          this.updatePrice.bind(this)
        );
        this.container.on(
          "variantUnitPriceChange" + this.settings.namespace,
          this.updateUnitPrice.bind(this)
        );

        if (this.container.querySelectorAll(this.selectors.sku).length) {
          this.container.on(
            "variantSKUChange" + this.settings.namespace,
            this.updateSku.bind(this)
          );
        }

        var inventoryEl = this.container.querySelector(
          this.selectors.inventory
        );
        if (inventoryEl) {
          this.settings.inventory = true;
          this.settings.inventoryThreshold = inventoryEl.dataset.threshold;
          this.container.on(
            "variantChange" + this.settings.namespace,
            this.updateInventory.bind(this)
          );
        }

        // Update individual variant availability on each selection
        if (theme.settings.dynamicVariantsEnable) {
          var currentVariantJson = this.container.querySelector(
            this.selectors.currentVariantJson
          );

          if (currentVariantJson) {
            var variantType = this.container.querySelector(
              selectors.variantType
            );

            if (variantType) {
              new theme.VariantAvailability({
                container: this.container,
                namespace: this.settings.namespace,
                type: variantType.dataset.type,
                variantsObject: this.variantsObject,
                currentVariantObject: JSON.parse(currentVariantJson.innerHTML),
              });
            }
          }
        }

        // image set names variant change listeners
        if (this.settings.imageSetName) {
          var variantWrapper = this.container.querySelector(
            '.variant-input-wrap[data-handle="' +
            this.settings.imageSetName +
            '"]'
          );
          if (variantWrapper) {
            this.settings.imageSetIndex = variantWrapper.dataset.index;
            this.container.on(
              "variantChange" + this.settings.namespace,
              this.updateImageSet.bind(this)
            );
          } else {
            this.settings.imageSetName = null;
          }
        }
      },

      initProductProperties: function () {
        let element = this.container.querySelector("[data-product-properties]");
        if (!element) return;

        document
          .querySelectorAll(".select-properties__dropdown")
          .forEach((element) => {
            element.addEventListener("click", function () {
              this.classList.toggle("active");
            });

            element.querySelectorAll(".item").forEach((e) => {
              e.addEventListener("click", function () {
                let propertiesName = e.innerHTML;
                let productPropertiesValue = e.dataset.value;

                element.querySelector("input").value = productPropertiesValue;

                element.querySelector("[data-line-name]").innerHTML =
                  propertiesName;
                [...element.querySelectorAll(".item")].map((x) =>
                  x.classList.remove("selected")
                );
                e.classList.add("selected");
              });

              e.addEventListener("click", function () {
                if (element.querySelector("input").value != 0) {
                  element.querySelector(".select-selected").style.borderColor =
                    "#242424";
                }
              });
            });
          });

        document
          .querySelector("[data-add-to-cart]")
          .addEventListener("click", function (event) {
            document
              .querySelectorAll(".select-properties__dropdown")
              .forEach((element) => {
                element.querySelectorAll(".item").forEach((e) => {
                  if (element.querySelector("input").value == 0) {
                    event.preventDefault();
                    element.querySelector(
                      ".select-selected"
                    ).style.borderColor = "#ff0000";
                  }
                });
              });
          });
      },

      initQtySelector: function () {
        this.container.querySelectorAll(".js-qty__wrapper").forEach((el) => {
          new theme.QtySelector(el, {
            namespace: ".product",
          });
        });
      },

      initAjaxProductForm: function () {
        new theme.AjaxProduct(this.cache.form, ".add-to-cart");
      },

      initUpsellProductForm: function () {
        document
          .querySelectorAll("[data-upsell-selector]")
          .forEach((element) => {
            let formElement = element.querySelector(".shopify-product-form");
            new theme.ProductUpsellForm(formElement, ".add-upsell-product");
          });
      },

      /*============================================================================
        Variant change methods
      ==============================================================================*/
      updateColorName: function (color, index) {
        // Updates on radio button change, not variant.js
        this.container.querySelector(
          this.selectors.colorLabel + `[data-index="${index}"`
        ).textContent = color;
      },

      updateCartButton: function (evt) {
        var variant = evt.detail.variant;
        var cartBtn = this.container.querySelector(this.selectors.addToCart);
        var cartBtnText = this.container.querySelector(
          this.selectors.addToCartText
        );

        if (variant) {
          if (variant.available) {
            // Available, enable the submit button and change text
            cartBtn.classList.remove(classes.disabled);
            cartBtn.disabled = false;
            var defaultText = cartBtnText.dataset.defaultText;
            cartBtnText.textContent = defaultText;
          } else {
            // Sold out, disable the submit button and change text
            cartBtn.classList.add(classes.disabled);
            cartBtn.disabled = true;
            cartBtnText.textContent = theme.strings.soldOut;
          }
        } else {
          // The variant doesn't exist, disable submit button
          cartBtn.classList.add(classes.disabled);
          cartBtn.disabled = true;
          cartBtnText.textContent = theme.strings.unavailable;
        }
      },

      // updatePrice: function (evt) {
      //   var variant = evt.detail.variant;

      //   if (variant) {
      //     // If no price element, form initiated later than rest of
      //     // product page. Update cached elements
      //     if (!this.cache.price) {
      //       this.cacheElements();
      //     }
      //     // console.log(
      //     //   "variant.price",
      //     //   theme.Currency.formatMoney(
      //     //     variant.price,
      //     //     theme.settings.moneyFormat
      //     //   ).replace(/(\.00|,00)$/, "") // Removes .00 or ,00 from formatted currency
      //     // );

      //     // Regular price
      //     this.cache.price.innerHTML = theme.Currency.formatMoney(
      //       variant.price,
      //       theme.settings.moneyFormat
      //     ).replace(/(\.00|,00)$/, "");

      //     // Sale price, if necessary
      //     if (variant.compare_at_price > variant.price) {
      //       this.cache.comparePrice.innerHTML = theme.Currency.formatMoney(
      //         variant.compare_at_price,
      //         theme.settings.moneyFormat
      //       );
      //       this.cache.priceWrapper.classList.remove(classes.hidden);
      //       this.cache.price.classList.add(classes.onSale);
      //       if (this.cache.comparePriceA11y) {
      //         this.cache.comparePriceA11y.setAttribute("aria-hidden", "false");
      //       }
      //       if (this.cache.priceA11y) {
      //         this.cache.priceA11y.setAttribute("aria-hidden", "false");
      //       }

      //       var savings = variant.compare_at_price - variant.price;
      //       // if (theme.settings.saveType == "percent") {
      //       //   savings =
      //       //     Math.round((savings * 100) / variant.compare_at_price) + "%";
      //       // } else {
      //       //   savings = theme.Currency.formatMoney(
      //       //     savings,
      //       //     theme.settings.moneyFormat
      //       //   );
      //       // }
      //      savings = Math.round((savings * 100) / variant.compare_at_price) + "%";

      //       this.cache.savePrice.classList.remove(classes.hidden);
      //       this.cache.savePrice.innerHTML = theme.strings.savePrice.replace(
      //         "[saved_amount]",
      //         savings
      //       );
            
      //     } else {
      //       if (this.cache.priceWrapper) {
      //         this.cache.priceWrapper.classList.add(classes.hidden);
      //       }
      //       this.cache.savePrice.classList.add(classes.hidden);
      //       this.cache.price.classList.remove(classes.onSale);
      //       if (this.cache.comparePriceA11y) {
      //         this.cache.comparePriceA11y.setAttribute("aria-hidden", "true");
      //       }
      //       if (this.cache.priceA11y) {
      //         this.cache.priceA11y.setAttribute("aria-hidden", "true");
      //       }
      //     }
      //   }
      // },
      updatePrice: function (evt) {
        var variant = evt.detail.variant;

        if (variant) {
          // Re-cache if needed
          if (!this.cache.price) {
            this.cacheElements();
          }

          // =========================
          // MAIN PRICE (EXISTING)
          // =========================
          // 2026-10-10 audit: keep ".00" so a pick prints the $100.00 the server render and the sticky bar show (it stripped the zeros, so a whole-dollar pick read $100). Restore .replace(/(\.00|,00)$/, "") to roll back.
          this.cache.price.innerHTML = theme.Currency.formatMoney(
            variant.price,
            theme.settings.moneyFormat
          );

          // =========================
          // 🔥 ADD THIS (ATC PRICE)
          // =========================
          if (this.cache.atcPrice) {
            // 2026-10-10 audit: same as the main price above, keep ".00". Restore .replace(/(\.00|,00)$/, "") to roll back.
            this.cache.atcPrice.innerHTML = theme.Currency.formatMoney(
              variant.price,
              theme.settings.moneyFormat
            );
          }

          // =========================
          // SALE LOGIC
          // =========================
          if (variant.compare_at_price > variant.price) {

            // Main compare price
            this.cache.comparePrice.innerHTML = theme.Currency.formatMoney(
              variant.compare_at_price,
              theme.settings.moneyFormat
            );

            this.cache.priceWrapper.classList.remove(classes.hidden);
            this.cache.price.classList.add(classes.onSale);

            if (this.cache.comparePriceA11y) {
              this.cache.comparePriceA11y.setAttribute("aria-hidden", "false");
            }
            if (this.cache.priceA11y) {
              this.cache.priceA11y.setAttribute("aria-hidden", "false");
            }

            // Savings %
            var savings = variant.compare_at_price - variant.price;
            /* 2026-09-21 Joel: savings are always a DOLLAR amount sitewide, never a percentage. */
            savings = theme.Currency.formatMoney(savings, theme.settings.moneyFormat);
            if (savings.slice(-3) === ".00") { savings = savings.slice(0, -3); }

            this.cache.savePrice.classList.remove(classes.hidden);
            this.cache.savePrice.innerHTML = theme.strings.savePrice.replace(
              "[saved_amount]",
              savings
            );

            // =========================
            // 🔥 ADD THIS (ATC SALE)
            // =========================
            if (this.cache.atcComparePrice) {
              this.cache.atcComparePrice.innerHTML = theme.Currency.formatMoney(
                variant.compare_at_price,
                theme.settings.moneyFormat
              );
            }

            if (this.cache.atcSavePrice) {
              this.cache.atcSavePrice.innerHTML = "Save " + savings;
            }

          } else {

            // Main reset
            if (this.cache.priceWrapper) {
              this.cache.priceWrapper.classList.add(classes.hidden);
            }

            this.cache.savePrice.classList.add(classes.hidden);
            this.cache.price.classList.remove(classes.onSale);

            if (this.cache.comparePriceA11y) {
              this.cache.comparePriceA11y.setAttribute("aria-hidden", "true");
            }
            if (this.cache.priceA11y) {
              this.cache.priceA11y.setAttribute("aria-hidden", "true");
            }

            // =========================
            // 🔥 ADD THIS (ATC RESET)
            // =========================
            if (this.cache.atcComparePrice) {
              this.cache.atcComparePrice.innerHTML = "";
            }

            if (this.cache.atcSavePrice) {
              this.cache.atcSavePrice.innerHTML = "";
            }
          }
        }
      },

      updateUnitPrice: function (evt) {
        var variant = evt.detail.variant;

        if (variant && variant.unit_price) {
          this.container.querySelector(this.selectors.unitPrice).innerHTML =
            theme.Currency.formatMoney(
              variant.unit_price,
              theme.settings.moneyFormat
            );
          this.container.querySelector(
            this.selectors.unitPriceBaseUnit
          ).innerHTML = theme.Currency.getBaseUnit(variant);
          this.container
            .querySelector(this.selectors.unitWrapper)
            .classList.remove(classes.hidden);
        } else {
          this.container
            .querySelector(this.selectors.unitWrapper)
            .classList.add(classes.hidden);
        }
      },

      imageSetArguments: function (variant) {
        var variant = variant
          ? variant
          : this.variants
            ? this.variants.currentVariant
            : null;
        if (!variant) return;

        var setValue = (this.settings.currentImageSet = this.getImageSetName(
          variant[this.settings.imageSetIndex]
        ));
        var set = this.settings.imageSetName + "_" + setValue;

        // Always start on index 0
        this.settings.currentSlideIndex = 0;

        // Return object that adds cellSelector to mainSliderArgs
        return {
          cellSelector: '[data-group="' + set + '"]',
          imageSet: set,
          initialIndex: this.settings.currentSlideIndex,
        };
      },

      updateImageSet: function (evt) {
        // If called directly, use current variant
        var variant = evt
          ? evt.detail.variant
          : this.variants
            ? this.variants.currentVariant
            : null;
        if (!variant) {
          return;
        }

        var setValue = this.getImageSetName(
          variant[this.settings.imageSetIndex]
        );

        // Already on the current image group
        if (this.settings.currentImageSet === setValue) {
          return;
        }

        this.initProductSlider(variant);
      },

      // Show/hide thumbnails based on current image set
      updateImageSetThumbs: function (set) {
        this.cache.thumbSlider
          .querySelectorAll(".product__thumb-item")
          .forEach((thumb) => {
            thumb.classList.toggle(classes.hidden, thumb.dataset.group !== set);
          });
      },

      getImageSetName: function (string) {
        return string
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, "-")
          .replace(/-$/, "")
          .replace(/^-/, "");
      },

      updateSku: function (evt) {
        var variant = evt.detail.variant;
        var newSku = "";
        var hideSku = true;

        if (variant) {
          if (variant.sku) {
            newSku = variant.sku;
            hideSku = false;
          }

          if (this.container.querySelectorAll(this.selectors.sku).length > 0)
            this.container
              .querySelectorAll(this.selectors.sku)
              .forEach((el) => {
                el.classList.toggle(classes.hidden, hideSku);
                el.querySelector("[data-sku-id]").textContent = newSku;
              });
        }
      },

      updateInventory: function (evt) {
        var variant = evt.detail.variant;

        // Hide stock if no inventory management or policy is continue
        if (
          !variant ||
          !variant.inventory_management ||
          variant.inventory_policy === "continue"
        ) {
          this.toggleInventoryQuantity(variant, false);
          this.toggleIncomingInventory(false);
          return;
        }

        if (
          variant.inventory_management === "shopify" &&
          window.inventories &&
          window.inventories[this.productId]
        ) {
          var variantInventoryObject =
            window.inventories[this.productId][variant.id];

          // Hide stock if policy is continue
          if (variantInventoryObject.policy === "continue") {
            this.toggleInventoryQuantity(variant, false);
            this.toggleIncomingInventory(false);
            return;
          }

          var quantity = variantInventoryObject.quantity;
          var showInventory = true;
          var showIncomingInventory = false;

          if (quantity <= 0 || quantity > this.settings.inventoryThreshold) {
            showInventory = false;
          }

          this.toggleInventoryQuantity(variant, showInventory, quantity);

          // Only show incoming inventory when:
          // - inventory notice itself is hidden
          // - have incoming inventory
          // - current quantity is below theme setting threshold
          if (
            !showInventory &&
            variantInventoryObject.incoming === "true" &&
            quantity <= this.settings.inventoryThreshold
          ) {
            showIncomingInventory = true;
          }

          this.toggleIncomingInventory(
            showIncomingInventory,
            variant.available,
            variantInventoryObject.next_incoming_date
          );
        }
      },

      updateAvailability: function (evt) {
        var variant = evt.detail.variant;
        if (!variant) {
          return;
        }

        this.storeAvailability.updateContent(variant.id);
      },

      toggleInventoryQuantity: function (variant, show, qty) {
        if (!this.settings.inventory) {
          show = false;
        }

        var el = this.container.querySelector(this.selectors.inventory);
        var salesPoint = el.closest(".product-block");

        if (parseInt(qty) <= parseInt(this.settings.inventoryThreshold)) {
          el.parentNode.classList.add("inventory--low");
          el.textContent = theme.strings.stockLabel.replace("[count]", qty);
        } else {
          el.parentNode.classList.remove("inventory--low");
          el.textContent = theme.strings.inStockLabel;
        }

        if (variant && variant.available) {
          el.parentNode.classList.remove(classes.hidden);
          if (salesPoint) {
            salesPoint.classList.remove(classes.hidden);
          }
        } else {
          el.parentNode.classList.add(classes.hidden);
          if (salesPoint) {
            salesPoint.classList.add(classes.hidden);
          }
        }
      },

      toggleIncomingInventory: function (show, available, date) {
        var el = this.container.querySelector(this.selectors.incomingInventory);
        var salesPoint = el.closest(".product-block");

        if (!el) {
          return;
        }

        var textEl = el.querySelector(".js-incoming-text");

        if (show) {
          var string = available
            ? theme.strings.willNotShipUntil.replace("[date]", date)
            : theme.strings.willBeInStockAfter.replace("[date]", date);

          if (!date) {
            string = theme.strings.waitingForStock;
          }

          el.classList.remove(classes.hidden);
          if (salesPoint) {
            salesPoint.classList.remove(classes.hidden);
          }
          textEl.textContent = string;
        } else {
          el.classList.add(classes.hidden);
        }
      },

      /*============================================================================
        Product videos
      ==============================================================================*/
      videoSetup: function () {
        var productVideos = this.cache.mainSlider.querySelectorAll(
          selectors.productVideo
        );

        if (!productVideos.length) {
          return false;
        }

        productVideos.forEach((vid) => {
          var type = vid.dataset.videoType;
          if (type === "youtube") {
            this.initYoutubeVideo(vid);
          } else if (type === "mp4") {
            this.initMp4Video(vid);
          }
        });
      },

      initYoutubeVideo: function (div) {
        videoObjects[div.id] = new theme.YouTube(div.id, {
          videoId: div.dataset.youtubeId,
          videoParent: selectors.videoParent,
          autoplay: false, // will handle this in callback
          style: div.dataset.videoStyle,
          loop: div.dataset.videoLoop,
          events: {
            onReady: this.youtubePlayerReady.bind(this),
            onStateChange: this.youtubePlayerStateChange.bind(this),
          },
        });
      },

      // Comes from YouTube SDK
      // Get iframe ID with evt.target.getIframe().id
      // Then access product video players with videoObjects[id]
      youtubePlayerReady: function (evt) {
        var iframeId = evt.target.getIframe().id;

        if (!videoObjects[iframeId]) {
          // No youtube player data
          return;
        }

        var obj = videoObjects[iframeId];
        var player = obj.videoPlayer;

        if (obj.options.style !== "sound") {
          player.mute();
        }

        obj.parent.classList.remove("loading");
        obj.parent.classList.add("loaded");

        // If we have an element, it is in the visible/first slide,
        // and is muted, play it
        if (this._isFirstSlide(iframeId) && obj.options.style !== "sound") {
          player.playVideo();
        }
      },

      _isFirstSlide: function (id) {
        return this.cache.mainSlider.querySelector(
          selectors.startingSlide + " " + "#" + id
        );
      },

      youtubePlayerStateChange: function (evt) {
        var iframeId = evt.target.getIframe().id;
        var obj = videoObjects[iframeId];

        switch (evt.data) {
          case -1: // unstarted
            // Handle low power state on iOS by checking if
            // video is reset to unplayed after attempting to buffer
            if (obj.attemptedToPlay) {
              obj.parent.classList.add("video-interactable");
            }
            break;
          case 0: // ended
            if (obj && obj.options.loop === "true") {
              obj.videoPlayer.playVideo();
            }
            break;
          case 3: // buffering
            obj.attemptedToPlay = true;
            break;
        }
      },

      initMp4Video: function (div) {
        videoObjects[div.id] = {
          id: div.id,
          type: "mp4",
        };

        if (this._isFirstSlide(div.id)) {
          this.playMp4Video(div.id);
        }
      },

      stopVideos: function () {
        for (var [id, vid] of Object.entries(videoObjects)) {
          if (vid.videoPlayer) {
            if (typeof vid.videoPlayer.stopVideo === "function") {
              vid.videoPlayer.stopVideo(); // YouTube player
            }
          } else if (vid.type === "mp4") {
            this.stopMp4Video(vid.id); // MP4 player
          }
        }
      },

      _getVideoType: function (video) {
        return video.getAttribute("data-video-type");
      },

      _getVideoDivId: function (video) {
        return video.id;
      },

      playMp4Video: function (id) {
        var player = this.container.querySelector("#" + id);
        var playPromise = player.play();

        player.focus();

        // When existing focus on the element, go back to thumbnail
        player.addEventListener(
          "focusout",
          this.returnFocusToThumbnail.bind(this)
        );

        if (playPromise !== undefined) {
          playPromise
            .then(function () {
              // Playing as expected
            })
            .catch(function (error) {
              // Likely low power mode on iOS, show controls
              player
                .closest(selectors.videoParent)
                .setAttribute("data-video-style", "unmuted");
            });
        }
      },

      stopMp4Video: function (id) {
        var player = this.container.querySelector("#" + id);
        player.removeEventListener(
          "focusout",
          this.returnFocusToThumbnail.bind(this)
        );
        if (player && typeof player.pause === "function") {
          player.removeAttribute("controls");
          player.pause();
        }
      },

      // Return focus to
      returnFocusToThumbnail: function () {
        var thumb = this.container.querySelector(
          '.product__thumb-item[data-index="' +
          this.settings.currentSlideIndex +
          '"] a'
        );
        if (thumb) {
          thumb.focus();
        }
      },

      /*============================================================================
        Product images
      ==============================================================================*/
      initImageZoom: function () {
        var container = this.container.querySelector(
          this.selectors.imageContainer
        );
        if (!container) {
          return;
        }
        var imageZoom = new theme.Photoswipe(container, this.sectionId);
        container.addEventListener(
          "photoswipe:afterChange",
          function (evt) {
            if (this.flickity) {
              this.flickity.goToSlide(evt.detail.index);
            }
          }.bind(this)
        );
      },

      initResponsiveVideo: function () {
        var selector = document.querySelector("[data-product-description]");
        if (!selector) return false;
        selector
          .querySelectorAll('iframe[src*="youtube.com/embed"]')
          .forEach((element) => {
            let videoWrapper = document.createElement("div");
            videoWrapper.setAttribute("class", "video-wrapper");

            element.parentNode.insertBefore(videoWrapper, element);
            videoWrapper.appendChild(element);
          });
      },

      getThumbIndex: function (target) {
        return target.dataset.index;
      },

      updateVariantImage: function (evt) {
        var variant = evt.detail.variant;
        var sizedImgUrl = theme.Images.getSizedImageUrl(
          variant.featured_media.preview_image.src,
          this.settings.imageSize
        );

        var newImage = this.container.querySelector(
          '.product__thumb[data-id="' + variant.featured_media.id + '"]'
        );
        var imageIndex = this.getThumbIndex(newImage);

        // If there is no index, slider is not initalized
        if (typeof imageIndex === "undefined") {
          return;
        }

        // Go to that variant image's slide
        if (this.flickity) {
          this.flickity.goToSlide(imageIndex);
        }
      },

      initProductSlider: function (variant) {
        // Stop if only a single image, but add active class to first slide
        if (
          this.cache.mainSlider.querySelectorAll(selectors.slide).length <= 1
        ) {
          var slide = this.cache.mainSlider.querySelector(selectors.slide);
          if (slide) {
            slide.classList.add("is-selected");
          }
          return;
        }

        // Destroy slider in preparation of new initialization
        if (this.flickity && typeof this.flickity.destroy === "function") {
          this.flickity.destroy();
        }

        // If variant argument exists, slideshow is reinitializing because of the
        // image set feature enabled and switching to a new group.
        // currentSlideIndex
        if (!variant) {
          var activeSlide = this.cache.mainSlider.querySelector(
            selectors.startingSlide
          );
          this.settings.currentSlideIndex = this._slideIndex(activeSlide);
        }

        var mainSliderArgs = {
          adaptiveHeight: true,
          avoidReflow: true,
          initialIndex: this.settings.currentSlideIndex,
          childNav: this.cache.thumbSlider,
          childNavScroller: this.cache.thumbScroller,
          childVertical: this.cache.thumbSlider.dataset.position === "beside",
          pageDots: true, // mobile only with CSS
          wrapAround: true,
          setGallerySize: false,
          callbacks: {
            onInit: this.onSliderInit.bind(this),
            onChange: this.onSlideChange.bind(this),
          },
        };

        // Override default settings if image set feature enabled
        if (this.settings.imageSetName) {
          var imageSetArgs = this.imageSetArguments(variant);
          mainSliderArgs = Object.assign({}, mainSliderArgs, imageSetArgs);
          this.updateImageSetThumbs(mainSliderArgs.imageSet);
        }

        this.flickity = new theme.Slideshow(
          this.cache.mainSlider,
          mainSliderArgs
        );
      },

      onSliderInit: function (slide) {
        // If slider is initialized with image set feature active,
        // initialize any videos/media when they are first slide
        if (this.settings.imageSetName) {
          this.prepMediaOnSlide(slide);
        }
       updateDotPagination(this.cache.mainSlider);
      },

      onSlideChange: function (index) {
        updateDotPagination(this.cache.mainSlider);
        if (!this.flickity) return;

        var prevSlide = this.cache.mainSlider.querySelector(
          '.product-main-slide[data-index="' +
          this.settings.currentSlideIndex +
          '"]'
        );

        // If imageSetName exists, use a more specific selector
        var nextSlide = this.settings.imageSetName
          ? this.cache.mainSlider.querySelectorAll(
            ".flickity-slider .product-main-slide"
          )[index]
          : this.cache.mainSlider.querySelector(
            '.product-main-slide[data-index="' + index + '"]'
          );

        prevSlide.setAttribute("tabindex", "-1");
        nextSlide.setAttribute("tabindex", 0);

        // Pause any existing slide video/media
        this.stopMediaOnSlide(prevSlide);

        // Prep next slide video/media
        this.prepMediaOnSlide(nextSlide);

        // Update current slider index
        this.settings.currentSlideIndex = index;      
      },

      stopMediaOnSlide(slide) {
        // Stop existing video
        var video = slide.querySelector(selectors.productVideo);
        if (video) {
          var videoType = this._getVideoType(video);
          var videoId = this._getVideoDivId(video);
          if (videoType === "youtube") {
            if (videoObjects[videoId].videoPlayer) {
              videoObjects[videoId].videoPlayer.stopVideo();
              return;
            }
          } else if (videoType === "mp4") {
            this.stopMp4Video(videoId);
            return;
          }
        }

        // Stop existing media
        var currentMedia = slide.querySelector(this.selectors.media);
        if (currentMedia) {
          currentMedia.dispatchEvent(
            new CustomEvent("mediaHidden", {
              bubbles: true,
              cancelable: true,
            })
          );
        }
      },

      prepMediaOnSlide(slide) {
        var video = slide.querySelector(selectors.productVideo);
        if (video) {
          var videoType = this._getVideoType(video);
          var videoId = this._getVideoDivId(video);
          if (videoType === "youtube") {
            if (
              videoObjects[videoId].videoPlayer &&
              videoObjects[videoId].options.style !== "sound"
            ) {
              videoObjects[videoId].videoPlayer.playVideo();
              return;
            }
          } else if (videoType === "mp4") {
            this.playMp4Video(videoId);
          }
        }

        var nextMedia = slide.querySelector(this.selectors.media);
        if (nextMedia) {
          nextMedia.dispatchEvent(
            new CustomEvent("mediaVisible", {
              bubbles: true,
              cancelable: true,
            })
          );
          slide
            .querySelector(".shopify-model-viewer-ui__button")
            .setAttribute("tabindex", 0);
          slide
            .querySelector(".product-single__close-media")
            .setAttribute("tabindex", 0);
        }
      },

      _slideIndex: function (el) {
        return el.getAttribute("data-index");
      },

      /*============================================================================
        Products when in quick view modal
      ==============================================================================*/
      openModalProduct: function () {
        var initialized = false;

        if (!this.settings.modalInit) {
          this.blocksHolder = this.container.querySelector(
            selectors.blocksHolder
          );
          var url = this.blocksHolder.dataset.url;

          fetch(url)
            .then(function (response) {
              return response.text();
            })
            .then(
              function (html) {
                var parser = new DOMParser();
                var doc = parser.parseFromString(html, "text/html");
                var blocks = doc.querySelector(selectors.blocks);

                // Because the same product could be opened in quick view
                // on the page we load the form elements from, we need to
                // update any `id`, `for`, and `form` attributes
                blocks.querySelectorAll("[id]").forEach((el) => {
                  // Update input `id`
                  var val = el.getAttribute("id");
                  el.setAttribute("id", val + "-modal");

                  // Update related label if it exists
                  var label = blocks.querySelector(`[for="${val}"]`);
                  if (label) {
                    label.setAttribute("for", val + "-modal");
                  }

                  // Update any collapsible elements
                  var collapsibleTrigger = blocks.querySelector(
                    `[aria-controls="${val}"]`
                  );
                  if (collapsibleTrigger) {
                    collapsibleTrigger.setAttribute(
                      "aria-controls",
                      val + "-modal"
                    );
                  }
                });

                // Update any elements with `form` attribute.
                // Form element already has `-modal` appended
                var form = blocks.querySelector(this.selectors.form);
                var formId = form.getAttribute("id");
                blocks.querySelectorAll("[form]").forEach((el) => {
                  el.setAttribute("form", formId);
                });

                this.blocksHolder.innerHTML = "";
                this.blocksHolder.append(blocks);
                this.blocksHolder.classList.add("product-form-holder--loaded");

                this.cacheElements();

                this.formSetup();
                this.updateModalProductInventory();

                if (Shopify && Shopify.PaymentButton) {
                  Shopify.PaymentButton.init();
                }

                // Re-hook up collapsible box triggers
                theme.collapsibles.init(this.container);

                document.dispatchEvent(
                  new CustomEvent("quickview:loaded", {
                    detail: {
                      productId: this.sectionId,
                    },
                  })
                );
              }.bind(this)
            );

          this.productSetup();
          this.videoSetup();

          // Enable product slider in quick view
          // 1. with image sets enabled, make sure we have this.variants before initializing
          // 2. initialize normally, form data not required
          if (this.settings.imageSetName) {
            if (this.variants) {
              this.initProductSlider();
            } else {
              document.addEventListener(
                "quickview:loaded",
                function (evt) {
                  if (evt.detail.productId === this.sectionId) {
                    this.initProductSlider();
                  }
                }.bind(this)
              );
            }
          } else {
            this.initProductSlider();
          }
          this.customMediaListners();
          this.addIdToRecentlyViewed();
          this.settings.modalInit = true;
        } else {
          initialized = true;
        }

        document.dispatchEvent(
          new CustomEvent("quickview:open", {
            detail: {
              initialized: initialized,
              productId: this.sectionId,
            },
          })
        );
      },

      // Recommended products load via JS and don't add variant inventory to the
      // global variable that we later check. This function scrapes a data div
      // to get that info and manually add the values.
      updateModalProductInventory: function () {
        window.inventories = window.inventories || {};
        this.container
          .querySelectorAll(".js-product-inventory-data")
          .forEach((el) => {
            var productId = el.dataset.productId;
            window.inventories[productId] = {};

            el.querySelectorAll(".js-variant-inventory-data").forEach((el) => {
              window.inventories[productId][el.dataset.id] = {
                quantity: el.dataset.quantity,
                policy: el.dataset.policy,
                incoming: el.dataset.incoming,
                next_incoming_date: el.dataset.date,
              };
            });
          });
      },

      closeModalProduct: function () {
        this.stopVideos();
      },

      initQuickAddForm: function () {
        this.updateModalProductInventory();

        if (Shopify && Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }
      },

      /*============================================================================
        Product media (3D)
      ==============================================================================*/
      initModelViewerLibraries: function () {
        var modelViewerElements = this.container.querySelectorAll(
          this.selectors.media
        );
        if (modelViewerElements.length < 1) return;

        theme.ProductMedia.init(modelViewerElements, this.sectionId);
      },

      initShopifyXrLaunch: function () {
        document.addEventListener(
          "shopify_xr_launch",
          function () {
            var currentMedia = this.container.querySelector(
              this.selectors.productMediaWrapper +
              ":not(." +
              self.classes.hidden +
              ")"
            );
            currentMedia.dispatchEvent(
              new CustomEvent("xrLaunch", {
                bubbles: true,
                cancelable: true,
              })
            );
          }.bind(this)
        );
      },

      customMediaListners: function () {
        document.querySelectorAll(this.selectors.closeMedia).forEach((el) => {
          el.addEventListener(
            "click",
            function () {
              var slide = this.cache.mainSlider.querySelector(
                selectors.currentSlide
              );
              var media = slide.querySelector(this.selectors.media);
              if (media) {
                media.dispatchEvent(
                  new CustomEvent("mediaHidden", {
                    bubbles: true,
                    cancelable: true,
                  })
                );
              }
            }.bind(this)
          );
        });

        var modelViewers = this.container.querySelectorAll("model-viewer");
        if (modelViewers.length) {
          modelViewers.forEach((el) => {
            el.addEventListener(
              "shopify_model_viewer_ui_toggle_play",
              function (evt) {
                this.mediaLoaded(evt);
              }.bind(this)
            );

            el.addEventListener(
              "shopify_model_viewer_ui_toggle_pause",
              function (evt) {
                this.mediaUnloaded(evt);
              }.bind(this)
            );
          });
        }
      },

      mediaLoaded: function (evt) {
        this.container
          .querySelectorAll(this.selectors.closeMedia)
          .forEach((el) => {
            el.classList.remove(classes.hidden);
          });

        if (this.flickity) {
          this.flickity.setDraggable(false);
        }
      },

      mediaUnloaded: function (evt) {
        this.container
          .querySelectorAll(this.selectors.closeMedia)
          .forEach((el) => {
            el.classList.add(classes.hidden);
          });

        if (this.flickity) {
          this.flickity.setDraggable(true);
        }
      },

      onUnload: function () {
        theme.ProductMedia.removeSectionModels(this.sectionId);

        if (this.flickity && typeof this.flickity.destroy === "function") {
          this.flickity.destroy();
        }
      },
    });

    return Product;
  })();

  theme.Photoswipe = (function () {
    var selectors = {
      trigger: ".js-photoswipe__zoom",
      images: ".photoswipe__image",
      slideshowTrack: ".flickity-viewport ",
      activeImage: ".is-selected",
    };

    function Photoswipe(container, sectionId) {
      this.container = container;
      this.sectionId = sectionId;
      this.namespace = ".photoswipe-" + this.sectionId;
      this.gallery;
      this.images;
      this.items;
      this.inSlideshow = false;

      if (!container || container.dataset.zoom === "false") {
        return;
      }

      if (container.dataset.slider === "true") {
        this.inSlideshow = true;
      }

      this.init();
    }

    Photoswipe.prototype = Object.assign({}, Photoswipe.prototype, {
      init: function () {
        this.container
          .querySelectorAll(selectors.trigger)
          .forEach((trigger) => {
            trigger.on("click" + this.namespace, this.triggerClick.bind(this));
          });
      },

      triggerClick: function (evt) {
        this.items = this.getImageData();

        var image = this.inSlideshow
          ? this.container.querySelector(selectors.activeImage)
          : evt.currentTarget;

        var index = this.inSlideshow
          ? this.getChildIndex(image)
          : image.dataset.index;

        this.initGallery(this.items, index);
      },

      // Because of image set feature, need to get index based on location in parent
      getChildIndex: function (el) {
        var i = 0;
        while ((el = el.previousSibling) != null) {
          i++;
        }

        // 1-based index required
        return i + 1;
      },

      getImageData: function () {
        this.images = this.inSlideshow
          ? this.container.querySelectorAll(
            selectors.slideshowTrack + selectors.images
          )
          : this.container.querySelectorAll(selectors.images);

        var items = [];
        var options = {};

        this.images.forEach((el) => {
          var item = {
            msrc: el.currentSrc || el.src,
            src: el.getAttribute("data-photoswipe-src"),
            w: el.getAttribute("data-photoswipe-width"),
            h: el.getAttribute("data-photoswipe-height"),
            el: el,
            initialZoomLevel: 0.5,
          };

          items.push(item);
        });

        return items;
      },

      initGallery: function (items, index) {
        var pswpElement = document.querySelectorAll(".pswp")[0];

        var options = {
          allowPanToNext: false,
          captionEl: false,
          closeOnScroll: false,
          counterEl: false,
          history: false,
          index: index - 1,
          pinchToClose: false,
          // Requires the .pswp__preloader block in snippets/photoswipe.liquid: the UI stores the
          // element it finds at init and then toggles a class on it unguarded.
          preloaderEl: true,
          scaleMode: "zoom",
          shareEl: false,
          tapToToggleControls: false,
          getThumbBoundsFn: function (index) {
            var pageYScroll =
              window.pageYOffset || document.documentElement.scrollTop;
            var thumbnail = items[index].el;
            var rect = thumbnail.getBoundingClientRect();
            return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
          },
        };

        this.gallery = new PhotoSwipe(
          pswpElement,
          PhotoSwipeUI_Default,
          items,
          options
        );
        this.gallery.listen("afterChange", this.afterChange.bind(this));
        this.gallery.init();

        this.preventiOS15Scrolling();
      },

      afterChange: function () {
        var index = this.gallery.getCurrentIndex();
        this.container.dispatchEvent(
          new CustomEvent("photoswipe:afterChange", {
            detail: {
              index: index,
            },
          })
        );
      },

      syncHeight: function () {
        document.documentElement.style.setProperty(
          "--window-inner-height",
          `${window.innerHeight}px`
        );
      },

      // Fix poached from https://gist.github.com/dimsemenov/0b8c255c0d87f2989e8ab876073534ea
      preventiOS15Scrolling: function () {
        let initialScrollPos;

        if (!/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) return;

        this.syncHeight();

        // Store scroll position to restore it later
        initialScrollPos = window.scrollY;

        // Add class to root element when PhotoSwipe opens
        document.documentElement.classList.add("pswp-open-in-ios");

        window.addEventListener("resize", this.syncHeight);

        this.gallery.listen("destroy", () => {
          document.documentElement.classList.remove("pswp-open-in-ios");
          window.scrollTo(0, initialScrollPos);
        });
      },
    });

    return Photoswipe;
  })();

  theme.Collection = (function () {
    function Collection(container) {
      this.container = container;
      this.containerId = container.getAttribute("data-section-id");

      this.init(container);
    }

    Collection.prototype = Object.assign({}, Collection.prototype, {
      init: function (container) {
        // If container not set, section has been reinitialized.
        // Update this.container to refreshed DOM element
        if (!container) {
          this.container = document.getElementById(this.containerId);
        }
        // console.log("Collection-this" , this )
        this.quickAdd = new theme.QuickAdd(this.container);
        this.quickShop = new theme.QuickShop(this.container);
      },
    });

    return Collection;
  })();

  theme.ImageSlider = (function () {
    function ImageSlider(container) {
      this.container = container;
      const sectionId = container.getAttribute("data-section-id");
      this.slideshow = container.querySelector(
        "#block-image__slider-" + sectionId
      );

      if (!this.slideshow) {
        return;
      }

      this.init(container);
    }

    ImageSlider.prototype = Object.assign({}, ImageSlider.prototype, {
      init: function (container) {
        var sliderArgs = {
          pageDots: true,
          cellAlign: "left",
          adaptiveHeight: false,
          prevNextButtons: true,
          autoPlay: true,
          arrowShape: {
            x0: 10,
            x1: 60,
            y1: 50,
            x2: 70,
            y2: 40,
            x3: 30,
          },
        };

        this.flickity = new theme.Slideshow(this.slideshow, sliderArgs);
      },
    });

    return ImageSlider;
  })();

  theme.ImageCarousel = (function () {
    function ImageCarousel(container) {
      this.container = container;
      const sectionId = container.getAttribute("data-section-id");
      this.slideshow = container.querySelector(
        "#block-image__carousel-" + sectionId
      );

      if (!this.slideshow) {
        return;
      }

      this.init(container);
    }

    ImageCarousel.prototype = Object.assign({}, ImageCarousel.prototype, {
      init: function (container) {
        var sliderArgs = {
          pageDots: true,
          cellAlign: "left",
          adaptiveHeight: false,
          prevNextButtons: true,
          autoPlay: true,
          arrowShape: {
            x0: 10,
            x1: 60,
            y1: 50,
            x2: 70,
            y2: 40,
            x3: 30,
          },
        };

        this.flickity = new theme.Slideshow(this.slideshow, sliderArgs);
      },
    });

    return ImageCarousel;
  })();

  theme.ReviewsSlider = (function () {
    function ReviewsSlider(container) {
      this.container = container;
      const sectionId = container.getAttribute("data-section-id");
      this.slideshow = container.querySelector(
        "#block-review__slider-" + sectionId
      );

      if (!this.slideshow) {
        return;
      }

      this.init(container);
    }

    ReviewsSlider.prototype = Object.assign({}, ReviewsSlider.prototype, {
      init: function (container) {
        var sliderArgs = {
          pageDots: false,
          cellAlign: "left",
          adaptiveHeight: true,
          prevNextButtons: false,
          autoPlay: true,
          arrowShape: {
            x0: 10,
            x1: 60,
            y1: 50,
            x2: 70,
            y2: 40,
            x3: 30,
          },
        };

        this.flickity = new theme.Slideshow(this.slideshow, sliderArgs);
      },
    });

    return ReviewsSlider;
  })();

  theme.ImagesColumn = (function () {
    function ImagesColumn(container) {
      this.container = container;
      const sectionId = container.getAttribute("data-section-id");
      this.slideshow = container.querySelector(
        "#block-image__column-" + sectionId
      );

      if (!this.slideshow) {
        return;
      }

      this.init(container);
    }

    ImagesColumn.prototype = Object.assign({}, ImagesColumn.prototype, {
      init: function (container) {
        var sliderArgs = {
          pageDots: true,
          cellAlign: "left",
          adaptiveHeight: true,
          prevNextButtons: true,
          arrowShape: {
            x0: 10,
            x1: 60,
            y1: 50,
            x2: 70,
            y2: 40,
            x3: 30,
          },
        };

        this.flickity = new theme.Slideshow(this.slideshow, sliderArgs);
      },
    });

    return ImagesColumn;
  })();

  theme.ImageSlideshow = (function () {
    function ImageSlideshow(container) {
      this.container = container;
      const sectionId = container.getAttribute("data-section-id");
      this.slideshow = container.querySelector(
        "#block-image__slideshow-" + sectionId
      );

      if (!this.slideshow) {
        return;
      }

      this.init(container);
    }

    ImageSlideshow.prototype = Object.assign({}, ImageSlideshow.prototype, {
      init: function (container) {
        var sliderArgs = {
          autoPlay: true,
          pageDots: false,
          cellAlign: "left",
          prevNextButtons: false,
        };

        this.flickity = new theme.Slideshow(this.slideshow, sliderArgs);
      },
    });

    return ImageSlideshow;
  })();

  theme.isStorageSupported = function (type) {
    // Return false if we are in an iframe without access to sessionStorage
    if (window.self !== window.top) {
      return false;
    }

    var testKey = "test";
    var storage;
    if (type === "session") {
      storage = window.sessionStorage;
    }
    if (type === "local") {
      storage = window.localStorage;
    }

    try {
      storage.setItem(testKey, "1");
      storage.removeItem(testKey);
      return true;
    } catch (error) {
      return false;
    }
  };

  theme.Toolkit = (function () {
    function Toolkit(container) {
      this.container = container;
      const sectionId = container.getAttribute("data-section-id");
      this.slideshow = container.querySelector(
        "#block-announcement__slider-" + sectionId
      );

      if (!this.slideshow) {
        return;
      }

      this.init(container);
    }

    Toolkit.prototype = Object.assign({}, Toolkit.prototype, {
      init: function (container) {
        var sliderArgs = {
          pageDots: false,
          cellAlign: "left",
          adaptiveHeight: true,
          prevNextButtons: true,
          autoPlay: true,
          pauseAutoPlayOnHover: true,
          arrowShape: {
            x0: 10,
            x1: 60,
            y1: 50,
            x2: 70,
            y2: 40,
            x3: 30,
          },
        };

        this.flickity = new theme.Slideshow(this.slideshow, sliderArgs);
      },
    });

    return Toolkit;
  })();

  theme.customerTemplates = function () {
    checkUrlHash();
    initEventListeners();
    resetPasswordSuccess();
    customerAddressForm();

    function checkUrlHash() {
      var hash = window.location.hash;

      // Allow deep linking to recover password form
      if (hash === "#recover") {
        toggleRecoverPasswordForm();
      }
    }

    function toggleRecoverPasswordForm() {
      var passwordForm = document
        .getElementById("RecoverPasswordForm")
        .classList.toggle("hide");
      var loginForm = document
        .getElementById("CustomerLoginForm")
        .classList.toggle("hide");
    }

    function initEventListeners() {
      // Show reset password form
      var recoverForm = document.getElementById("RecoverPassword");
      if (recoverForm) {
        recoverForm.addEventListener("click", function (evt) {
          evt.preventDefault();
          toggleRecoverPasswordForm();
        });
      }

      // Hide reset password form
      var hideRecoverPassword = document.getElementById(
        "HideRecoverPasswordLink"
      );
      if (hideRecoverPassword) {
        hideRecoverPassword.addEventListener("click", function (evt) {
          evt.preventDefault();
          toggleRecoverPasswordForm();
        });
      }
    }

    function resetPasswordSuccess() {
      var formState = document.querySelector(".reset-password-success");

      // check if reset password form was successfully submitted
      if (!formState) {
        return;
      }

      // show success message
      document.getElementById("ResetSuccess").classList.remove("hide");
    }

    function customerAddressForm() {
      var newAddressForm = document.getElementById("AddressNewForm");
      var addressForms = document.querySelectorAll(".js-address-form");

      if (!newAddressForm || !addressForms.length) {
        return;
      }

      // Country/province selector can take a short time to load
      setTimeout(function () {
        document.querySelectorAll(".js-address-country").forEach((el) => {
          var countryId = el.dataset.countryId;
          var provinceId = el.dataset.provinceId;
          var provinceContainerId = el.dataset.provinceContainerId;

          new Shopify.CountryProvinceSelector(countryId, provinceId, {
            hideElement: provinceContainerId,
          });
        });
      }, 1000);

      // Toggle new/edit address forms
      document.querySelectorAll(".address-new-toggle").forEach((el) => {
        el.addEventListener("click", function () {
          newAddressForm.classList.toggle("hide");
        });
      });

      document.querySelectorAll(".address-edit-toggle").forEach((el) => {
        el.addEventListener("click", function (evt) {
          var formId = evt.currentTarget.dataset.formId;
          document
            .getElementById("EditAddress_" + formId)
            .classList.toggle("hide");
        });
      });

      document.querySelectorAll(".address-delete").forEach((el) => {
        el.addEventListener("click", function (evt) {
          var formId = evt.currentTarget.dataset.formId;
          var confirmMessage = evt.currentTarget.dataset.confirmMessage;

          if (
            confirm(
              confirmMessage || "Are you sure you wish to delete this address?"
            )
          ) {
            if (Shopify) {
              Shopify.postLink("/account/addresses/" + formId, {
                parameters: { _method: "delete" },
              });
            }
          }
        });
      });
    }
  };

  /*============================================================================
  Things that don't require DOM to be ready
  ==============================================================================*/
  theme.config.hasSessionStorage = theme.isStorageSupported("session");
  theme.config.hasLocalStorage = theme.isStorageSupported("local");

  if (theme.config.hasLocalStorage) {
    var recentIds = window.localStorage.getItem("recently-viewed");
    if (recentIds && typeof recentIds !== undefined) {
      theme.recentlyViewedIds = JSON.parse(recentIds);
    }
  }

  /*============================================================================
  Things that require DOM to be ready
  ==============================================================================*/
  function DOMready(callback) {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
  }

  theme.initGlobals = function () {
    theme.videoModal();
  };

  DOMready(function () {
    theme.sections = new theme.Sections();

    theme.sections.register("header", theme.Header);

    theme.sections.register("toolkit", theme.Toolkit);
    theme.sections.register("product", theme.Product);
    theme.sections.register("accordion", theme.Accordion);
    theme.sections.register("video-grid", theme.videoGrid);
    theme.sections.register("photoswipe", theme.Photoswipe);
    theme.sections.register("collection", theme.Collection);

    theme.sections.register("image-slider", theme.ImageSlider);
    theme.sections.register("images-column", theme.ImagesColumn);
    theme.sections.register("image-carousel", theme.ImageCarousel);
    theme.sections.register("reviews-slider", theme.ReviewsSlider);

    theme.sections.register("slideshow", theme.ImageSlideshow);

    theme.sections.register("products-slider", theme.ProductSlider);
    theme.sections.register("store-availability", theme.StoreAvailability);
    theme.sections.register("footer", theme.Footer);

    theme.initGlobals();

    if (document.body.classList.contains("template-cart")) {
      var cartPageForm = document.getElementById("CartPageForm");
      if (cartPageForm) {
        var cartForm = new theme.CartForm(cartPageForm);

        document.addEventListener(
          "ajaxProduct:added",
          function (evt) {
            cartForm.buildCart();
          }.bind(this)
        );
      }
    }

    theme.customerTemplates();

    document.querySelector('.text-link__review')?.addEventListener('click', function(e){
      e.preventDefault();
      let target = this.getAttribute('href');
      document.querySelector(target)?.scrollIntoView();
    });
  });
})();


// =================Cart drawer add on ===================
async function isAddOnProductInCart(productId) {
    try {
      const response = await fetch('/cart.js'); // Fetch the current cart
      const cart = await response.json();
      return cart.items.some(item => item.id == productId); // Check if add on product exists
    } catch (error) {
      console.error("Error fetching cart data:", error);
      return false;
    }
}
async function checkaddon_product(){
  if(!document.querySelector(".cart__drawer-form"))return;
  if(!document.querySelector("add-on-product"))return; // 2026-09-28 cart-fix-l low-drawer-clean C24: the /cart.js read below only feeds an <add-on-product> element no template renders; skip it when absent. Rollback: delete this line.
  isAddOnProductInCart(document.querySelector(".cart__drawer-form").getAttribute("data-add-on-product")*1).then(isInCart => {
    var add_on_ele =  document.querySelector("add-on-product");
      if (add_on_ele){
        if (isInCart) {
          add_on_ele.classList.add("visually-hidden");  
        } else {
          add_on_ele.classList.remove("visually-hidden");  
        }      
      }          
  });  
}

async function add_on_cart () {
      const add_on_btn =  document.querySelector("add-on-product button.quick-add-btn");
      if (add_on_btn) {
          add_on_btn.addEventListener('click', function(e) {
              cstm_addTo_Cart(event);
          });
      }
      function cstm_addTo_Cart (evt) {
        let button = evt.currentTarget;
        let productId = button.dataset.id;

        var data = {
          items: [
            {
              id: productId,
              quantity: 1,
            },
          ],
        };

        fetch(theme.routes.cartAdd, {
          method: "POST",
          body: JSON.stringify(data),
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
          },
        })
          .then((response) => response.json())
          .then(
            function (data) {
              if (data.status === 422 || data.status === "bad_request") {
              } else {
                var product = data;
                document.dispatchEvent(
                  new CustomEvent("ajaxProduct:added", {
                    detail: {
                      product: product,
                    },
                  })
                );
                document.querySelector("add-on-product").classList.add("visually-hidden");  
                // new theme.Drawer("header_minicart", "right").open();
              }
            }.bind(this)
          );
      }

}
add_on_cart ();
checkaddon_product();

// 2026-08-12 - Joel: "does clarity show any issues at checkout or adding to cart?" Shared failure
// UI for the sticky add-to-cart bar and the buy-now button. Both used to swallow a failed
// /cart/add.js completely: a 422 (sold out / over the per-order limit) is valid JSON so it fed
// the ERROR body into the success path, fired ajaxProduct:added and opened the drawer EMPTY with
// no message, and a rejected fetch left btn--loading on forever because it is only removed inside
// the .then. Both reproduced live at 375px. This renders the theme's own .errors element (same
// class ProductForm.error uses) beside the button. To roll back, delete this function and the two
// blocks marked "2026-08-12 ATC failure" below.
function aoamStickyAtcError(btn, err) {
  try {
    if (btn && btn.classList) { btn.classList.remove("btn--loading"); }
    var msg = (err && err.aoamDescription) || "Sorry, we could not add that to your cart. Please try again.";
    var host = (btn && (btn.closest(".sticky-add-to-cart-btn") || btn.parentNode)) || document.body;
    var old = host.querySelector(".errors.aoam-atc-error");
    if (old) { old.remove(); }
    var div = document.createElement("div");
    div.className = "errors text-center aoam-atc-error";
    div.setAttribute("role", "alert");
    div.textContent = msg;
    host.appendChild(div);
    setTimeout(function () { if (div && div.parentNode) { div.remove(); } }, 8000);
    document.dispatchEvent(new CustomEvent("ajaxProduct:error", { detail: { errorMessage: msg } }));
  } catch (e) { console.error("aoamStickyAtcError", e); }
}
document.addEventListener("DOMContentLoaded", function () {
  const stickyButton = document.querySelector('.sticky-add-to-cart-btn button');
  // if (stickyButton) {
  //   stickyButton.addEventListener('click', function () {        
  //     gtag('event', 'sticky_add_to_cart_click', {
  //       event_category: 'engagement',
  //       event_label: 'Sticky Add to Cart Button'
  //     });
  //   });
  // }
  if (stickyButton) {
    stickyButton.addEventListener('click', function (e) {        
    const pro_id = this.getAttribute("data-product-id"); 
      this.classList.add("btn--loading");
      // AOAM fix (2026-06-19): the sticky add-to-cart bar sits OUTSIDE the product form, so it was
      // adding items with NO warranty line-item properties -> the Lifetime Warranty stayed dead in the
      // drawer (the main symptom on mobile, where the sticky bar is the primary add button). Pull the
      // warranty props from the product form on the page so sticky-added items are warranty-eligible.
      var _aoamProps = {};
      var _aoamForm = document.querySelector('form.product-single__form');
      if (_aoamForm) {
        [
          '_related_product',
          '_warranty_pro_id',
          '_warranty_pro_des',
          '_warranty_pro_price',
          '_product_1',
          '_product_2'
        ].forEach(function(_k) {
          var _i = _aoamForm.querySelector('input[name="properties[' + _k + ']"]');
          if (_i && _i.value) {
            _aoamProps[_k] = _i.value;
          }
        });
      }
      var _aoamBody = { id: parseInt(pro_id), quantity: 1 };
      if (Object.keys(_aoamProps).length) _aoamBody.properties = _aoamProps;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(_aoamBody)
      })
      // 2026-08-12 ATC failure: reject a non-ok /cart/add.js instead of parsing the error body
      // as though it were a product. Shopify returns the customer-facing sentence in .description.
      .then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (body) {
          if (!res.ok) {
            var e = new Error('cart/add.js ' + res.status);
            e.aoamDescription = body.description || body.message;
            throw e;
          }
          return body;
        });
      })
      .then(data => {      
        var product = data;
        document.dispatchEvent(
          new CustomEvent("ajaxProduct:added", {
            detail: {
              product: product,
            },
          })
        );
        this.classList.remove("btn--loading");
        // console.log("added to cart sucessfully..1");
        /* 2026-08-17 (Claude) - was new theme.Drawer("header_minicart", "right").open(); , which
           built a WHOLE NEW Drawer on every press of the sticky Add to Cart. Each construction
           re-binds an open listener to every .js-drawer-open-right, a close listener to every
           .js-drawer-close and an outside-click listener to .site-content, so a shopper who added
           three times carried three of each. That is what turned the <html> mis-bind above into a
           permanent dead X rather than a one-off. Reuse one instance, and clear its own open flag
           first so open() still runs (a fresh instance always started false, and aoam-cart-fix owns
           the real open/close, so this object cannot be trusted to know the current state).
           Restore the single line above to roll back. */
        var _aoamMini = window.__aoamMiniDrawer;
        if (!_aoamMini) { _aoamMini = window.__aoamMiniDrawer = new theme.Drawer("header_minicart", "right"); }
        _aoamMini.drawerIsOpen = false;
        if (!(window.__aoamCloseHolds && window.__aoamCloseHolds())) _aoamMini.open();   // 2026-10-11 (Claude): close-wins, see HeaderCart ajaxProduct:added
      })
      .catch(err => {
        // 2026-08-12 ATC failure: clear the spinner and tell the customer. The old body was
        // console.error only, so the button span forever on a dropped request.
        aoamStickyAtcError(this, err);
        console.error("Error:", err);
      });
      
    });
  }
  
  var native_add =  document.querySelectorAll("[data-add-to-cartss]");
  if (native_add) {
    native_add.forEach(function (add_btn) {
      add_btn.addEventListener("click", function (event) {
        event.preventDefault();                                                                 
        const pro_id = this.getAttribute("data-product-id"); 
        let properties = {};

        if(this.dataset.product1){
          properties["_product_1"] = this.dataset.product1;
        }

        if(this.dataset.product2){
          properties["_product_2"] = this.dataset.product2;
        }
        // AOAM fix (2026-06-19): scope the warranty .product_property_home inputs to THIS button's own
        // section container. The original grabbed them page-wide (document.querySelectorAll), so on a page
        // with multiple buy-now sections the LAST section's warranty won, attaching the wrong product's
        // warranty SKU. Scoping to the matched container makes each buy-now button carry its OWN warranty.
        var _aoamScope = add_btn.closest('.new-custom-pro-details-row') || add_btn.closest('.pro-right-content');
        if(_aoamScope){
          _aoamScope.querySelectorAll('.product_property_home').forEach(function(product_property_home){
             properties[product_property_home.name] = product_property_home.value;
          })
        }

        this.classList.add("btn--loading");
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: parseInt(pro_id),
            quantity: 1,
            properties: properties
          })
        })
        // 2026-08-12 ATC failure: reject a non-ok /cart/add.js instead of parsing the error body
      // as though it were a product. Shopify returns the customer-facing sentence in .description.
      .then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (body) {
          if (!res.ok) {
            var e = new Error('cart/add.js ' + res.status);
            e.aoamDescription = body.description || body.message;
            throw e;
          }
          return body;
        });
      })
        .then(data => {      
          var product = data;
          document.dispatchEvent(
            new CustomEvent("ajaxProduct:added", {
              detail: {
                product: product,
              },
            })
          );
          this.classList.remove("btn--loading");
          // console.log("Product Data",product);
          // console.log("Home page Buy now button added to cart");
          // new theme.Drawer("header_minicart", "right").open();

          fetch(`/variants/${product.id}.js`)
          .then(res => res.json())
          .then(variantData => {
            // Merge relevant variant info into the product object
            product.price = variantData.price;
            product.compare_at_price = variantData.compare_at_price;

            addToCartPopup_fn(product);
            let protection_product_checkbox = document.querySelector('.protection_product_checkbox');
            if(localStorage.getItem('warranty_toogle_is_disable_by_user') == 'false' /* 2026-09-24 opt-in: a missing flag is OFF now */){
                update_protection_products('Update');
            }else{
              update_protection_total_price();
            }
          })
          .catch(err => {
              let protection_product_checkbox = document.querySelector('.protection_product_checkbox');
              if(localStorage.getItem('warranty_toogle_is_disable_by_user') == 'false' /* 2026-09-24 opt-in: a missing flag is OFF now */){
                  update_protection_products('Update');
              }else{
                update_protection_total_price();
              }
            console.error("Error fetching variant details:", err);
            addToCartPopup_fn(product); // fallback
          });
        })
        .catch(err => {
          // 2026-08-12 ATC failure: same fix as the sticky bar above.
          aoamStickyAtcError(this, err);
          console.error("Error:", err);
        });            
    
      });
    });
  }

  // 2026-08-15 - Joel: "fix these video sliders on all pages so there are no gaps like this. they
  // should always be centered."
  // Measured on the BitWhip PDP at 2560px: 478px of black to the LEFT of the first card with the
  // strip jammed off the right edge. Cause: video-list.css caps a cell at 16% of the rail from
  // 2000px up (6.25 across), but this section normally carries 5 or 6 videos, so the cells cannot
  // fill the rail and Flickity's wrapAround has no cells left to shift into the hole. Under 2000px
  // the cells are 33% and the strip always overflows, which is why it only ever shows on a wide
  // monitor. Same class of bug, and the same remedy, as the multi-video-list fix below.
  // Two parts. Size the cells against the REAL rail instead of a fixed percentage, so when there
  // are more videos than fit they tile it exactly with no remainder. And when every video already
  // fits, drop Flickity for a centred flex row: arrows and dots that page nothing are just a way to
  // leave a hole. Recomputed on resize.
  // Roll back by deleting this block, restoring the plain
  //   new Flickity(elem, { wrapAround: true, cellAlign: 'left', pageDots: true, autoPlay: true })
  // over ".video-list-slider .main-carousel", and deleting the matching block in video-list.css.
  var vlsCarousels = [].slice.call(document.querySelectorAll(".video-list-slider .main-carousel"));

  function vlsFlickity(elem) {
    return (typeof Flickity !== 'undefined') ? Flickity.data(elem) : null;
  }

  function vlsInit(elem) {
    var flkty = new Flickity(elem, {
      wrapAround: true,
      cellAlign: 'left',
      pageDots: true,
      autoPlay: true
    });
    flkty.on('ready', function () { updateDotPagination(flkty); });
    flkty.on('change', function () { updateDotPagination(flkty); });
    return flkty;
  }

  // Returns true when every cell already fits the rail, false when it has to scroll, and null when
  // the section is not measurable yet (hidden, zero width) so the caller can leave it alone.
  function vlsMeasure(elem) {
    var cells = [].slice.call(elem.querySelectorAll(".carousel-cell"));
    if (!cells.length) return null;

    // Read the width the stylesheet asks for, with our own override off.
    elem.classList.remove("vls-sized");
    elem.style.removeProperty("--vls-cell-w");
    var cs = getComputedStyle(elem);
    var rail = elem.clientWidth - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0);
    // Measure the cell with shrinking switched off. Two traps here, both of which quietly return a
    // number that looks plausible. Before Flickity takes over the cells are flex items that all ask
    // for 100% and then SHRINK to share the rail, so the rendered box is always rail/count and every
    // section measures as though it fits. And getComputedStyle().maxWidth is not the escape: Chrome
    // hands back the percentage as authored ("16%"), so parsing it gives a 16px cell.
    elem.classList.add("vls-measuring");
    var base = cells[0].getBoundingClientRect().width;
    elem.classList.remove("vls-measuring");
    if (rail <= 0 || base <= 0) return null;

    var perRow = Math.max(1, Math.floor((rail + 1) / base));
    // 2026-10-22 Joel phone walk item 3 desktop ("ship the bitwhip desktop clips"): a desktop_row section with more
    // clips than one row holds wraps into rows of perRow (static, no dots, arrows or autoplay) instead of turning
    // back into a slider. Delete this block and the vls-wrap rule in sections/video-list.liquid to roll back.
    var vlsWrap = !!elem.closest('.vls-desktop-row') && window.innerWidth >= 1200 && cells.length > perRow;
    elem.classList.toggle('vls-wrap', vlsWrap);
    var fits = cells.length <= perRow || vlsWrap;
    // A cell never grows past 1.5x what the stylesheet asked for, so a section with one or two
    // videos does not end up with a card the width of the screen. Below that cap the row is centred.
    var w = (fits && !vlsWrap) ? Math.min(rail / cells.length, base * 1.5) : rail / perRow;
    w = Math.floor(w * 100) / 100;

    elem.style.setProperty("--vls-cell-w", w + "px");
    elem.classList.add("vls-sized");
    return fits;
  }

  function vlsApply(elem) {
    var fits = vlsMeasure(elem);
    var flkty = vlsFlickity(elem);
    if (fits === null) {
      if (!flkty) vlsInit(elem);
      return;
    }
    if (fits) {
      if (flkty) flkty.destroy();
      elem.classList.add("vls-static");
      vlsMeasure(elem);
      return;
    }
    elem.classList.remove("vls-static");
    if (flkty) { flkty.resize(); } else { vlsInit(elem); }
  }

  vlsCarousels.forEach(function (elem) {
    // Kept from the original init: a video reporting its real dimensions can change the row height.
    elem.querySelectorAll("video").forEach(function (video) {
      video.addEventListener("loadedmetadata", function () { vlsApply(elem); });
    });
    vlsApply(elem);
  });

  if (vlsCarousels.length) {
    var vlsResizeTimer;
    window.addEventListener("resize", function () {
      clearTimeout(vlsResizeTimer);
      vlsResizeTimer = setTimeout(function () { vlsCarousels.forEach(vlsApply); }, 150);
    });
    window.addEventListener("load", function () { vlsCarousels.forEach(vlsApply); });
  }
  // image/video
  // 2026-07-29 - Joel: "i want all of these galleries on product pages to be centered so that when
  // you land on the page the available images are centered and there are no gaps on the sides."
  // The strip is meant to bleed past the 1500px container, but Flickity only ever measured the
  // container, so on a wide screen it ran out of cells and left a black gap on the right while the
  // left stayed full. Measure the real bleed and hand it to the CSS as --vlm-bleed (consumed in
  // sections/multi-video-list.liquid) so the carousel spans the whole window, then centre the cells.
  // Delete this block, put cellAlign back to 'left' and delete the matching CSS block to roll back.
  var vlmCarousels = document.querySelectorAll('.section-video-list-multi .vlm-carousel');
  function vlmSetBleed(elem) {
    var wrap = elem.parentElement;
    if (!wrap) return;
    elem.style.setProperty('--vlm-bleed', Math.max(0, Math.round(wrap.getBoundingClientRect().left)) + 'px');
  }
  function vlmRefresh() {
    vlmCarousels.forEach(function (elem) {
      vlmSetBleed(elem);
      var f = (typeof Flickity !== 'undefined') && Flickity.data(elem);
      if (f) { f.resize(); }
    });
  }
  vlmCarousels.forEach(vlmSetBleed);
  var vlmResizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(vlmResizeTimer);
    vlmResizeTimer = setTimeout(vlmRefresh, 100);
  });
  window.addEventListener('load', vlmRefresh);
  vlmCarousels.forEach(function (elem) {
      var flkty = new Flickity(elem, {
        wrapAround: true,
        cellAlign: 'center',
        pageDots: true,
        prevNextButtons: true,
        autoPlay: false
      });
      
       flkty.on('ready', function () {
          updateDotPagination(flkty);
        });

        // Update pagination on slide change
        flkty.on('change', function () {
          updateDotPagination(flkty);
        });
        updateDotPagination(flkty);
      // elem.querySelectorAll('.vlm-cell .block-wrappperer').forEach((a)=>{
      //   a.style.height = "100%";
      // })
      elem.querySelectorAll('.vlm-cell').forEach((a)=>{
        a.style.height = "100%";
      })
      elem.querySelectorAll('video').forEach(function (v) {
        v.addEventListener('loadedmetadata', function () { flkty.resize(); });
      });
    });

    // POPULAR ACCESSORIES:
(function () {
  function initAccCarousels() {
    if (typeof Flickity === 'undefined') return;
    document.querySelectorAll('.acc-carousel').forEach(function (el) {
      // Skip if already a Flickity instance
      if (Flickity.data(el)) {
        Flickity.data(el).resize();
        return;
      }
      new Flickity(el, {
        cellAlign: 'left',
        contain: true,
        pageDots: true,               
        prevNextButtons: true,
        groupCells: true,
        wrapAround: false,
        imagesLoaded: true,
        adaptiveHeight: false
      });
    });
  }

  if (document.readyState !== 'loading') {
    initAccCarousels();
  } else {
    document.addEventListener('DOMContentLoaded', initAccCarousels);
  }

  // 2) Re-run when the drawer opens (Flickity measures 0 width while hidden)
  document.addEventListener('click', function (e) {
    if (e.target.closest('.js-drawer-open, [href*="cart"], .cart-toggle')) {
      setTimeout(initAccCarousels, 350); // wait for open animation
    }
  });

  // 3) Re-init when the cart drawer markup is replaced via AJAX
  var cartRoot = document.querySelector('[data-header-cart]') || document.body;
  if (window.MutationObserver) {
    new MutationObserver(function () {
      // small debounce so we run after the new nodes settle
      clearTimeout(window.__accCarouselTimer);
      window.__accCarouselTimer = setTimeout(initAccCarousels, 200);
    }).observe(cartRoot, { childList: true, subtree: true });
  }
})();


  ///image gallery slider
  var elem = document.querySelector(".image-gallery .image-gallery-grid");
  if (elem) {
    var flkty_slider = new Flickity(elem, {
      wrapAround: true,
      cellAlign:'left',
      pageDots: false,
      autoPlay: true
    });

    flkty_slider.on('ready', function() {
      updateDotPagination(flkty_slider);
    });

    // run every time the slide changes
    flkty_slider.on('change', function() {
      updateDotPagination(flkty_slider);
    });

  }; 
  
  ///story images gallery slider
  var elem = document.querySelector(".story-slider .carousel");
  if (elem) {
    var flkty_slider = new Flickity(elem, {
      wrapAround: true,
      cellAlign:'left',
      pageDots: true,
      autoPlay: false
    });
  }; 
  
  ///mobile costume idea images slider
  if (window.screen.width < 750) {
    var elem = document.querySelectorAll(".costume-images-grid");
    if (elem) {
      elem.forEach(function (params) {
        var flkty_slider = new Flickity(params, {
        wrapAround: true,
        cellAlign:'left',
        pageDots: false,
        autoPlay: true
        });
      });
    } 
  }
  
 // ================video slider  fun =========================== 
  // -d start of adding mp4/utube video logic

    (function () {
      var ytPlayers = {};

      // ── Hook into the theme's existing youTubeReady event ──────────
      // NEVER overwrite window.onYouTubeIframeAPIReady — theme already uses it
      function initVideoSliderPlayers() {
        document
          .querySelectorAll(".video-list-slider .carousel-cell iframe.youtube-player")
          .forEach(function (iframe, index) {
            // Assign unique ID if missing
            if (!iframe.id) iframe.id = "yt-slider-" + index;

            // Force enablejsapi if somehow missing
            if (!iframe.src.includes("enablejsapi=1")) {
              iframe.src += (iframe.src.includes("?") ? "&" : "?") + "enablejsapi=1";
            }

            ytPlayers[iframe.id] = new YT.Player(iframe.id, {
              events: {
                onStateChange: function (event) {
                  if (event.data === YT.PlayerState.PLAYING) {
                    pauseAllExcept(null, iframe.id);
                  }
                },
              },
            });
          });
      }

      // ── Central pause function ─────────────────────────────────────
      function pauseAllExcept(activeMP4, activeYTId) {
        // Pause all MP4s except active
        document
          .querySelectorAll(".video-list-slider .carousel-cell video")
          .forEach(function (vid) {
            if (vid !== activeMP4) {
              vid.pause();
              vid.controls = false;
              var btn = vid.closest(".carousel-cell") &&
                        vid.closest(".carousel-cell").querySelector(".play-icon");
              if (btn) btn.classList.remove("hide");
            }
          });

        // Pause all YT players except active
        Object.keys(ytPlayers).forEach(function (id) {
          if (id !== activeYTId) {
            var player = ytPlayers[id];
            if (player && typeof player.pauseVideo === "function") {
              try { player.pauseVideo(); } catch (e) {}
            }
          }
        });
      }

      // ── MP4 play button logic ──────────────────────────────────────
      document
        .querySelectorAll(".video-list-slider .carousel-cell")
        .forEach(function (container) {
          var video = container.querySelector("video");
          var playButton = container.querySelector(".play-icon");

          if (!video || !playButton) return;

          playButton.addEventListener("click", function (event) {
            event.preventDefault();

            if (video.paused) {
              pauseAllExcept(video, null);
              video.play();
              video.controls = true;
              playButton.classList.add("hide");
            } else {
              video.pause();
              video.controls = false;
              playButton.classList.remove("hide");
            }
          });

          video.addEventListener("ended", function () {
            video.controls = false;
            playButton.classList.remove("hide");
          });
        });

      // ── Wait for theme's youTubeReady event ───────────────────────
      if (theme.config.youTubeReady) {
        // YT already ready (rare but possible)
        initVideoSliderPlayers();
      } else {
        document.addEventListener("youTubeReady", function () {
          initVideoSliderPlayers();
        });
      }

    })();

    // end of logic

  function slider_grid_fullheight() {
    const productItems = document.querySelectorAll(".product-slider-inner .grid-product");
    productItems.forEach(item => {
      item.style.height = "100%";
    });
  }
    setTimeout(() => {     
      slider_grid_fullheight();
    }, 3000);
  
    
// const videos = document.querySelectorAll(".video-list-slider video");
  let currentIndex = 0;
  function playNextVideo() {
    if (videos.length === 0) return;
    // Play current video
    let currentVideo = videos[currentIndex];
    currentVideo.play();

    // Move to the next video after 3 seconds
    setTimeout(() => {
      currentIndex = (currentIndex + 1) % videos.length; // Loop back after last video
      playNextVideo();
    }, 3000);
  }


 // playNextVideo(); 
// ====================================================
  let touchStartX = 0;
  let touchEndX = 0;

  function handleSwipe() {
    // console.log("touchStartX", touchStartX, "touchEndX", touchEndX)
    if (touchStartX - touchEndX > 50 && document.querySelector("html").classList.contains("js-drawer-open-left")) {            
             document.querySelector("#mobile-navigation .js-drawer-close").click();      
    }
    if(touchEndX - touchStartX > 50 && document.querySelector("html").classList.contains("js-drawer-open-right")){      
                document.querySelector("#header_minicart .js-drawer-close").click();    
    }
  }

  document.addEventListener('touchstart', function (e) {
    touchStartX = e.changedTouches[0].screenX;
  });

  document.addEventListener('touchend', function (e) {
    touchEndX = e.changedTouches[0].screenX;
    // handleSwipe();
  });  

// ================
  const cstm_btn_cart = document.querySelector(".custom-cart-icon-wrap");
  if(cstm_btn_cart){
      cstm_btn_cart.addEventListener("click", function() {
          document.querySelector("[data-header-cart-trigger]").click();
      });    
  }

// ======================== PDP page scroll ===================
if (location.href.includes("judgeme_product_reviews")) { 
        setTimeout(() => {
        const review_a = document.querySelector(".jdgm-write-rev-link");
        if (review_a){review_a.click();}  
        }, 3000);
}
  
 if (location.href.includes("customer_posted=true")) {
  const interval = setInterval(() => {
    const footer = document.querySelector(".section-footer__inner");
    const instaFeed = document.querySelector("#insta-feed");

    if (footer && instaFeed && instaFeed.offsetHeight > 0) {
      const footerTop = footer.getBoundingClientRect().top + window.scrollY;

      window.scrollTo({
        top: footerTop,
        behavior: "smooth"
      });

      clearInterval(interval); // Stop checking after scroll
    }
  }, 1000); // Check every 300ms
}

// ========================== End of the DOM ==========================
});

// function updateDotPagination(){
//   document.querySelectorAll("[data-product-images] .flickity-page-dots").forEach(dots => { 
//     if(dots.children.length<10) return;
//     let currentDot = dots.querySelector(".dot.is-selected");
//     let currentIndex = -1;
//     let lastIndex = dots.children.length - 1;
//     if(currentDot) currentIndex = [...currentDot.parentNode.children].indexOf(currentDot);
//     else return;
   
//     dots.querySelectorAll( ".dot" ).forEach( (dot, index) => {
//       if ( index==0 || index==dots.children.length-1 ) return;
//       if ( index == currentIndex ) { dot.classList.remove("dot--gap"); return; } 
//       dot.classList.add("dot--gap"); 
//     } );
   
//     const span = 3;
//     dots.querySelectorAll( ".dot" ).forEach( (dot, index) => {
//       if ( !dot.classList.contains("dot--gap") ) return;
//       if( index < currentIndex ){ 
//         if( currentIndex < span || ( lastIndex - currentIndex <= span && lastIndex - index <= span )  ) {  
//           dot.classList.remove("dot--gap");
//           return; 
//         } 
//         if( currentIndex - index < 2 ) dot.classList.remove("dot--gap"); 
//       } else {
//         if( lastIndex - currentIndex < span || ( currentIndex <= span && index <= span ) ) { 
//           dot.classList.remove("dot--gap"); 
//           return; 
//         } 
//         if( index - currentIndex < 2 ) dot.classList.remove("dot--gap"); 
//       }
//     });
//   });
// }

function updateDotPagination(target) {
  // console.log("Target",target);
  let dotsContainer = null;

  // Case 1: Flickity instance passed
  if (target && target.pageDots) {
    dotsContainer = target.pageDots.holder; // <ol> wrapper element
  }

  // Case 2: DOM container passed
  else if (target instanceof Element) {
    dotsContainer = target.querySelector(".flickity-page-dots");
  }

  if (!dotsContainer) {
    console.log("No dots found for", target);
    return;
  }

  let currentDot = dotsContainer.querySelector(".dot.is-selected");
  if (!currentDot) return;

  // console.log("current DOT:", currentDot);

  let currentIndex = [...dotsContainer.children].indexOf(currentDot);
  let lastIndex = dotsContainer.children.length - 1;

  // Reset all to gap except first/last/current
  dotsContainer.querySelectorAll(".dot").forEach((dot, index) => {
    if (index === 0 || index === lastIndex || index === currentIndex) {
      dot.classList.remove("dot--gap");
    } else {
      dot.classList.add("dot--gap");
    }
  });

  const span = 3;
  dotsContainer.querySelectorAll(".dot").forEach((dot, index) => {
    if (!dot.classList.contains("dot--gap")) return;

    if (index < currentIndex) {
      if (currentIndex < span || (lastIndex - currentIndex <= span && lastIndex - index <= span)) {
        dot.classList.remove("dot--gap");
      } else if (currentIndex - index < 2) {
        dot.classList.remove("dot--gap");
      }
    } else {
      if (lastIndex - currentIndex < span || (currentIndex <= span && index <= span)) {
        dot.classList.remove("dot--gap");
      } else if (index - currentIndex < 2) {
        dot.classList.remove("dot--gap");
      }
    }
  });
}
function formatMoneyNoTrailing(amount) {
        let formatted = theme.Currency.formatMoney(amount, theme.settings.moneyFormat);
        return formatted.replace(/(\.00|,00)$/, '');
}




// document.addEventListener("cart:updated", function (event) {
//   updateExtendedWarranty();
//   updateCompareTotal();

//   if (event.detail && event.detail.cart) {
//     const cart = event.detail.cart;

//     updateFreeShippingUI(cart.total_price);
//     updateCartSavingsUI(cart);

//   } else {
//     // fallback (safe)
//     fetch('/cart.js')
//       .then(res => res.json())
//       .then(cart => {
//         updateFreeShippingUI(cart.total_price);
//         updateCartSavingsUI(cart);
//       });
//   }
// });


document.addEventListener('cart:updated', function (event) {
  if (!event.detail || !event.detail.cart) return;
  const cart = event.detail.cart;

  /* =========================
     CART PAGE LOGIC
  ========================== */
  // updateExtendedWarranty();
  setTimeout(()=>{
    updateCompareTotal();
  },1000);
  

  updateCartPageOrderDiscount(cart); // ✅ FIXED

  toggleOrderDiscountVisibility();

  updateFreeShippingUI(cart.total_price, cart);
});





  document.addEventListener('click', function (e) {
    const checkoutBtn = e.target.closest('.block-mincart .cart__footer .cart__item-row.payment-buttons .btn-cart__checkout');
    if (!checkoutBtn) return;

    e.preventDefault();
    e.stopPropagation();

    // loading class add
    checkoutBtn.classList.add('btn--loading');

    // optional: disable button to prevent double click
    checkoutBtn.setAttribute('disabled', 'disabled');

    // small delay so loading animation shows
    // 2026-09-28 cart-fix-m C30 (Claude): also wait (max 4s) for an in-flight warranty add/remove or cart write, so the
    // cover the drawer shows is the cover checkout gets. Rollback: restore setTimeout(() => { window.location.href = '/checkout'; }, 300);
    var aoamGo = function () { window.location.href = '/checkout'; };
    var aoamSettle = (typeof window.aoamCartSettled === 'function') ? window.aoamCartSettled(4000) : Promise.resolve();
    /* 2026-11-03 cart audit B-003 / E-001 (Claude, W1a): a cart holding only warranty cover stays in the drawer with a friendly line (window.aoamCheckoutGuard in assets/aoam-cart-fix.js); no guard loaded = go as before. */
    var aoamCheck = function () {
      if (typeof window.aoamCheckoutGuard !== 'function') return aoamGo();
      window.aoamCheckoutGuard().then(function (ok) {
        if (ok) return aoamGo();
        checkoutBtn.classList.remove('btn--loading'); checkoutBtn.removeAttribute('disabled');
        try { if (typeof window.aoamPageSpinner === 'function') window.aoamPageSpinner(false); } catch (x) {}
      }, aoamGo);
    };
    Promise.all([aoamSettle, new Promise(function (r) { setTimeout(r, 300); })]).then(aoamCheck, aoamCheck);
  });





function updateCartCount(count) {
  const countElem = document.querySelector(".cart__item-sub.cart__item--subtotal .drawer-item-count");
  if (countElem) {
    countElem.textContent = "(" + count + (count === 1 ? " item" : " items") + ")";
  }
}

function handleCartUpdate(event) {
  if (event && event.detail && event.detail.cart) {
    const cart = event.detail.cart;
    updateFreeShippingUI(cart.total_price, cart);
    updateCompareTotal();

  } else {
    // fallback (safe)
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        updateFreeShippingUI(cart.total_price, cart);
        updateCompareTotal();
      });
  }
}



// document.addEventListener("ajaxProduct:added", function(event) {

//       fetch('/cart.js')
//         .then(res => res.json())
//         .then(cart => {
//           setTimeout(() => {
//         fetch('/cart.js')
//           .then(res => res.json())
//           .then(cart => {
//             updateFreeShippingUI(cart.total_price);
//             updateCartCount(cart.item_count);
//           });
//       }, 300); // 👈 delay compulsory

//       //  Find warranties whose _related_product is NOT in main products anymore
//       var saving = 0;

//       cart.items.forEach(item => {
//         // For displaying aving price of all the items
//         let variantId = item.id; 
      
//         fetch(`/variants/${variantId}.js`)
//           .then(res => res.json())
//           .then(variant => {
//             if (variant.compare_at_price > item.original_price) {
//               // calculate per-unit saving (still in cents)
//               let line_saving = (variant.compare_at_price - item.original_price) * item.quantity;
//               saving += line_saving; // accumulate
//             }

//             let formattedSaving = formatMoneyNoTrailing(saving);
//             let savingEl = document.querySelector(".cart__footer .block-saving__amount");
             
//             if (savingEl) {
//               savingEl.textContent = formattedSaving;          // text update (je tame karto hata)
//               savingEl.setAttribute("cus-discount", formattedSaving); // ✅ SAME value attribute ma
//             }

//           })
//           .catch(err => console.error("Variant fetch error:", err));
//       });
//       function formatMoneyNoTrailing(amount) {
//         let formatted = theme.Currency.formatMoney(amount, theme.settings.moneyFormat);
//         return formatted.replace(/(\.00|,00)$/, '');
//       }
//         updateCompareTotal();
//     });

//     let product = event.detail.product;
//     if (!product || !product.id) return;

//     // Wait a moment for the cart DOM to refresh
//     setTimeout(() => {
//       // Find warranty button for this specific product in cart
//       let warrantyBtn = document.querySelector(
//         `.cart__item_wrp[data-id="${product.id}"] .extended-warranty[data-extended-submit]`
//       );

//       if (warrantyBtn && warrantyBtn.dataset.inCart !== "true") {
//         // Simulate click to use existing logic
//         warrantyBtn.click();
//         console.log("warrantyBtn",warrantyBtn);
//       }
//     }, 2000);

//      updateExtendedWarranty();
   

//      if (event && event.detail && event.detail.cart) {
//     const cart = event.detail.cart;
//     updateFreeShippingUI(cart.total_price);
//   } else {
//     // fallback (safe)
//     fetch('/cart.js')
//       .then(res => res.json())
//       .then(cart => {
//         updateFreeShippingUI(cart.total_price);
//       });
//   }

// });

document.addEventListener("ajaxProduct:added", function (event) {
  // Wait for Shopify cart to fully update
  setTimeout(() => {
    fetch('/cart.js')
      // 2026-08-06 - Clarity/GA4 error-click sweep. This handler runs after EVERY add-to-cart and
      // then fans out one /variants/<id>.js fetch per cart line, so a big kit cart trips Shopify's
      // throttle by itself and the HTML 429 page made res.json() throw "Unexpected token '<'"
      // uncaught. Leave the free-shipping bar, count and savings on their previous values; the
      // next cart change refreshes them. Restore the bare res.json() chain and drop the catch
      // below to roll back.
      .then(res => (res.ok ? res.json() : null))
      .then(cart => {
        if (!cart || !Array.isArray(cart.items)) { return; }

        /* =============================
           FREE SHIPPING + COUNT
        ============================== */
        updateFreeShippingUI(cart.total_price, cart);
        updateCartCount(cart.item_count);
        updateCompareTotal();

        // 2026-09-28 cart-fix-m C31 (Claude): aoam-cart-fix's aoamWriteSavings owns the "You're saving" note (codes, struck
        // shipping, cents). This block re-summed compare-at only, with one /variants request per line, and landed last.
        // Rollback: delete the next line.
        if (window.AOAM_CART_BUILD) return;

        /* =============================
           SAVING CALCULATION
        ============================== */
        let saving = 0;
        let processed = 0;

        cart.items.forEach(item => {
          fetch(`/variants/${item.id}.js`)
            // 2026-08-06 - same sweep. A finally() does not handle a rejection, so a throttled
            // /variants/<id>.js still escaped as an uncaught rejection here. Skip the line's
            // saving instead; the total it feeds is cosmetic. Restore the bare res.json() chain
            // and drop the catch to roll back.
            .then(res => (res.ok ? res.json() : null))
            .then(variant => {
              if (variant && variant.compare_at_price > item.original_price) {
                saving +=
                  (variant.compare_at_price - item.original_price) *
                  item.quantity;
              }
            })
            .catch(function () {})
            .finally(() => {
              processed++;

              if (processed === cart.items.length) {
                let formattedSaving = formatMoneyNoTrailing(saving);
                let savingEl = document.querySelector(".cart__footer .block-saving__amount");

                if (savingEl) {
                  savingEl.textContent = formattedSaving;
                  savingEl.setAttribute("cus-discount", formattedSaving);
                }
              }
            });
        });

      })
      .catch(function (err) {
        console.error("Cart refresh after add failed:", err);
      });
  }, 300); // IMPORTANT delay

  /* =============================
     WARRANTY AUTO ADD
  ============================== */
  const product = event.detail?.product;
  if (!product?.id) return;

  setTimeout(() => {
    let warrantyBtn = document.querySelector(
      `.cart__item_wrp[data-id="${product.id}"] .extended-warranty[data-extended-submit]`
    );

    if (warrantyBtn && warrantyBtn.dataset.inCart !== "true") {
      // warrantyBtn.click();
    }
  }, 2000);

  // updateExtendedWarranty();
});

/* =============================
   Helper
============================== */
function formatMoneyNoTrailing(amount) {
  let formatted = theme.Currency.formatMoney(amount, theme.settings.moneyFormat);
  return formatted.replace(/(\.00|,00)$/, '');
}

document.addEventListener("cart:updated", function (event) {
  if (!event.detail || !event.detail.cart) return; // 2026-09-15: GA4 js_error "cart.item_count" on an event without a cart
  let cart = event.detail.cart;

  const item_count = cart.item_count;
  const countElem = document.querySelector(".cart__item-sub.cart__item--subtotal .drawer-item-count");
  if (countElem) {
    countElem.textContent = "(" + item_count + (item_count === 1 ? " item" : " items") + ")";
  }

  // Loop through each upsell form on the page
  document.querySelectorAll("[data-upsell-selector] form").forEach(form => {
    let addBtn = form.querySelector(".add-upsell-product");
    if (!addBtn) return;

    // Get variant ID from hidden input
    let variantId = form.querySelector('input[name="id"]')?.value;
    if (!variantId) return;

    // Check if that variant is still in the cart
    let stillInCart = cart.items.some(item => item.id == variantId);

    if (!stillInCart) {
      // Re-enable button
      addBtn.disabled = false;
      addBtn.classList.remove("btn--loading");
      // console.log("Product added successfully..3");
      const btnText = addBtn.querySelector("[data-upsell-text]").getAttribute("data-text");
      addBtn.querySelector("[data-upsell-text]").innerText = btnText; 
      // Make sure to have `theme.strings.upgrade` in your translations
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {

  updateCompareTotal();

  if (document.body.classList.contains("template-index")) {
    new theme.QuickAdd(document);
  }

  const form = document.querySelector(".subscribe-form");
  const closeBtn = document.querySelector(".subscribe-form .decline-offer");

  const COOKIE_NAME = "klaviyo_subscribe_hide_24h";
  const HIDE_DURATION_HOURS = 24;

  function setCookie(name, value, hours) {
    const d = new Date();
    d.setTime(d.getTime() + hours * 60 * 60 * 1000);
    document.cookie =
      name + "=" + value + ";expires=" + d.toUTCString() + ";path=/";
  }

  function getCookie(name) {
    const cname = name + "=";
    const cookies = decodeURIComponent(document.cookie).split(";");

    for (let c of cookies) {
      c = c.trim();
      if (c.indexOf(cname) === 0) {
        return c.substring(cname.length);
      }
    }
    return "";
  }

  // Hide initially
  form?.classList.add("hide");

  // Show after 8 seconds only if cookie does not exist
  if (getCookie(COOKIE_NAME) !== "true") {
    setTimeout(() => {
      form?.classList.remove("hide");
    }, 8000);
  }

  // Close popup and set cookie
  closeBtn?.addEventListener("click", function (e) {
    e.preventDefault();
    form?.classList.add("hide");
    setCookie(COOKIE_NAME, "true", HIDE_DURATION_HOURS);
  });
});

document.addEventListener("click", function (e) {
  const anchor = e.target.closest("a[href^='#']");
  if (!anchor) return;

  const targetId = anchor.getAttribute("href").substring(1);
  const targetBlock = document.getElementById(targetId);

  if (!targetBlock) return;

  e.preventDefault();

  // Scroll to section
  targetBlock.scrollIntoView({
    behavior: "smooth",
    block: "start"
  });

  // Find accordion header inside this block
  const header = targetBlock.querySelector(".block-title");

  if (header && !header.classList.contains("open")) {
    setTimeout(() => {
      header.click();
    }, 400); // small delay so scroll completes first
  }
});

document.body.addEventListener('click',(event)=>{
  let click_btn = event.target;
  if(click_btn.closest('.featured-product-list')){
    if(click_btn.closest('.featured-product-list')){
      if(typeof updateDotPagination == 'function'){
        updateDotPagination(click_btn.closest('.featured-product-list'));
      }
    }
  }
})


let update_protection_total_price= async (cart)=>{
  if(!cart){
   /* 2026-10-10 audit: a 429 or challenge page from /cart.js is not JSON; skip quietly instead of an uncaught SyntaxError */
   const cart_detail = await fetch('/cart.js',{headers:{Accept:'application/json'}}).then(res => res.ok ? res.json() : null).catch(() => null);
   if (cart_detail) update_protection_total_price(cart_detail);
  }else{
    if(!cart.items.length)return;
    updateCompareTotal();
    // AOAM fix (2026-06-19): refresh the TOTAL element. The theme leaves [data-subtotal] stale on a
    // quantity change because quantityChanged skips buildCart(), so the cart-page/drawer Total stuck
    // at the prior value while the Subtotal updated. This function runs at every cart-change
    // convergence point with the already-settled cart, so cart.total_price is the final amount
    // payable here - setting it once (not in a rAF pump) fixes the stale Total without bouncing.
    // 2026-08-16: + aoamShipCents, same reason as updateCount above - this is the writer that runs
    // on a quantity change, so without it a plus/minus click knocked the shipping back off the TOTAL.
    // 2026-10-10 audit: same string as aoamWriteTotals and the Liquid render (decimals kept). formatMoneyNoTrailing here made a whole-unit TOTAL (CA, GB and AU markets, gift cards) flip between "123.00" and "123". Restore formatMoneyNoTrailing( to roll back.
    document.querySelectorAll('[data-subtotal]').forEach(function(__totalEl){ __totalEl.innerHTML = theme.Currency.formatMoney(cart.total_price + (window.aoamShipCents ? window.aoamShipCents(cart) : 0), theme.settings.moneyFormat); });
    const totalQty = cart.items.reduce((total, item) => { if (!item.properties._protection_product) { return total + item.quantity; } return total; }, 0);
    let cart_inner_counts = document.querySelectorAll(".cart-inner-count-update");
    let cart_inner_count_update_spans = document.querySelectorAll('.cart-inner-count-update-span');
    cart_inner_counts.forEach((cart_inner_count)=>{
      cart_inner_count.innerHTML = totalQty;
    })

    cart_inner_count_update_spans.forEach((cart_inner_count_update_span)=>{
      if(totalQty>1){
        cart_inner_count_update_span.innerHTML = 'items';
      }else{
        cart_inner_count_update_span.innerHTML = 'item';
      }
    })
    let protection_total_price_ele = document.querySelector('.protection_total_price');
    let protection_total_containor = document.querySelector(".protection_total_containor");
    let protection_total_price_subtotal_ele = document.querySelector(".protection_total_price_subtotal");
    let prot_pro_switch = document.querySelector('.prot_pro_switch');
    let protection_total_price_subtotal = 0;
    let protection_total_price = 0;

    let protection_items_in_cart = cart.items.filter((cart_item)=>cart_item.properties['_protection_product']);
    protection_items_in_cart.forEach((pro_item)=>{protection_total_price_subtotal+=(pro_item.price * pro_item.quantity)})
    let filter_items = cart.items.filter((item)=> item.properties._warranty_pro_price);
    filter_items.length && filter_items.forEach((filter_item)=>{
      protection_total_price+=(parseFloat(filter_item.properties._warranty_pro_price)*filter_item.quantity);
    })
    // AOAM 2026-08-17 (currency): `_warranty_pro_price` is a FROZEN USD cents snapshot, written onto
    // the PDP's add-to-cart button and carried on the line for the life of the cart. Summing it and
    // handing it to Shopify.formatMoney - which IS contextualised per market - printed a USD number in
    // the local currency's clothes: a GB shopper saw "£19.95" for a warranty that really costs less in
    // GBP, and a Canadian saw "$19.95" for one that costs about C$28, which reads as CAD because CAD
    // also spells its currency "$". The warranty line already in the cart carries the REAL presentment
    // price, so prefer that and scale it to the eligible quantity.
    // Guarded three ways so this can only ever improve the number: it needs a warranty line to read
    // from, every such line must share ONE unit price (a mixed-tier cart keeps the old estimate rather
    // than averaging a $19.95 and a $39.95 warranty into one figure that is wrong for both), and there
    // must be an eligible quantity to scale to. In USD it is a provable no-op - the line price and the
    // frozen property are the same 1995. Mirrors the v19 fix live in snippets/aoam-cart-fix.liquid
    // since 2026-07-01, which fixed this same class of bug on Joel's AU cart ($59.85 shown, $90 charged).
    if (protection_total_price > 0 && protection_items_in_cart.length) {
      let __warrUnits = protection_items_in_cart.reduce((n, i) => n + (+i.quantity || 0), 0);
      let __uniformPrice = protection_items_in_cart.every((i) => i.price === protection_items_in_cart[0].price);
      let __eligibleQty = filter_items.reduce((n, i) => n + (+i.quantity || 0), 0);
      if (__uniformPrice && __warrUnits > 0 && __eligibleQty > 0) {
        protection_total_price = Math.round(protection_items_in_cart[0].price * __eligibleQty);
      }
    }
    // 2026-09-25 warranty price steps: the row shows the ORDER's step (or the real charge once added), not a per-item sum
    if (typeof window.aoamWarrShownCents === 'function') { try { const __s = window.aoamWarrShownCents(cart); if (__s != null) protection_total_price = __s; } catch (e) {} }
    if(protection_total_price_ele){
      if(protection_total_price == 0){
       protection_total_price_ele.innerHTML = ''; 
       if(prot_pro_switch)prot_pro_switch.classList.add('disabled');
      }else{
       protection_total_price_ele.innerHTML = Shopify.formatMoney(protection_total_price);
       if(prot_pro_switch)prot_pro_switch.classList.remove('disabled');
      }
    }
    if(protection_total_price_subtotal_ele){
      protection_total_price_subtotal_ele.innerHTML = Shopify.formatMoney(protection_total_price_subtotal);
      if(protection_total_containor && protection_total_price_subtotal>0){
        protection_total_containor.classList.remove('hide');
      }else{
        protection_total_containor.classList.add('hide');
      }
    }
  }
}


let update_protection_content=(condition,cart)=>{
  if(!window.protection_content)return;
  let warranty_title = document.querySelector(".warranty_title");
  let protection_description = document.querySelector(".protection_description");
  let is_there_pro_eligible = cart.items.find((item)=>item.properties['_warranty_pro_id']);
   if(condition == 'Update' && is_there_pro_eligible){
     if(__st.p != 'cart'){
      warranty_title.innerHTML = window.protection_content.title_before;
     }else{
      warranty_title.innerHTML = window.protection_content.title;
     }
     protection_description.innerHTML = window.protection_content.description;
   }else{
      warranty_title.innerHTML = window.protection_content.title_before;
      protection_description.innerHTML = window.protection_content.description_before;
   }
}

async function update_products_API_calls(add_new_items, update_existing_items) {
  let total_api_to_call = 0;
  let total_api_success_done = 0;

  if (add_new_items.length) total_api_to_call++;
  if (update_existing_items.length) total_api_to_call++;

  // Add new items
  if (add_new_items.length) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: add_new_items
      })
    })
    .then(res => res.json())
    .then(data => {
      total_api_success_done++;
    })
    .catch(err => {
      total_api_success_done++;
    });
  }

  // Update existing items
  if (update_existing_items.length) {
    const updates = {};

    update_existing_items.forEach(item => {
      updates[item.key] = item.quantity;
    });

    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        updates
      })
    })
    .then(res => res.json())
    .then(data => {
      total_api_success_done++;
    })
    .catch(err => {
      total_api_success_done++;
    });
  }

  // No API calls
  if (total_api_to_call === 0) {
    return;
  }

  const interval = setInterval(async () => {
    if (total_api_success_done >= total_api_to_call) {
      clearInterval(interval);
      const cart_d = await fetch('/cart.js')
        .then(res => res.json());
      if (!cart_d.items.length && __st.p == 'cart') {
        location.reload();
        return;
      }
      update_protection_total_price(cart_d);
      let is_there_pro_eligible = cart_d.items.find( item => item.properties['_warranty_pro_id'] );
      let is_prote_pro = cart_d.items.find( item => item.properties['_protection_product'] );
      let block_extended__warranty = document.querySelector( ".block-extended__warranty.custom" );
      let protection_product_checkbox = document.querySelector( '.protection_product_checkbox' );
      (is_there_pro_eligible && block_extended__warranty) ? block_extended__warranty.classList.remove('hide') : (block_extended__warranty && block_extended__warranty.classList.add('hide'));
      (protection_product_checkbox && !is_prote_pro)? protection_product_checkbox.checked = false: '';
       document.dispatchEvent(new CustomEvent("ajaxProduct:added", {detail: {}}));
    }

  }, 1000);
}
window.update_protection_products=(condition)=>{
  /* 2026-11-03 cart audit B-009 (Claude, W1a): aoam-cart-fix.js (a separate blocking asset since 2026-10-25) sets
     AOAM_CART_BUILD and replaces this writer. If that file failed to load, this old writer would run alone and can
     add a second cover line, so it does nothing instead. Rollback: delete the next line. */
  if (typeof window.AOAM_CART_BUILD === 'undefined') return;
  fetch('/cart.js')
  .then(response => response.json())
  .then(cart => {
    /* 2026-09-24 opt-in: aoam-cart-fix.liquid installs its own writer over this one at DOMContentLoaded, but this
       deferred file can call it first. Ask the same cart-scoped question here so it can never add cover the
       shopper did not choose. */
    if (condition == 'Update' && typeof window.aoamWarrOptIn === 'function' && !window.aoamWarrOptIn(cart)) { return; }
    /* 2026-09-25 price steps: this old writer only knows per-item cover. Once aoam-cart-fix.liquid is installed it
       replaces this function; before that, leave cover alone rather than add lines the new writer must undo. */
    if (condition == 'Update' && window.AOAM_WARR && window.AOAM_WARR.tiers && window.AOAM_WARR.tiers.length) { return; }
    if(localStorage.getItem('warranty_toogle_is_disable_by_user') == 'false' /* 2026-09-24 opt-in: a missing flag is OFF now */){
      let protection_product_checkbox = document.querySelector('.protection_product_checkbox'); 
      let is_there_pro_eligible = cart.items.find((item)=>item.properties['_warranty_pro_id']);
      if(protection_product_checkbox && !protection_product_checkbox.checked && is_there_pro_eligible){
        protection_product_checkbox.checked = true;
        protection_product_checkbox.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }
    }
    if(cart.items.length){
      let add_new_items = [];
      let update_existing_items = [];
      if(condition == 'Update'){
        cart.items.forEach((item)=>{
          if(item.properties._warranty_pro_id){
            let variant_id = item.properties._warranty_pro_id;
            let is_protection_exist = cart.items.find(cartItem => cartItem.variant_id == variant_id && cartItem.properties['Extended Warranty'] && cartItem.properties['Extended Warranty'] == item.properties['_warranty_pro_des']);
            if(is_protection_exist){
                if(is_protection_exist.quantity != item.quantity){
                  update_existing_items.push({
                  key: is_protection_exist.key,
                  quantity: item.quantity
                });
              }
            }else{
                add_new_items.push({
                id: variant_id,
                quantity: item.quantity,
                properties : {
                  'Extended Warranty': item.properties['_warranty_pro_des'],
                  '_protection_product': true,
                }
              });
            }
          }
        })
        cart.items.forEach((item)=>{
          if(item.properties['Extended Warranty']){
            let same_property_item = cart.items.find((cart_item)=>cart_item.properties['_warranty_pro_des'] && cart_item.properties['_warranty_pro_des'] == item.properties['Extended Warranty']);
            if(!same_property_item){
              update_existing_items.push({
                key: item.key,
                quantity: 0
              });
            }
          }
        })
        update_protection_content('Update',cart);
      }else{
        cart.items.forEach((item)=>{
          if(item.properties['_protection_product']){
            let variant_id = item.variant_id;
              update_existing_items.push({
              key: item.key,
              quantity: 0,
            });
          }
        })
        update_protection_content('remove',cart);
      }
      if(add_new_items.length || update_existing_items.length){
        update_products_API_calls(add_new_items,update_existing_items);
      }else{
        update_protection_total_price();
        updateCompareTotal();
        document.dispatchEvent(new CustomEvent("ajaxProduct:added", {detail: {}}));
      }
    }
  })
  .catch(error => {console.error('Cart Error:', error)});
}

function close_pro_pop(){
  let protection_popup_containor = document.querySelector(".protection_popup_containor");
  let protection_popup_containor_wrap = document.querySelector(".protection_popup_containor_wrap");
  let site_content = document.querySelector("#site_content");
  if(protection_popup_containor)protection_popup_containor.classList.add('hide');
  if(protection_popup_containor_wrap)protection_popup_containor_wrap.classList.remove('active');
  if(site_content)site_content.classList.remove('remove_sticky');
}

function open_custom_duty_popup(){
  let custom_duties_info_popup = document.querySelector(".custom-duties-info-popup");
  if(custom_duties_info_popup){
    let protection_popup_containor = custom_duties_info_popup.querySelector(".protection_popup_containor");
    custom_duties_info_popup.classList.add('active');
    protection_popup_containor.classList.remove("hide");
  }
}

function close_custom_duty_popup(){
  let custom_duties_info_popup = document.querySelector(".custom-duties-info-popup");
  if(custom_duties_info_popup){
    let protection_popup_containor = custom_duties_info_popup.querySelector(".protection_popup_containor");
    custom_duties_info_popup.classList.remove('active');
    protection_popup_containor.classList.add("hide");
  }
}



function open_protection_popup(){
  let protection_popup_containor = document.querySelector(".protection_popup_containor");
  let protection_popup_containor_wrap = document.querySelector(".protection_popup_containor_wrap");
  let site_content = document.querySelector("#site_content");
  if(protection_popup_containor)protection_popup_containor.classList.remove('hide');
  if(protection_popup_containor_wrap)protection_popup_containor_wrap.classList.add('active');
  if(site_content)site_content.classList.add('remove_sticky');
}
window.toggle_prot_pro = function (checkbox) {
  if(checkbox.checked){
    localStorage.setItem('warranty_toogle_is_disable_by_user',false);
    update_protection_products('Update');
  }else{
    localStorage.setItem('warranty_toogle_is_disable_by_user',true);
    update_protection_products('Remove');
  }
};

if(__st.p == 'cart'){
  if(localStorage.getItem('warranty_toogle_is_disable_by_user') == 'false' /* 2026-09-24 opt-in: a missing flag is OFF now */){
     let protection_product_checkbox = document.querySelector('.protection_product_checkbox'); 
     if(false /* 2026-09-24 opt-in: this ticked the warranty on every /cart load, before aoam-cart-fix could scope it (review finding). The row starts off now. */ && protection_product_checkbox && !protection_product_checkbox.checked){
      protection_product_checkbox.checked = true;
      protection_product_checkbox.dispatchEvent(new Event('change', { bubbles: true }));
     }
  }
  update_protection_total_price();
}

// 2026-09-28 cart-fix-l low-drawer-logic C121 C125: one polite, visually hidden status region for cart messages. Delete to roll back.
window.aoamCartAnnounce = window.aoamCartAnnounce || function (msg) {
    try {
        var el = document.getElementById('aoam-cart-announce');
        if (!el) { el = document.createElement('div'); el.id = 'aoam-cart-announce'; el.setAttribute('role', 'status'); el.setAttribute('aria-live', 'polite'); el.style.cssText = 'position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;border:0'; document.body.appendChild(el); }
        el.textContent = '';
        setTimeout(function () { el.textContent = String(msg); }, 60);
    } catch (e) {}
};
async function add_draw_accesories_pro(event,button) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    button.classList.add('loading');
    const variantId = button.dataset.variantId;
    let properties = {};

    if (button.dataset._related_product) {
        properties["_related_product"] = button.dataset._related_product;
    }

    if (button.dataset._warranty_pro_id) {
        properties["_warranty_pro_id"] = button.dataset._warranty_pro_id;
    }

    if (button.dataset._warranty_pro_des) {
        properties["_warranty_pro_des"] = button.dataset._warranty_pro_des;
    }

    if (button.dataset._warranty_pro_price) {
        properties["_warranty_pro_price"] = button.dataset._warranty_pro_price;
    }

    const payload = {
        items: [
            {
                id: variantId,
                quantity: 1,
                ...(Object.keys(properties).length > 0 && { properties })
            }
        ]
    };
    try {
        const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        });

        const data = await response.json();
        // 2026-09-28 cart-fix-l low-drawer-logic C125: a refused add (422 is valid JSON) no longer marks the button Added. Delete this if-block to roll back.
        if (!response.ok) { button.classList.remove('loading'); return { ok: false, description: (data && (data.description || data.message)) || '' }; }
        button.textContent = 'Added';
        button.disabled = true;
        update_protection_products('Update');

        // document.dispatchEvent( new CustomEvent("ajaxProduct:added", { detail: { product: response } }) );
        // 2026-11-03 cart audit B-011 (Claude, W1a): the writer fires the drawer rebuild itself, once, only after a real add (a refused add returned above).
        // Its one caller, window.aoamUpsellAdd in assets/aoam-upsell-card.js, no longer dispatches. Roll back: delete this line and restore the card's dispatch.
        try { document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { source: 'rail' } })); } catch (e) {}
    } catch (error) {
        console.error('Error adding product:', error);
    }
}

